function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFormgroupTiangel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 295.05 340.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2-2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SUPPLIER"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "48.48 229.15 96.46 256.86 96.47 312.26 48.48 339.96 0.5 312.26 0.5 256.85 48.48 229.15",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.6,312.38l48-27.82m0,0-.12-55.41m.15,55.41,47.54,27.59",
    style: {
      fill: "none",
      stroke: "#111",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.58,323.61a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,29.58,323.61Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.08,322.74a.17.17,0,0,1,0,.33.58.58,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,31.08,322.74Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.59,321.87c.16.09.16.24,0,.34a.66.66,0,0,1-.58,0c-.16-.1-.16-.25,0-.34A.66.66,0,0,1,32.59,321.87Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.09,321c.16.1.16.24,0,.34a.64.64,0,0,1-.57,0c-.16-.1-.16-.24,0-.34A.64.64,0,0,1,34.09,321Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6,320.14a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.6.6,0,0,1,35.6,320.14Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.57,323.61a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,26.57,323.61Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.07,322.74a.17.17,0,0,1,0,.33.58.58,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,28.07,322.74Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.58,321.87c.16.09.16.24,0,.34a.66.66,0,0,1-.58,0c-.16-.1-.16-.25,0-.34A.66.66,0,0,1,29.58,321.87Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.08,321c.16.1.16.24,0,.34a.64.64,0,0,1-.57,0c-.16-.1-.16-.24,0-.34A.64.64,0,0,1,31.08,321Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.3,
    cy: 320.3,
    rx: 0.41,
    ry: 0.23,
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.09,319.27a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.58.58,0,0,1,34.09,319.27Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.77,
    cy: 322.91,
    rx: 0.41,
    ry: 0.23,
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.57,321.87c.16.09.16.24,0,.34a.66.66,0,0,1-.58,0c-.16-.1-.16-.25,0-.34A.66.66,0,0,1,26.57,321.87Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.07,321c.16.1.16.24,0,.34a.64.64,0,0,1-.57,0c-.16-.1-.16-.24,0-.34A.64.64,0,0,1,28.07,321Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.58,320.14a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.6.6,0,0,1,29.58,320.14Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.08,319.27a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.58.58,0,0,1,31.08,319.27Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.59,318.4a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,32.59,318.4Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.56,321.87c.16.09.16.24,0,.34a.66.66,0,0,1-.58,0c-.16-.1-.16-.25,0-.34A.66.66,0,0,1,23.56,321.87Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.06,321c.16.1.16.24,0,.34a.64.64,0,0,1-.57,0c-.16-.1-.16-.24,0-.34A.64.64,0,0,1,25.06,321Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.28,
    cy: 320.3,
    rx: 0.41,
    ry: 0.23,
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.07,319.27a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.58.58,0,0,1,28.07,319.27Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.58,318.4a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,29.58,318.4Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.08,317.53a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,31.08,317.53Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.05,321c.16.1.16.24,0,.34a.64.64,0,0,1-.57,0c-.16-.1-.16-.24,0-.34A.64.64,0,0,1,22.05,321Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.56,320.14a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.6.6,0,0,1,23.56,320.14Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.06,319.27a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.58.58,0,0,1,25.06,319.27Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.57,318.4a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,26.57,318.4Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.07,317.53a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,28.07,317.53Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.58,316.66a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,29.58,316.66Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.55,320.14a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.6.6,0,0,1,20.55,320.14Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.05,319.27a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.58.58,0,0,1,22.05,319.27Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.56,318.4a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,23.56,318.4Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.77,
    cy: 317.7,
    rx: 0.41,
    ry: 0.23,
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.57,316.66a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,26.57,316.66Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.07,315.79a.17.17,0,0,1,0,.33.58.58,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,28.07,315.79Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,319.27a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.58.58,0,0,1,19,319.27Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.55,318.4a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,20.55,318.4Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.05,317.53a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,22.05,317.53Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.56,316.66a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,23.56,316.66Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.06,315.79a.17.17,0,0,1,0,.33.58.58,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,25.06,315.79Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.57,314.92a.17.17,0,0,1,0,.33.6.6,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,26.57,314.92Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,317.53a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,19,317.53Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.55,316.66a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,20.55,316.66Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.05,315.79a.17.17,0,0,1,0,.33.58.58,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,22.05,315.79Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.56,314.92a.17.17,0,0,1,0,.33.6.6,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,23.56,314.92Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.06,314.05c.16.1.16.24,0,.34a.64.64,0,0,1-.57,0c-.16-.1-.16-.24,0-.34A.64.64,0,0,1,25.06,314.05Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.53,314.91c.16.1.16.24,0,.34a.64.64,0,0,1-.57,0C19.8,315.15,20.38,314.82,20.53,314.91Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.46,314a.66.66,0,0,1,.58,0c.16.1.16.24,0,.34a.66.66,0,0,1-.58,0,.18.18,0,0,1,0-.34C21.62,314,21.31,314.14,21.46,314Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.54,313.18a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.58.58,0,0,1,23.54,313.18Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.51,302.9a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.18.18,0,0,1,0-.33A.66.66,0,0,1,29.51,302.9Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.73,
    cy: 302.2,
    rx: 0.41,
    ry: 0.23,
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.52,301.16a.17.17,0,0,1,0,.33.6.6,0,0,1-.58,0,.18.18,0,0,1,0-.33A.66.66,0,0,1,32.52,301.16Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,300.29c.16.09.16.24,0,.34a.64.64,0,0,1-.57,0c-.16-.1-.16-.25,0-.34A.64.64,0,0,1,34,300.29Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.53,299.42c.16.1.16.24,0,.34a.66.66,0,0,1-.58,0c-.16-.1-.16-.24,0-.34A.66.66,0,0,1,35.53,299.42Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37,298.56a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.58.58,0,0,1,37,298.56Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.54,297.69a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.6.6,0,0,1,38.54,297.69Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,300.29c.16.09.16.24,0,.34a.64.64,0,0,1-.57,0c-.16-.1-.16-.25,0-.34A.64.64,0,0,1,31,300.29Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.52,299.42c.16.1.16.24,0,.34a.66.66,0,0,1-.58,0,.18.18,0,0,1,0-.34A.66.66,0,0,1,32.52,299.42Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,298.56a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.58.58,0,0,1,34,298.56Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.53,297.69a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.6.6,0,0,1,35.53,297.69Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37,296.82a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,37,296.82Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.51,299.42c.16.1.16.24,0,.34a.66.66,0,0,1-.58,0,.18.18,0,0,1,0-.34A.66.66,0,0,1,29.51,299.42Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,298.56a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.58.58,0,0,1,31,298.56Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.52,297.69a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.18.18,0,0,1,0-.33A.6.6,0,0,1,32.52,297.69Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,296.82a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,34,296.82Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.24,
    cy: 296.11,
    rx: 0.41,
    ry: 0.23,
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.51,297.69a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.18.18,0,0,1,0-.33A.6.6,0,0,1,29.51,297.69Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,296.82a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,31,296.82Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.52,296a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.18.18,0,0,1,0-.33A.66.66,0,0,1,32.52,296Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,295.08a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33.64.64,0,0,1,.57,0Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.51,296a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.18.18,0,0,1,0-.33A.66.66,0,0,1,29.51,296Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,295.08a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,31,295.08Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.15,322.76a.17.17,0,0,1,0,.33.6.6,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,46.15,322.76Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.65,321.89c.16.1.16.24,0,.34a.64.64,0,0,1-.57,0c-.16-.1-.16-.24,0-.34A.64.64,0,0,1,47.65,321.89Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.16,321c.16.1.16.25,0,.34a.66.66,0,0,1-.58,0c-.16-.09-.16-.24,0-.34A.66.66,0,0,1,49.16,321Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.66,320.16a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.58.58,0,0,1,50.66,320.16Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.17,319.29a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,52.17,319.29Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.39,
    cy: 318.58,
    rx: 0.41,
    ry: 0.23,
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.18,317.55a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,55.18,317.55Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.68,316.68a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,56.68,316.68Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2,314.07c.16.1.16.24,0,.34a.66.66,0,0,1-.58,0c-.16-.1-.16-.24,0-.34A.66.66,0,0,1,61.2,314.07Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7,313.2c.16.1.16.25,0,.34a.64.64,0,0,1-.57,0c-.16-.09-.16-.24,0-.34A.64.64,0,0,1,62.7,313.2Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.21,312.34a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.6.6,0,0,1,64.21,312.34Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.71,311.47a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,65.71,311.47Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.22,310.6a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,67.22,310.6Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.72,309.73a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,68.72,309.73Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.9,
    cy: 315.98,
    rx: 0.41,
    ry: 0.24,
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.69,314.94a.17.17,0,0,1,0,.33.58.58,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,59.69,314.94Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.64,321.89c.16.1.16.24,0,.34a.64.64,0,0,1-.57,0c-.16-.1-.16-.24,0-.34A.64.64,0,0,1,44.64,321.89Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.15,321c.16.1.16.25,0,.34a.66.66,0,0,1-.58,0c-.16-.09-.16-.24,0-.34A.66.66,0,0,1,46.15,321Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.37,
    cy: 320.32,
    rx: 0.41,
    ry: 0.23,
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.87,
    cy: 319.45,
    rx: 0.41,
    ry: 0.24,
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.38,
    cy: 318.58,
    rx: 0.41,
    ry: 0.23,
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.88,
    cy: 317.72,
    rx: 0.41,
    ry: 0.23,
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.67,316.68a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,53.67,316.68Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.18,315.81a.17.17,0,0,1,0,.33.6.6,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,55.18,315.81Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.4,
    cy: 313.37,
    rx: 0.41,
    ry: 0.23,
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2,312.34a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.6.6,0,0,1,61.2,312.34Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7,311.47a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,62.7,311.47Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.21,310.6a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,64.21,310.6Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.71,309.73a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,65.71,309.73Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.22,308.86a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,67.22,308.86Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.68,314.94a.17.17,0,0,1,0,.33.58.58,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,56.68,314.94Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.19,314.07c.16.1.16.24,0,.34a.66.66,0,0,1-.58,0c-.16-.1-.16-.24,0-.34A.66.66,0,0,1,58.19,314.07Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.14,321c.16.1.16.25,0,.34a.66.66,0,0,1-.58,0c-.16-.09-.16-.24,0-.34A.66.66,0,0,1,43.14,321Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.64,320.16a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.58.58,0,0,1,44.64,320.16Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.15,319.29a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,46.15,319.29Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.65,318.42a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,47.65,318.42Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.16,317.55a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,49.16,317.55Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.66,316.68a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,50.66,316.68Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.17,315.81a.17.17,0,0,1,0,.33.6.6,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,52.17,315.81Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.67,314.94a.17.17,0,0,1,0,.33.58.58,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,53.67,314.94Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.18,314.07c.16.1.16.24,0,.34a.66.66,0,0,1-.58,0c-.16-.1-.16-.24,0-.34A.66.66,0,0,1,55.18,314.07Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.69,311.47a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,59.69,311.47Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2,310.6a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,61.2,310.6Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7,309.73a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,62.7,309.73Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.21,308.86a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,64.21,308.86Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.71,308a.17.17,0,0,1,0,.33.58.58,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,65.71,308Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.39,
    cy: 313.37,
    rx: 0.41,
    ry: 0.23,
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.19,312.34a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.6.6,0,0,1,58.19,312.34Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.63,320.16a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.58.58,0,0,1,41.63,320.16Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.85,
    cy: 319.45,
    rx: 0.41,
    ry: 0.24,
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.64,318.42a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,44.64,318.42Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.15,317.55a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,46.15,317.55Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.65,316.68a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,47.65,316.68Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.16,315.81a.17.17,0,0,1,0,.33.6.6,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,49.16,315.81Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.66,314.94a.17.17,0,0,1,0,.33.58.58,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,50.66,314.94Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.17,314.07c.16.1.16.24,0,.34a.66.66,0,0,1-.58,0c-.16-.1-.16-.24,0-.34A.66.66,0,0,1,52.17,314.07Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.68,311.47a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,56.68,311.47Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.19,310.6a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,58.19,310.6Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.69,309.73a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,59.69,309.73Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2,308.86a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,61.2,308.86Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7,308a.17.17,0,0,1,0,.33.58.58,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,62.7,308Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.21,307.12c.16.09.16.24,0,.34a.66.66,0,0,1-.58,0c-.16-.1-.16-.25,0-.34A.66.66,0,0,1,64.21,307.12Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.67,313.2c.16.1.16.25,0,.34a.64.64,0,0,1-.57,0c-.16-.09-.16-.24,0-.34A.64.64,0,0,1,53.67,313.2Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.89,
    cy: 312.5,
    rx: 0.41,
    ry: 0.23,
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.84,
    cy: 319.45,
    rx: 0.41,
    ry: 0.23,
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.63,318.42a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,41.63,318.42Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.14,317.55a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,43.14,317.55Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.64,316.68a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,44.64,316.68Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.15,315.81a.17.17,0,0,1,0,.33.6.6,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,46.15,315.81Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.37,
    cy: 315.11,
    rx: 0.41,
    ry: 0.23,
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.87,
    cy: 314.24,
    rx: 0.41,
    ry: 0.23,
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.66,313.21a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.58.58,0,0,1,50.66,313.21Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.18,310.6a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,55.18,310.6Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.68,309.73a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,56.68,309.73Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.19,308.86a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,58.19,308.86Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.69,308a.17.17,0,0,1,0,.33.58.58,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,59.69,308Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2,307.12c.16.09.16.24,0,.34a.66.66,0,0,1-.58,0c-.16-.1-.16-.25,0-.34A.66.66,0,0,1,61.2,307.12Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7,306.25c.16.1.16.24,0,.34a.64.64,0,0,1-.57,0c-.16-.1-.16-.24,0-.34A.64.64,0,0,1,62.7,306.25Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.17,312.34a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.6.6,0,0,1,52.17,312.34Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.67,311.47a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,53.67,311.47Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.53,319.28a.64.64,0,0,1,.57,0,.18.18,0,0,1,0,.33.66.66,0,0,1-.58,0A.17.17,0,0,1,36.53,319.28Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.61,318.41a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,38.61,318.41Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.12,317.54a.18.18,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,40.12,317.54Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.33,
    cy: 316.84,
    rx: 0.41,
    ry: 0.23,
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.13,315.8a.18.18,0,0,1,0,.33.6.6,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,43.13,315.8Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.63,314.93c.16.1.16.24,0,.34a.64.64,0,0,1-.57,0c-.16-.1-.16-.24,0-.34A.64.64,0,0,1,44.63,314.93Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.14,314.06a.18.18,0,0,1,0,.34.66.66,0,0,1-.58,0c-.16-.09-.16-.24,0-.34A.66.66,0,0,1,46.14,314.06Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.35,
    cy: 313.36,
    rx: 0.41,
    ry: 0.23,
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.86,
    cy: 312.49,
    rx: 0.41,
    ry: 0.24,
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.66,309.72a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.18.18,0,0,1,0-.33A.66.66,0,0,1,53.66,309.72Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.16,308.85a.17.17,0,0,1,0,.33.58.58,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,55.16,308.85Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.67,308c.16.09.16.24,0,.34a.66.66,0,0,1-.58,0,.18.18,0,0,1,0-.34A.66.66,0,0,1,56.67,308Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.17,307.11c.16.1.16.24,0,.34a.64.64,0,0,1-.57,0c-.16-.1-.16-.24,0-.34A.64.64,0,0,1,58.17,307.11Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.68,306.25a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.18.18,0,0,1,0-.33A.6.6,0,0,1,59.68,306.25Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.18,305.38a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.58.58,0,0,1,61.18,305.38Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.36,
    cy: 311.62,
    rx: 0.41,
    ry: 0.23,
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.87,
    cy: 310.76,
    rx: 0.41,
    ry: 0.23,
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,318.41a.66.66,0,0,1,.58,0,.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0A.18.18,0,0,1,35,318.41Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.11,317.54a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,37.11,317.54Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.61,316.67a.17.17,0,0,1,0,.33.58.58,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,38.61,316.67Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.12,315.8a.18.18,0,0,1,0,.33.6.6,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,40.12,315.8Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.62,314.93c.16.1.16.24,0,.34a.64.64,0,0,1-.57,0c-.16-.1-.16-.24,0-.34A.64.64,0,0,1,41.62,314.93Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.13,314.06a.18.18,0,0,1,0,.34.66.66,0,0,1-.58,0c-.16-.09-.16-.24,0-.34A.66.66,0,0,1,43.13,314.06Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.63,313.2a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.58.58,0,0,1,44.63,313.2Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.14,312.33a.18.18,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,46.14,312.33Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.65,309.72a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.18.18,0,0,1,0-.33A.66.66,0,0,1,50.65,309.72Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.87,
    cy: 309.02,
    rx: 0.41,
    ry: 0.24,
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.66,308c.16.09.16.24,0,.34a.66.66,0,0,1-.58,0,.18.18,0,0,1,0-.34A.66.66,0,0,1,53.66,308Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.16,307.11c.16.1.16.24,0,.34a.64.64,0,0,1-.57,0c-.16-.1-.16-.24,0-.34A.64.64,0,0,1,55.16,307.11Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.38,
    cy: 306.41,
    rx: 0.41,
    ry: 0.23,
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.17,305.38a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.58.58,0,0,1,58.17,305.38Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.68,304.51a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.18.18,0,0,1,0-.33A.66.66,0,0,1,59.68,304.51Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.64,311.46a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.18.18,0,0,1,0-.33A.66.66,0,0,1,47.64,311.46Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.15,310.59a.18.18,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,49.15,310.59Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.52,317.54a.64.64,0,0,1,.57,0,.18.18,0,0,1,0,.33.63.63,0,0,1-.58,0A.17.17,0,0,1,33.52,317.54Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6,316.67a.17.17,0,0,1,0,.33.58.58,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,35.6,316.67Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.11,315.8a.17.17,0,0,1,0,.33.6.6,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,37.11,315.8Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.61,314.93c.16.1.16.24,0,.34a.64.64,0,0,1-.57,0c-.16-.1-.16-.24,0-.34A.64.64,0,0,1,38.61,314.93Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.12,314.06a.18.18,0,0,1,0,.34.66.66,0,0,1-.58,0c-.16-.09-.16-.24,0-.34A.66.66,0,0,1,40.12,314.06Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.62,313.2a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.58.58,0,0,1,41.62,313.2Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.84,
    cy: 312.49,
    rx: 0.41,
    ry: 0.24,
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.63,311.46a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,44.63,311.46Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.86,
    cy: 309.02,
    rx: 0.41,
    ry: 0.23,
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.65,308c.16.09.16.24,0,.34a.66.66,0,0,1-.58,0,.18.18,0,0,1,0-.34A.66.66,0,0,1,50.65,308Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.16,307.11a.18.18,0,0,1,0,.34.66.66,0,0,1-.58,0c-.16-.1-.16-.24,0-.34A.66.66,0,0,1,52.16,307.11Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.66,306.25a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.18.18,0,0,1,0-.33A.6.6,0,0,1,53.66,306.25Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.16,305.38a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.58.58,0,0,1,55.16,305.38Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.67,304.51a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.18.18,0,0,1,0-.33A.66.66,0,0,1,56.67,304.51Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.17,303.64a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,58.17,303.64Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.14,310.59a.18.18,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,46.14,310.59Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.64,309.72a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.18.18,0,0,1,0-.33A.66.66,0,0,1,47.64,309.72Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,316.67a.66.66,0,0,1,.58,0,.17.17,0,0,1,0,.33.6.6,0,0,1-.58,0A.18.18,0,0,1,32,316.67Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1,315.8a.17.17,0,0,1,0,.33.6.6,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,34.1,315.8Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6,314.93c.16.1.16.24,0,.34a.64.64,0,0,1-.57,0c-.16-.1-.16-.24,0-.34A.64.64,0,0,1,35.6,314.93Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.82,
    cy: 314.23,
    rx: 0.41,
    ry: 0.23,
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.61,313.2a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.58.58,0,0,1,38.61,313.2Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.83,
    cy: 312.49,
    rx: 0.41,
    ry: 0.23,
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.33,
    cy: 311.62,
    rx: 0.41,
    ry: 0.23,
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.13,310.59a.18.18,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,43.13,310.59Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.64,308c.16.09.16.24,0,.34a.66.66,0,0,1-.58,0,.18.18,0,0,1,0-.34A.66.66,0,0,1,47.64,308Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.86,
    cy: 307.28,
    rx: 0.41,
    ry: 0.23,
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.36,
    cy: 306.41,
    rx: 0.41,
    ry: 0.23,
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.16,305.38a.18.18,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.6.6,0,0,1,52.16,305.38Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.66,304.51a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.18.18,0,0,1,0-.33A.66.66,0,0,1,53.66,304.51Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.16,303.64a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,55.16,303.64Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.67,302.77a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.18.18,0,0,1,0-.33A.66.66,0,0,1,56.67,302.77Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.63,309.72a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,44.63,309.72Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.14,308.85a.18.18,0,0,1,0,.33.6.6,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,46.14,308.85Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.51,315.8a.64.64,0,0,1,.57,0,.18.18,0,0,1,0,.34.66.66,0,0,1-.58,0C30.35,316,30.35,315.9,30.51,315.8Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.3,
    cy: 315.1,
    rx: 0.41,
    ry: 0.23,
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1,314.06c.16.1.16.25,0,.34a.66.66,0,0,1-.58,0c-.16-.09-.16-.24,0-.34A.66.66,0,0,1,34.1,314.06Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6,313.2a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.58.58,0,0,1,35.6,313.2Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.11,312.33a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,37.11,312.33Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.61,311.46a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,38.61,311.46Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.12,310.59a.18.18,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,40.12,310.59Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.62,309.72a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,41.62,309.72Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.13,308.85a.18.18,0,0,1,0,.33.6.6,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,43.13,308.85Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.64,306.25a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.18.18,0,0,1,0-.33A.6.6,0,0,1,47.64,306.25Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.15,305.38a.18.18,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.6.6,0,0,1,49.15,305.38Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.65,304.51a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.18.18,0,0,1,0-.33A.66.66,0,0,1,50.65,304.51Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.16,303.64a.18.18,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,52.16,303.64Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.66,302.77a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.18.18,0,0,1,0-.33A.66.66,0,0,1,53.66,302.77Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.88,
    cy: 302.07,
    rx: 0.41,
    ry: 0.23,
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.63,308c.16.09.16.24,0,.34a.64.64,0,0,1-.57,0c-.16-.1-.16-.25,0-.34A.64.64,0,0,1,44.63,308Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.85,
    cy: 307.28,
    rx: 0.41,
    ry: 0.23,
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29,314.93a.66.66,0,0,1,.58,0c.16.1.16.24,0,.34a.64.64,0,0,1-.57,0A.18.18,0,0,1,29,314.93Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.09,314.06c.16.1.16.25,0,.34a.66.66,0,0,1-.58,0c-.16-.09-.16-.24,0-.34A.66.66,0,0,1,31.09,314.06Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.59,313.2a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.58.58,0,0,1,32.59,313.2Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.81,
    cy: 312.49,
    rx: 0.41,
    ry: 0.23,
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6,311.46a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,35.6,311.46Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.11,310.59a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,37.11,310.59Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.61,309.72a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,38.61,309.72Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.12,308.85a.18.18,0,0,1,0,.33.6.6,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,40.12,308.85Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.62,308c.16.09.16.24,0,.34a.64.64,0,0,1-.57,0c-.16-.1-.16-.25,0-.34A.64.64,0,0,1,41.62,308Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.13,307.11a.18.18,0,0,1,0,.34.66.66,0,0,1-.58,0c-.16-.1-.16-.24,0-.34A.66.66,0,0,1,43.13,307.11Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.64,304.51a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.18.18,0,0,1,0-.33A.66.66,0,0,1,47.64,304.51Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.15,303.64a.18.18,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,49.15,303.64Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.65,302.77a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.18.18,0,0,1,0-.33A.66.66,0,0,1,50.65,302.77Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.87,
    cy: 302.07,
    rx: 0.41,
    ry: 0.23,
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.66,301a.17.17,0,0,1,0,.33.6.6,0,0,1-.58,0,.18.18,0,0,1,0-.33A.66.66,0,0,1,53.66,301Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 44.34,
    cy: 306.41,
    rx: 0.41,
    ry: 0.23,
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.14,305.38a.18.18,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.6.6,0,0,1,46.14,305.38Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5,314.07a.58.58,0,0,1,.57,0,.18.18,0,0,1,0,.33.66.66,0,0,1-.58,0A.17.17,0,0,1,27.5,314.07Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.58,313.2a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.58.58,0,0,1,29.58,313.2Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.09,312.33a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,31.09,312.33Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.59,311.46a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,32.59,311.46Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1,310.59a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,34.1,310.59Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6,309.72a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,35.6,309.72Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.11,308.85a.17.17,0,0,1,0,.33.6.6,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,37.11,308.85Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.61,308c.16.09.16.24,0,.34a.64.64,0,0,1-.57,0c-.16-.1-.16-.25,0-.34A.64.64,0,0,1,38.61,308Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.83,
    cy: 307.28,
    rx: 0.41,
    ry: 0.23,
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.33,
    cy: 306.41,
    rx: 0.41,
    ry: 0.23,
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.13,305.38a.18.18,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.6.6,0,0,1,43.13,305.38Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.35,
    cy: 302.94,
    rx: 0.41,
    ry: 0.23,
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.86,
    cy: 302.07,
    rx: 0.41,
    ry: 0.23,
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.36,
    cy: 301.2,
    rx: 0.41,
    ry: 0.23,
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.63,304.51a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,44.63,304.51Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.14,303.64a.18.18,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,46.14,303.64Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,313.2a.63.63,0,0,1,.58,0,.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0A.18.18,0,0,1,26,313.2Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.08,312.33a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,28.08,312.33Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.58,311.46a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,29.58,311.46Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.09,310.59a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,31.09,310.59Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.3,
    cy: 309.89,
    rx: 0.41,
    ry: 0.23,
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1,308.85a.17.17,0,0,1,0,.33.6.6,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,34.1,308.85Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6,308c.16.09.16.24,0,.34a.64.64,0,0,1-.57,0c-.16-.1-.16-.25,0-.34A.64.64,0,0,1,35.6,308Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.11,307.11c.16.1.16.24,0,.34a.66.66,0,0,1-.58,0c-.16-.1-.16-.24,0-.34A.66.66,0,0,1,37.11,307.11Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.61,306.25a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.58.58,0,0,1,38.61,306.25Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.12,305.38a.18.18,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.6.6,0,0,1,40.12,305.38Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.62,304.51a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,41.62,304.51Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.13,303.64a.18.18,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,43.13,303.64Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.64,301a.17.17,0,0,1,0,.33.6.6,0,0,1-.58,0,.18.18,0,0,1,0-.33A.66.66,0,0,1,47.64,301Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.15,300.16a.18.18,0,0,1,0,.34.66.66,0,0,1-.58,0c-.16-.1-.16-.25,0-.34a.66.66,0,0,1,.58,0Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.63,302.77a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,44.63,302.77Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.85,
    cy: 302.07,
    rx: 0.41,
    ry: 0.23,
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.48,312.32a.64.64,0,0,1,.57,0,.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0A.17.17,0,0,1,24.48,312.32Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.56,311.45a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,26.56,311.45Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.06,310.58a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,28.06,310.58Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.57,309.71a.17.17,0,0,1,0,.33.6.6,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,29.57,309.71Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.07,308.84a.17.17,0,0,1,0,.33.58.58,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,31.07,308.84Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.29,
    cy: 308.14,
    rx: 0.41,
    ry: 0.23,
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.08,307.1c.16.1.16.25,0,.34a.64.64,0,0,1-.57,0c-.16-.09-.16-.24,0-.34A.64.64,0,0,1,34.08,307.1Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.59,306.24a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.6.6,0,0,1,35.59,306.24Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.09,305.37a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,37.09,305.37Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6,304.5a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,38.6,304.5Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1,303.63a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,40.1,303.63Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.61,302.76a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,41.61,302.76Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.11,301.89a.17.17,0,0,1,0,.33.58.58,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,43.11,301.89Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.62,301c.16.09.16.24,0,.34a.66.66,0,0,1-.58,0c-.16-.1-.16-.25,0-.34A.66.66,0,0,1,44.62,301Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.83,
    cy: 300.32,
    rx: 0.41,
    ry: 0.23,
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.05,310.58a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,25.05,310.58Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.56,309.71a.17.17,0,0,1,0,.33.6.6,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,26.56,309.71Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.57,308c.16.1.16.24,0,.34a.66.66,0,0,1-.58,0c-.16-.1-.16-.24,0-.34A.66.66,0,0,1,29.57,308Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.07,307.1c.16.1.16.25,0,.34a.64.64,0,0,1-.57,0c-.16-.09-.16-.24,0-.34A.64.64,0,0,1,31.07,307.1Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.58,306.24a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.6.6,0,0,1,32.58,306.24Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.8,
    cy: 305.53,
    rx: 0.41,
    ry: 0.23,
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.59,304.5a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,35.59,304.5Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.09,303.63a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,37.09,303.63Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6,302.76a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,38.6,302.76Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1,301.89a.17.17,0,0,1,0,.33.58.58,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,40.1,301.89Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.61,301c.16.09.16.24,0,.34a.66.66,0,0,1-.58,0c-.16-.1-.16-.25,0-.34A.66.66,0,0,1,41.61,301Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.11,300.15c.16.1.16.24,0,.34a.64.64,0,0,1-.57,0c-.16-.1-.16-.24,0-.34A.64.64,0,0,1,43.11,300.15Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 44.33,
    cy: 299.45,
    rx: 0.41,
    ry: 0.23,
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.57,306.24a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.6.6,0,0,1,29.57,306.24Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.07,305.37a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,31.07,305.37Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.58,304.5a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,32.58,304.5Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.08,303.63a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,34.08,303.63Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.59,302.76a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,35.59,302.76Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.81,
    cy: 302.06,
    rx: 0.41,
    ry: 0.23,
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6,301c.16.09.16.24,0,.34a.66.66,0,0,1-.58,0c-.16-.1-.16-.25,0-.34A.66.66,0,0,1,38.6,301Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.82,
    cy: 300.32,
    rx: 0.41,
    ry: 0.23,
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.32,
    cy: 299.45,
    rx: 0.41,
    ry: 0.23,
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.11,298.42a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33.58.58,0,0,1,.57,0C43.27,298.51,43,298.32,43.11,298.42Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.57,304.5a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,29.57,304.5Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.07,303.63a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,31.07,303.63Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.29,
    cy: 302.93,
    rx: 0.41,
    ry: 0.23,
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.08,301.89a.17.17,0,0,1,0,.33.58.58,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,34.08,301.89Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.59,301c.16.09.16.24,0,.34a.66.66,0,0,1-.58,0c-.16-.1-.16-.25,0-.34A.66.66,0,0,1,35.59,301Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.09,300.15c.16.1.16.24,0,.34a.64.64,0,0,1-.57,0c-.16-.1-.16-.24,0-.34A.64.64,0,0,1,37.09,300.15Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6,299.29a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.6.6,0,0,1,38.6,299.29Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1,298.42a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.58.58,0,0,1,40.1,298.42Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.61,297.88a.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33C41.19,297.46,41.77,297.79,41.61,297.88Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.24,308.87a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,70.24,308.87Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.74,308a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,71.74,308Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.25,307.13a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,73.25,307.13Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.75,306.26a.17.17,0,0,1,0,.33.58.58,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,74.75,306.26Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 75.97,
    cy: 305.56,
    rx: 0.41,
    ry: 0.23,
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.76,304.52c.16.1.16.24,0,.34a.64.64,0,0,1-.57,0c-.16-.1-.16-.24,0-.34A.64.64,0,0,1,77.76,304.52Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.16,308a.64.64,0,0,1,.57,0,.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0A.17.17,0,0,1,68.16,308Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 69.95,
    cy: 307.3,
    rx: 0.41,
    ry: 0.23,
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.74,306.26a.17.17,0,0,1,0,.33.58.58,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,71.74,306.26Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.25,305.39a.17.17,0,0,1,0,.33.6.6,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,73.25,305.39Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.75,304.52c.16.1.16.24,0,.34a.64.64,0,0,1-.57,0c-.16-.1-.16-.24,0-.34A.64.64,0,0,1,74.75,304.52Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.26,304a.66.66,0,0,1-.58,0c-.16-.09-.16-.24,0-.34S76.42,303.9,76.26,304Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.65,307.13a.66.66,0,0,1,.58,0,.17.17,0,0,1,0,.33.6.6,0,0,1-.58,0A.17.17,0,0,1,66.65,307.13Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.73,306.26a.17.17,0,0,1,0,.33.58.58,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,68.73,306.26Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.24,305.39a.17.17,0,0,1,0,.33.6.6,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,70.24,305.39Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.74,304.52c.16.1.16.24,0,.34a.64.64,0,0,1-.57,0c-.16-.1-.16-.24,0-.34A.64.64,0,0,1,71.74,304.52Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.25,303.65c.16.1.16.25,0,.34a.66.66,0,0,1-.58,0c-.16-.09-.16-.24,0-.34A.66.66,0,0,1,73.25,303.65Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.15,306.26a.64.64,0,0,1,.57,0,.17.17,0,0,1,0,.33.58.58,0,0,1-.57,0A.17.17,0,0,1,65.15,306.26Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.23,305.39a.17.17,0,0,1,0,.33.6.6,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,67.23,305.39Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.73,304.52c.16.1.16.24,0,.34a.64.64,0,0,1-.57,0c-.16-.1-.16-.24,0-.34A.64.64,0,0,1,68.73,304.52Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.24,303.65c.16.1.16.25,0,.34a.66.66,0,0,1-.58,0c-.16-.09-.16-.24,0-.34A.66.66,0,0,1,70.24,303.65Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.74,302.79a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.58.58,0,0,1,71.74,302.79Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.64,305.39a.66.66,0,0,1,.58,0c.16.09.16.24,0,.34a.66.66,0,0,1-.58,0C63.48,305.63,63.48,305.49,63.64,305.39Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.72,304.52c.16.1.16.24,0,.34a.64.64,0,0,1-.57,0c-.16-.1-.16-.24,0-.34A.64.64,0,0,1,65.72,304.52Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.23,303.65c.16.1.16.25,0,.34a.66.66,0,0,1-.58,0c-.16-.09-.16-.24,0-.34A.66.66,0,0,1,67.23,303.65Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.73,302.79a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.58.58,0,0,1,68.73,302.79Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.24,301.92a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,70.24,301.92Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.12,304.52a.6.6,0,0,1,.58,0,.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0A.18.18,0,0,1,62.12,304.52Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.21,303.65a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.6.6,0,0,1,64.21,303.65Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.71,302.78a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,65.71,302.78Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.22,301.91a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,67.22,301.91Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.62,303.65a.61.61,0,0,1,.57,0,.18.18,0,0,1,0,.33.66.66,0,0,1-.58,0A.17.17,0,0,1,60.62,303.65Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7,302.78a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,62.7,302.78Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.21,301.91a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,64.21,301.91Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.11,302.78a.66.66,0,0,1,.58,0,.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0A.18.18,0,0,1,59.11,302.78Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2,301.91a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,61.2,301.91Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7,301a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,62.7,301Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.61,301.91a.64.64,0,0,1,.57,0,.18.18,0,0,1,0,.33.66.66,0,0,1-.58,0A.17.17,0,0,1,57.61,301.91Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.69,301a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,59.69,301Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.68,301a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.18.18,0,0,1,0-.33A.66.66,0,0,1,56.68,301Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7,321.85a.17.17,0,0,1,0,.33.6.6,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,56.7,321.85Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2,321c.16.09.16.24,0,.34a.64.64,0,0,1-.57,0c-.16-.1-.16-.25,0-.34A.64.64,0,0,1,58.2,321Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.71,320.11c.16.1.16.24,0,.34a.66.66,0,0,1-.58,0c-.16-.1-.16-.24,0-.34A.66.66,0,0,1,59.71,320.11Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.22,317.51a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,64.22,317.51Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.73,316.64a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,65.73,316.64Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.23,315.77a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,67.23,315.77Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.74,314.9a.17.17,0,0,1,0,.33.6.6,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,68.74,314.9Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.24,314a.17.17,0,0,1,0,.33.58.58,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,70.24,314Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.75,313.16c.16.1.16.24,0,.34a.66.66,0,0,1-.58,0c-.16-.1-.16-.24,0-.34A.66.66,0,0,1,71.75,313.16Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.25,312.29c.16.1.16.25,0,.34a.64.64,0,0,1-.57,0c-.16-.09-.16-.24,0-.34A.64.64,0,0,1,73.25,312.29Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.21,319.25a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.58.58,0,0,1,61.21,319.25Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.72,318.38a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.6.6,0,0,1,62.72,318.38Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.69,321.85a.17.17,0,0,1,0,.33.6.6,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,53.69,321.85Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.19,321c.16.09.16.24,0,.34a.64.64,0,0,1-.57,0c-.16-.1-.16-.25,0-.34A.64.64,0,0,1,55.19,321Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7,320.11c.16.1.16.24,0,.34a.66.66,0,0,1-.58,0c-.16-.1-.16-.24,0-.34A.66.66,0,0,1,56.7,320.11Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2,319.25a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.58.58,0,0,1,58.2,319.25Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.72,316.64a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,62.72,316.64Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.22,315.77a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,64.22,315.77Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 65.44,
    cy: 315.07,
    rx: 0.41,
    ry: 0.24,
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.23,314a.17.17,0,0,1,0,.33.58.58,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,67.23,314Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.74,313.16c.16.1.16.24,0,.34a.66.66,0,0,1-.58,0c-.16-.1-.16-.24,0-.34A.66.66,0,0,1,68.74,313.16Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.24,312.29c.16.1.16.25,0,.34a.64.64,0,0,1-.57,0c-.16-.09-.16-.24,0-.34A.64.64,0,0,1,70.24,312.29Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.46,
    cy: 311.59,
    rx: 0.41,
    ry: 0.24,
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.71,318.38a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.6.6,0,0,1,59.71,318.38Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.21,317.51a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,61.21,317.51Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.17,322.72a.17.17,0,0,1,0,.33.58.58,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,49.17,322.72Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.68,321.85a.17.17,0,0,1,0,.33.6.6,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,50.68,321.85Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.18,321c.16.09.16.24,0,.34a.64.64,0,0,1-.57,0c-.16-.1-.16-.25,0-.34A.64.64,0,0,1,52.18,321Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.69,320.11c.16.1.16.24,0,.34a.66.66,0,0,1-.58,0c-.16-.1-.16-.24,0-.34A.66.66,0,0,1,53.69,320.11Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.91,
    cy: 319.41,
    rx: 0.41,
    ry: 0.23,
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7,318.38a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.6.6,0,0,1,56.7,318.38Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2,317.51a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,58.2,317.51Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.72,314.9a.17.17,0,0,1,0,.33.6.6,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,62.72,314.9Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.22,314a.17.17,0,0,1,0,.33.58.58,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,64.22,314Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.73,313.16c.16.1.16.24,0,.34a.66.66,0,0,1-.58,0c-.16-.1-.16-.24,0-.34A.66.66,0,0,1,65.73,313.16Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.23,312.29c.16.1.16.25,0,.34a.64.64,0,0,1-.57,0c-.16-.09-.16-.24,0-.34A.64.64,0,0,1,67.23,312.29Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 68.45,
    cy: 311.59,
    rx: 0.41,
    ry: 0.23,
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.24,310.56a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,70.24,310.56Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.71,316.64a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.17.17,0,0,1,0-.33A.66.66,0,0,1,59.71,316.64Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.21,315.77a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,61.21,315.77Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.19,311.43a.66.66,0,0,1,.58,0c.16.1.16.24,0,.34a.66.66,0,0,1-.58,0C74,311.68,74,311.53,74.19,311.43Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.27,310.56c.16.1.16.24,0,.34a.64.64,0,0,1-.57,0c-.16-.1-.16-.24,0-.34A.64.64,0,0,1,76.27,310.56Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.78,309.7a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.18.18,0,0,1,0-.33A.6.6,0,0,1,77.78,309.7Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.28,308.83a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.58.58,0,0,1,79.28,308.83Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.69,310.57a.61.61,0,0,1,.57,0c.16.1.16.25,0,.34a.64.64,0,0,1-.57,0A.17.17,0,0,1,72.69,310.57Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 74.48,
    cy: 309.86,
    rx: 0.41,
    ry: 0.23,
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.27,308.83a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.58.58,0,0,1,76.27,308.83Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.78,308a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.18.18,0,0,1,0-.33A.66.66,0,0,1,77.78,308Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.28,307.09a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,79.28,307.09Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.18,309.7a.6.6,0,0,1,.58,0,.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0A.17.17,0,0,1,71.18,309.7Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.26,308.83a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.58.58,0,0,1,73.26,308.83Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.77,308a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.18.18,0,0,1,0-.33A.66.66,0,0,1,74.77,308Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.27,307.09a.17.17,0,0,1,0,.33.64.64,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,76.27,307.09Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.78,306.22a.17.17,0,0,1,0,.33.66.66,0,0,1-.58,0,.18.18,0,0,1,0-.33A.66.66,0,0,1,77.78,306.22Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.28,305.35a.17.17,0,0,1,0,.33.58.58,0,0,1-.57,0,.17.17,0,0,1,0-.33A.64.64,0,0,1,79.28,305.35Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.32,294.94l-.07-14.46,47.34-.7.08,24.85a.76.76,0,0,1-.45.78L54.69,318.35a3,3,0,0,1-2.67-.1L31,306.1C30.51,305.84,30.29,295.26,30.32,294.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.51,318.76a3.17,3.17,0,0,1-1.56-.39L30.9,306.22c-.57-.32-.72-11-.72-11.28h0l-.08-14.6,47.63-.71.08,25a.9.9,0,0,1-.52.91L54.76,318.47A2.57,2.57,0,0,1,53.51,318.76ZM30.39,280.62,30.47,295h0c0,.51.23,10.67.59,11l21,12.14a2.78,2.78,0,0,0,2.52.1l22.54-12.93c.28-.17.42-.39.37-.63l-.08-24.73Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "53.39 294.44 53.39 318.62 54.69 318.35 77.67 305.07 77.53 280.86 54.33 294.32 53.39 294.44",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.61,293.49l22.53-12.93c.68-.4.59-1.09-.2-1.54l-21-12.15a3,3,0,0,0-2.67-.1L30.7,279.71c-.68.4-.6,1.09.2,1.54l21,12.15A3,3,0,0,0,54.61,293.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.44,293.91a3.21,3.21,0,0,1-1.57-.39l-21-12.15a1.21,1.21,0,0,1-.73-1,.91.91,0,0,1,.53-.8l22.53-12.93a3.11,3.11,0,0,1,2.81.1l21,12.14a1.25,1.25,0,0,1,.73,1,.92.92,0,0,1-.53.79L54.68,293.62A2.55,2.55,0,0,1,53.44,293.91Zm1-27.27a2.24,2.24,0,0,0-1.1.26L30.77,279.83a.67.67,0,0,0-.39.55c0,.26.22.53.59.74l21,12.15a2.8,2.8,0,0,0,2.53.1h0l22.53-12.93a.67.67,0,0,0,.39-.55,1,1,0,0,0-.59-.75L55.83,267A2.89,2.89,0,0,0,54.4,266.64Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.25,277.83a1.15,1.15,0,0,0,.65.77l21,12.15a2.94,2.94,0,0,0,2.67.1l22.53-12.93a.88.88,0,0,0,.45-.56v3.12a.77.77,0,0,1-.45.78L54.61,294.19a2.94,2.94,0,0,1-2.67-.1L30.9,282a1.09,1.09,0,0,1-.66-.93v-3.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.44,294.61a3.21,3.21,0,0,1-1.57-.39l-21-12.15A1.19,1.19,0,0,1,30.1,281v-3.18l.28,0a1,1,0,0,0,.58.67l21,12.15a2.83,2.83,0,0,0,2.53.1l22.53-12.94a.73.73,0,0,0,.38-.46l.28,0v3.12a.89.89,0,0,1-.52.9L54.68,294.32A2.55,2.55,0,0,1,53.44,294.61Zm-23-16.22V281c0,.28.19.58.58.8L52,294a2.83,2.83,0,0,0,2.53.1l22.53-12.94a.63.63,0,0,0,.38-.63v-2.63a1.06,1.06,0,0,1-.23.17L54.68,291a3.14,3.14,0,0,1-2.81-.1l-21-12.15A1.71,1.71,0,0,1,30.39,278.39Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7,277.11l22.53-12.94a3,3,0,0,1,2.67.1l21,12.15c.79.45.88,1.14.2,1.54L54.61,290.9a3,3,0,0,1-2.67-.1l-21-12.15C30.1,278.2,30,277.51,30.7,277.11Zm2.84,1.32,18.77,10.83a2.44,2.44,0,0,0,2.18.08l20.13-11.53c.55-.33.48-.89-.17-1.26L55.69,265.72a2.41,2.41,0,0,0-2.18-.08L33.38,277.17C32.82,277.5,32.9,278.06,33.54,278.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.44,291.31a3.21,3.21,0,0,1-1.57-.39l-21-12.15a1.21,1.21,0,0,1-.73-1,.91.91,0,0,1,.53-.8h0l22.53-12.93a3.11,3.11,0,0,1,2.81.1l21,12.14a1.25,1.25,0,0,1,.73,1,.92.92,0,0,1-.53.79L54.68,291A2.55,2.55,0,0,1,53.44,291.31ZM30.77,277.23a.67.67,0,0,0-.39.55c0,.26.22.53.59.74l21,12.15a2.8,2.8,0,0,0,2.53.1l22.53-12.93a.67.67,0,0,0,.39-.55,1,1,0,0,0-.59-.75l-21-12.14a2.8,2.8,0,0,0-2.53-.1Zm22.76,12.48a2.58,2.58,0,0,1-1.29-.33L33.47,278.55a1,1,0,0,1-.61-.83.78.78,0,0,1,.45-.67l20.13-11.54a2.57,2.57,0,0,1,2.32.08l18.76,10.84a1,1,0,0,1,.61.83.78.78,0,0,1-.44.67L54.56,289.46A2,2,0,0,1,53.53,289.71Zm.94-24.15a1.89,1.89,0,0,0-.89.2L33.45,277.3a.52.52,0,0,0-.3.42.76.76,0,0,0,.46.58h0l18.77,10.83a2.22,2.22,0,0,0,2,.08l20.13-11.53a.53.53,0,0,0,.31-.42.8.8,0,0,0-.47-.59L55.61,265.84A2.35,2.35,0,0,0,54.47,265.56Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.38,277.17l20.13-11.53a2.41,2.41,0,0,1,2.18.08l18.76,10.83c.65.37.72.93.17,1.26l-2.4,1.39-16.37-9.44a2.38,2.38,0,0,0-2.17-.08L35.94,279.81l-2.4-1.38C32.9,278.06,32.82,277.5,33.38,277.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.94,280l-2.47-1.43a1,1,0,0,1-.61-.83.78.78,0,0,1,.45-.67h0l20.13-11.54a2.57,2.57,0,0,1,2.32.08l18.76,10.84a1,1,0,0,1,.61.83.78.78,0,0,1-.44.67l-2.47,1.44-16.44-9.49a2.25,2.25,0,0,0-2-.08Zm-2.49-2.68a.52.52,0,0,0-.3.42.76.76,0,0,0,.46.58l2.33,1.35,17.67-10.1a2.52,2.52,0,0,1,2.31.08L72.22,279l2.32-1.36a.53.53,0,0,0,.31-.42.8.8,0,0,0-.47-.59L55.61,265.84a2.28,2.28,0,0,0-2-.08L33.45,277.3Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "72.89 306.3 72.89 293.07 55.85 302.9 55.85 316.18 72.89 306.3",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.74,316.36V302.84l0,0L73,292.88v13.48l0,0ZM56,303v13l16.83-9.75v-13Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "72.56 306.07 72.56 293.25 72.89 293.07 72.89 306.3 55.85 316.18 55.85 315.75 72.56 306.07",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.74,316.36v-.68l0,0L72.45,306V293.19l.55-.31v13.48l0,0Zm.22-.55V316l16.83-9.75v-13l-.12.07v12.81l0,0Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "_6",
    "data-name": 6
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1",
    "data-name": 1
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "67.1 277.94 67.1 274.57 59.72 278.69 59.83 282.03 67.1 277.94",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.72 278.69 52.75 274.57 52.75 277.91 59.83 282.03 59.72 278.69",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "69.1 278.66 67.31 277.42 67.1 277.94 59.83 282.2 61.32 283 69.1 278.66",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "67.1 274.57 59.86 270.31 52.75 274.57 59.72 278.69 67.1 274.57",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.24,274.49l-7.38-4.34-7.25,4.34V278l7.22,4.21L67.24,278Zm-7.38-4,7,4.09-7.09,3.95L53,274.57Zm-7,7.34v-3l6.69,3.95.05,1.43,0,1.58Zm7.08,4-.06-1.65,0-1.37,7.09-4v3.05Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4,274.13c-.57.06-.8.32-.8.67,0,0,0,0,0,0l-1.74.84a1.43,1.43,0,0,1-.27-.81c0-1.08,1.33-1.95,3-2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1,275.36a1.15,1.15,0,0,0,.75.15,1.29,1.29,0,0,0,.75-.15l1.81.78a4.21,4.21,0,0,1-2.56.77,4.07,4.07,0,0,1-2.67-.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.11,274.8c0-.06,0,.05,0,0a.84.84,0,0,0-.81-.83l-.2-1.13c1.69.08,3,1,3,2a1.42,1.42,0,0,1-.36.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.77,274.41l0-.08v0c0-.11,0-.44.68-.52h.11l.25-1.58h-.18c-1.8.09-3.15,1-3.15,2.18a1.57,1.57,0,0,0,.29.89l.07.1,1.85-.89Zm-.31-.15-1.54.75a1.26,1.26,0,0,1-.18-.63c0-.95,1.18-1.75,2.71-1.88l-.16,1C58.62,273.62,58.48,274,58.46,274.26Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.54,274.75a1.3,1.3,0,0,1-.68.12,1,1,0,0,1-.67-.12l-.06,0-2.22.77.19.17a4.27,4.27,0,0,0,2.76.9,4.37,4.37,0,0,0,2.65-.8l.19-.15-2.1-.9Zm1.59.93a4.61,4.61,0,0,1-4.65-.08L59.1,275a1.4,1.4,0,0,0,.76.13,1.6,1.6,0,0,0,.76-.13Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.12,272.2h-.18l.25,1.42.1,0a.69.69,0,0,1,.69.65l0,.08,0,0v.06h.13l1.69,1,.08-.1a1.57,1.57,0,0,0,.39-1C63.27,273.22,61.92,272.29,60.12,272.2Zm2.62,2.91-1.45-.87,0-.06a1,1,0,0,0-.83-.82l-.15-.86c1.53.13,2.71.93,2.71,1.88A1.29,1.29,0,0,1,62.74,275.11Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6,274.3c0,.4.56.72,1.25.72s1.26-.32,1.26-.72-.33-1-.76-1.14c-.16,0-.31.43-.5.43s-.32-.48-.48-.43C59,273.27,58.6,274,58.6,274.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.85,275.16c-.78,0-1.4-.38-1.4-.86a1.65,1.65,0,0,1,.88-1.28c.19,0,.3.12.39.26s.11.16.14.17a1.77,1.77,0,0,0,.13-.17c.1-.14.22-.31.39-.26a1.6,1.6,0,0,1,.88,1.28C61.26,274.78,60.64,275.16,59.85,275.16Zm-.47-1.86a1.44,1.44,0,0,0-.64,1c0,.27.46.57,1.11.57s1.12-.3,1.12-.57-.29-.88-.63-1a.75.75,0,0,0-.11.13c-.1.14-.21.29-.38.29s-.28-.15-.37-.29A1.7,1.7,0,0,0,59.38,273.3Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,273.57c0,.27.39.49.87.49s.88-.22.88-.49-.39-.5-.88-.5S59,273.29,59,273.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.85,274.21c-.57,0-1-.28-1-.64s.44-.64,1-.64,1,.28,1,.64S60.43,274.21,59.85,274.21Zm0-1c-.41,0-.73.18-.73.35s.32.35.73.35.74-.19.74-.35S60.27,273.22,59.85,273.22Z",
    style: {
      fill: "#090d15"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "59.85 274.06 59.85 275.02 60.39 274.93 60.88 274.71 61.11 274.3 60.87 273.57 60.33 274.01 59.85 274.06",
    style: {
      fill: "#090d15"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "76.33 304.36 76.33 291.21 74.02 292.52 74.02 305.71 76.33 304.36",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.91,305.9V292.45L76.44,291v13.4Zm.22-13.32v12.94l2.09-1.22V291.39Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76 304.12 76 291.39 76.33 291.21 76.33 304.36 74.02 305.71 74.02 305.28 76 304.12",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.91,305.9v-.68l2-1.16V291.33l.55-.31v13.4Zm.22-.56v.18l2.09-1.22V291.39l-.12.07v12.73Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "50.28 299.83 46.16 297.44 46.16 293.88 50.28 296.26 50.28 299.83",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "46.16 293.88 47.45 293.17 51.58 295.55 50.28 296.26 46.16 293.88",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "50.28 299.83 51.58 299.12 51.58 295.55 50.28 296.26 50.28 299.83",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.72,295.47,47.45,293,46,293.8v3.73L50.28,300l1.44-.79Zm-4.27-2.13,3.83,2.21-.75.41-.25.14-3.83-2.22Zm-1.15,4v-3.23l3.84,2.22v3.23ZM51.43,299l-1,.55v-3.23l.25-.14.75-.41Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.63,298.27a1.06,1.06,0,0,1-.51-.15,2.29,2.29,0,0,1-1.06-1.84.82.82,0,0,1,.36-.76.81.81,0,0,1,.84.07,2.29,2.29,0,0,1,1.06,1.83.85.85,0,0,1-.36.77A.62.62,0,0,1,48.63,298.27Zm-.88-2.55a.41.41,0,0,0-.19,0,.55.55,0,0,0-.22.51,2,2,0,0,0,.92,1.59.47.47,0,0,0,.78-.45,2,2,0,0,0-.92-1.58A.76.76,0,0,0,47.75,295.72Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "54.47 265.42 54.47 269.46 54 269.54 35.94 279.81 33.36 278.3 33.02 277.84 33.21 277.26 53.51 265.64 54.47 265.42",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "53.39 291.14 53.39 294.44 54.47 294.27 77.4 281.05 77.6 280.66 77.46 277.65 54.61 290.89 54 291.12 53.39 291.14",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "_13",
    "data-name": 13
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.08,317.78,58.71,319a.81.81,0,0,1-.53.23.85.85,0,0,1-.54-.23l-.4-1.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.18,319.39a1,1,0,0,1-.64-.26l0,0L57,317.71l2.24-.08-.44,1.47,0,0A1,1,0,0,1,58.18,319.39Zm-.42-.45a.59.59,0,0,0,.83,0l.3-1-1.45.06Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.68,316.27h0l.84-3.3h0a.64.64,0,0,1,.63-.54.64.64,0,0,1,.63.55h0l.84,3.29h0a1.5,1.5,0,0,1,.05.37,1.52,1.52,0,1,1-3,0A1.5,1.5,0,0,1,56.68,316.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.15,318.31a1.66,1.66,0,0,1-1.66-1.67.93.93,0,0,1,0-.23h0l.9-3.5a.19.19,0,0,1,0-.07h0a.77.77,0,0,1,.74-.54.78.78,0,0,1,.76.58l0,.07.88,3.47h0a2,2,0,0,1,0,.23A1.67,1.67,0,0,1,58.15,318.31Zm-1.29-2.19h0l0,.18a1.55,1.55,0,0,0,0,.34,1.38,1.38,0,0,0,2.76,0,1.12,1.12,0,0,0-.05-.34l0-.18h0l-.8-3.12a.49.49,0,0,0-.49-.42.48.48,0,0,0-.48.42l0,.12Z",
    style: {
      fill: "#090d15"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "58.23 318.17 58.18 319.25 58.74 319.11 58.98 317.93 58.23 318.17",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "58.69 311.83 58.42 311.72 62.51 302.8 62.77 302.92 58.69 311.83",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.72 308.28 61.45 308.16 64.73 301.21 64.99 301.32 61.72 308.28",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "67.31 307.35 67.05 307.22 70.71 299.59 70.97 299.72 67.31 307.35",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4,280.81a.86.86,0,0,1-.33.33L54.54,294.07a2,2,0,0,1-.79.23v.29a2.25,2.25,0,0,0,.93-.27l22.53-12.94.19-.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "40.47 313.17 37.49 311.49 40.81 309.82 40.63 312.06 40.47 313.17",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4,313.25l-3.13-1.77,3.66-1.84-.19,2.43-.17,1.1A.11.11,0,0,1,40.4,313.25Zm-2.69-1.76L40.39,313l.14-1L40.7,310Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8,312.06h0a.85.85,0,0,0-.89.24,2.78,2.78,0,0,0-.8,2.38,1,1,0,0,0,.39.66h0l1,.56,1.31-3.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.69,315.77a.25.25,0,0,1-.36.13l-1-.51v0a1.1,1.1,0,0,1-.37-.67,2.9,2.9,0,0,1,.83-2.48,1,1,0,0,1,.9-.29h0l.1.05,1,.54a.15.15,0,0,1,.07.19Zm-1.07-.48.86.46,1.23-3.08-1-.51a.74.74,0,0,0-.78.22,2.66,2.66,0,0,0-.77,2.28.89.89,0,0,0,.35.59Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.32,313.25a1,1,0,0,0-.59-.8,1,1,0,0,0-.95.28,2.89,2.89,0,0,0-.84,2.48.85.85,0,0,0,.82.84,1.13,1.13,0,0,0,.73-.32A2.92,2.92,0,0,0,40.32,313.25Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "31.3 318.69 28.32 317.01 31.65 315.34 31.46 317.58 31.3 318.69",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.13,318.72l-3-1.72,3.66-1.84-.19,2.43-.15,1A.2.2,0,0,1,31.13,318.72ZM28.54,317l2.68,1.52.14-1,.17-2.06Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.43,317.24h0a.85.85,0,0,0-.89.24,2.8,2.8,0,0,0-.8,2.38.94.94,0,0,0,.4.65h0l1,.55,1.31-3.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.31,321a.23.23,0,0,1-.33.11l-1-.53h0a1.1,1.1,0,0,1-.37-.68,2.89,2.89,0,0,1,.84-2.48,1,1,0,0,1,.89-.29v0l.1,0,.93.51a.23.23,0,0,1,.11.3Zm-1.07-.52.86.47,1.24-3.09-1-.51a.78.78,0,0,0-.78.23,2.64,2.64,0,0,0-.76,2.28.87.87,0,0,0,.34.59Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.94,318.44a1,1,0,0,0-.58-.8,1,1,0,0,0-1,.28,2.88,2.88,0,0,0-.83,2.47,1,1,0,0,0,.59.81.85.85,0,0,0,.23,0,1.13,1.13,0,0,0,.72-.32A2.88,2.88,0,0,0,30.94,318.44Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.62,308.63,42.07,302l-6.48-3.75-.18-.11c-.35-.19-.48-.25-.76-.1l-11.81,6.89a.82.82,0,0,0-.34.48l-.8,4.4-2,2c-.13.17.17.47.17.65l.2,2.19.19.72-.24.22,0,.31.93-.32V315a2.65,2.65,0,0,1,1-1.92c1.34-.84,1.41,1.23,1.45,1.64,0,.13.11.18.23.11l1.55-.87.18.2,3.37-.24,5.34-4.82.49-.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,316.1l-.06-.52.24-.22-.17-.65-.21-2.21a.5.5,0,0,0-.08-.21c-.09-.16-.19-.36-.06-.53l1.95-2,.79-4.37a.94.94,0,0,1,.4-.56l11.81-6.89c.33-.19.52-.1.88.1l.18.11L42.27,302l-7.53,6.72v.19l-.55.3L28.84,314l-3.47.26-.15-.18-1.47.82a.27.27,0,0,1-.27,0,.25.25,0,0,1-.14-.22v-.1c0-.37-.1-1.36-.55-1.58a.74.74,0,0,0-.71.13,2.46,2.46,0,0,0-.93,1.84v.71Zm.19-.43v.1l.72-.25V315A2.78,2.78,0,0,1,22,313a.94.94,0,0,1,.94-.15c.56.29.65,1.34.68,1.78v.1s0,0,0,0h0l1.64-.92.2.23,3.28-.24,5.3-4.79.45-.25v-.15L41.87,302l-6.52-3.77c-.33-.19-.42-.23-.64-.11L22.9,305a.63.63,0,0,0-.28.4l-.81,4.43-2,2.07s0,.16.09.26a.65.65,0,0,1,.11.31l.2,2.18.21.77Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.52,316.4h0l7.1,4.1,2.2-6.64-1.74-1h0l-5.36-3.11-2,2a1,1,0,0,0-.21.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.54,320.59l-7.14-4.12,0-4.09a1.13,1.13,0,0,1,.24-.65l2-2.11,5.44,3.16,1.82,1Zm-6.9-4.25,6.91,4,2.12-6.41L27,313l-5.28-3.06-1.9,2a.86.86,0,0,0-.19.49Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.83,307.22l-3.28-1.9c-.18-.1-.15-.27,0-.38l1.19-.69a.76.76,0,0,1,.67,0l3.29,1.9c.17.1.15.27,0,.39l-1.19.68A.73.73,0,0,1,28.83,307.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.12,307.41a.68.68,0,0,1-.35-.09l-3.28-1.89a.32.32,0,0,1-.18-.27.38.38,0,0,1,.23-.33l1.18-.68a.85.85,0,0,1,.79,0L30.8,306a.31.31,0,0,1,.17.27.39.39,0,0,1-.22.32l-1.19.68A.83.83,0,0,1,29.12,307.41Zm-.23-.29a.67.67,0,0,0,.55,0l1.19-.69c.07,0,.1-.08.1-.11s0-.06-.05-.07l-3.29-1.89a.63.63,0,0,0-.55,0l-1.19.69c-.07,0-.1.09-.1.12s0,0,.06.06Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.92,306.19a.21.21,0,0,1-.12,0l-.77-.44a.16.16,0,0,1-.08-.13.15.15,0,0,1,.09-.14l.28-.16a.27.27,0,0,1,.26,0l.77.44a.16.16,0,0,1,.08.13.2.2,0,0,1-.09.15l-.28.16A.32.32,0,0,1,27.92,306.19Zm0-.21H28l.21-.12-.69-.4h0l-.21.12Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.93,316.92l-.53-.31a.13.13,0,0,0-.12,0,.14.14,0,0,0-.06.13v1a.32.32,0,0,0,.14.27l.53.31.07,0,.05,0a.14.14,0,0,0,.07-.13v-1A.34.34,0,0,0,25.93,316.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,318.45l-.12,0-.53-.31a.43.43,0,0,1-.2-.36v-1a.25.25,0,0,1,.12-.22.22.22,0,0,1,.22,0l.53.31a.42.42,0,0,1,.2.36v1a.23.23,0,0,1-.12.22A.17.17,0,0,1,26,318.45Zm-.62-1.75s0,0,0,0v1a.22.22,0,0,0,.09.18l.53.31s0,0,0,0v-1a.22.22,0,0,0-.09-.18l-.53-.31Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,318.89l-.63-.36a.1.1,0,0,0-.09,0,.11.11,0,0,0,0,.1v.12a.21.21,0,0,0,.09.17l.63.37H26a.09.09,0,0,0,0-.09v-.13A.21.21,0,0,0,26,318.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,319.4a.19.19,0,0,1-.1,0l-.63-.37a.29.29,0,0,1-.15-.26v-.12a.23.23,0,0,1,.1-.19.19.19,0,0,1,.19,0l.64.36a.33.33,0,0,1,.14.26v.13a.2.2,0,0,1-.1.18A.14.14,0,0,1,26,319.4Zm-.69-.78,0,.12a.13.13,0,0,0,0,.09l.63.36,0-.13a.1.1,0,0,0,0-.08Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.66,313.91l-.53-.31a.13.13,0,0,0-.19.13v1a.3.3,0,0,0,.15.27l.52.31.07,0,.06,0a.14.14,0,0,0,.06-.13v-1A.33.33,0,0,0,20.66,313.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.68,315.44l-.12,0L20,315.1a.44.44,0,0,1-.19-.36v-1a.24.24,0,0,1,.11-.22.24.24,0,0,1,.23,0l.53.31a.44.44,0,0,1,.19.36v1a.24.24,0,0,1-.11.22A.2.2,0,0,1,20.68,315.44Zm-.61-1.75s0,0,0,0v1a.2.2,0,0,0,.09.18l.53.31s0,0,0,0v-1a.22.22,0,0,0-.09-.18l-.53-.31Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.71,315.88l-.63-.36a.1.1,0,0,0-.09,0,.11.11,0,0,0,0,.1v.12a.21.21,0,0,0,.09.17l.64.37h.09a.11.11,0,0,0,0-.09v-.13A.22.22,0,0,0,20.71,315.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.72,316.39a.17.17,0,0,1-.1,0L20,316a.3.3,0,0,1-.14-.26v-.12a.21.21,0,0,1,.1-.19.19.19,0,0,1,.19,0l.63.36a.3.3,0,0,1,.14.26v.13a.19.19,0,0,1-.09.18Zm-.7-.78,0,.12a.09.09,0,0,0,0,.08l.63.37,0-.13a.1.1,0,0,0,0-.08Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.62,316.09l-3.15-1.82a.16.16,0,0,0-.16,0,.19.19,0,0,0-.09.18v1.81a.44.44,0,0,0,.2.36l3.15,1.82a.15.15,0,0,0,.09,0h.07a.21.21,0,0,0,.08-.18v-1.81A.44.44,0,0,0,24.62,316.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.32,317.26a.1.1,0,0,1-.07,0l-.72-.41a.21.21,0,0,1-.09-.17v-.42a.15.15,0,0,1,.07-.13.14.14,0,0,1,.14,0l.72.41a.21.21,0,0,1,.09.17v.42a.15.15,0,0,1-.07.13h-.07Zm-.68-.91v.31l.62.35v-.3Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.66,318.56a.42.42,0,0,1-.15,0l-3.15-1.82a.55.55,0,0,1-.24-.45v-1.81a.3.3,0,0,1,.14-.27.27.27,0,0,1,.26,0L24.67,316a.54.54,0,0,1,.24.45v1.81a.31.31,0,0,1-.13.27A.27.27,0,0,1,24.66,318.56Zm-3.28-4.21h0s0,0,0,.09v1.81a.33.33,0,0,0,.14.27l3.15,1.82h0a.09.09,0,0,0,.05-.09v-1.81a.36.36,0,0,0-.14-.27l-3.16-1.82Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.21,301.9a.32.32,0,0,0-.34,0l-12,7a.88.88,0,0,0-.4.55l-.8,4.37-1.94,2a1,1,0,0,0-.25.64v4.07l.14.08.06,0,1.5-.78a.37.37,0,0,0,.18-.28l.06-.47a2.77,2.77,0,0,1,1.08-1.86.86.86,0,0,1,.95-.12,1.77,1.77,0,0,1,.62,1.38v.06a.27.27,0,0,0,.14.24.26.26,0,0,0,.27,0l6.08-3.53a.26.26,0,0,0,.13-.21l0-.33a.15.15,0,0,1,0-.07v-.1A3,3,0,0,1,38.87,312a1,1,0,0,1,.87-.15c.38.19.48.83.53,1.14a.44.44,0,0,0,0,.13.3.3,0,0,0,.14.2.33.33,0,0,0,.27,0l1.27-.73a.85.85,0,0,0,.39-.68V302.2A.33.33,0,0,0,42.21,301.9Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.43,307.81l-2.19-1.26a.2.2,0,0,0-.2,0,.21.21,0,0,0-.13.16L22.5,309a.38.38,0,0,0,.18.4l2.11,1.23a.27.27,0,0,0,.12,0l.11,0a.28.28,0,0,0,.14-.18l.44-2.25A.34.34,0,0,0,25.43,307.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.91,310.72a.26.26,0,0,1-.17-.05l-2.11-1.22a.48.48,0,0,1-.23-.51l.41-2.26a.33.33,0,0,1,.18-.23.34.34,0,0,1,.31,0l2.18,1.26a.43.43,0,0,1,.22.47l-.44,2.25a.39.39,0,0,1-.2.25Zm-1.78-4.1h-.05a.13.13,0,0,0-.07.09L22.6,309a.28.28,0,0,0,.13.29l2.11,1.23a.15.15,0,0,0,.13,0,.11.11,0,0,0,.08-.1l.45-2.25a.23.23,0,0,0-.12-.25l-2.19-1.26Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.67,309.7l-2.19-1.26a.2.2,0,0,0-.2,0,.21.21,0,0,0-.13.16l-.41,2.26a.38.38,0,0,0,.18.4L28,312.47a.19.19,0,0,0,.12,0l.1,0a.23.23,0,0,0,.14-.18l.45-2.25A.34.34,0,0,0,28.67,309.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.15,312.61a.34.34,0,0,1-.17-.05l-2.11-1.22a.48.48,0,0,1-.23-.51l.41-2.26a.36.36,0,0,1,.18-.24.32.32,0,0,1,.3,0l2.19,1.26a.43.43,0,0,1,.22.47l-.44,2.25a.39.39,0,0,1-.2.25A.4.4,0,0,1,28.15,312.61Zm-1.78-4.1h-.05a.13.13,0,0,0-.07.09l-.41,2.26a.28.28,0,0,0,.13.29l2.11,1.22a.12.12,0,0,0,.13,0,.13.13,0,0,0,.08-.1l.45-2.25a.26.26,0,0,0-.12-.26l-2.19-1.25Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.94,313.45a.22.22,0,0,1-.15-.06.38.38,0,0,1-.1-.41l.57-3a.89.89,0,0,1,.39-.53l.4-.25a.28.28,0,0,1,.29,0,.27.27,0,0,1,.12.25v2.61a1.07,1.07,0,0,1-.48.84l-.85.49A.35.35,0,0,1,29.94,313.45Zm.52-3.4-.56,3c0,.12,0,.19,0,.21s.07,0,.12,0l.85-.49a.87.87,0,0,0,.38-.66v-2.61s0-.07,0-.07,0,0-.07,0l-.41.25A.72.72,0,0,0,30.46,310.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.31,317.17a.31.31,0,0,1-.18-.05.35.35,0,0,1-.17-.3v-7.66a.55.55,0,0,1,.27-.47l1.78-1a.28.28,0,0,1,.28,0,.31.31,0,0,1,.15.25v7.74a.58.58,0,0,1-.28.49l-1.68,1A.26.26,0,0,1,32.31,317.17Zm1.84-9.32h0l-1.78,1a.34.34,0,0,0-.16.29v7.66a.14.14,0,0,0,.07.13.17.17,0,0,0,.14,0l1.67-1a.37.37,0,0,0,.18-.31v-7.74a.09.09,0,0,0,0-.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.57,313.64l-.09,0a.23.23,0,0,1-.1-.21v-.28a.44.44,0,0,1,.19-.37l.74-.42a.18.18,0,0,1,.2,0,.23.23,0,0,1,.1.2v.29a.48.48,0,0,1-.2.37l-.73.42Zm.83-1.12-.72.42a.22.22,0,0,0-.1.19v.28a0,0,0,0,0,0,0l.72-.43a.29.29,0,0,0,.09-.19v-.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.55,320.5l-.15,0A.61.61,0,0,1,29,320a1.71,1.71,0,0,1,.49-1.47.62.62,0,0,1,.59-.17.61.61,0,0,1,.37.5h0a1.69,1.69,0,0,1-.49,1.46A.74.74,0,0,1,29.55,320.5Zm.42-2a.5.5,0,0,0-.31.14,1.45,1.45,0,0,0-.42,1.26.39.39,0,0,0,.23.34.4.4,0,0,0,.38-.13,1.48,1.48,0,0,0,.43-1.26h0a.43.43,0,0,0-.23-.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.94,315.31a.39.39,0,0,1-.15,0,.6.6,0,0,1-.36-.49,1.66,1.66,0,0,1,.49-1.46.61.61,0,0,1,.59-.17.62.62,0,0,1,.37.49,1.69,1.69,0,0,1-.5,1.46A.64.64,0,0,1,38.94,315.31Zm.42-2a.48.48,0,0,0-.3.14,1.49,1.49,0,0,0-.43,1.27c0,.18.12.3.23.33a.39.39,0,0,0,.39-.13,1.44,1.44,0,0,0,.42-1.26.41.41,0,0,0-.23-.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "46.11 307 50.98 304.19 50.98 302.42 49.57 303.24 46.11 306.14 46.11 307",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "46.11 306.14 26.37 294.57 29.83 291.67 49.57 303.24 46.11 306.14",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "50.98 302.42 31.24 290.85 29.83 291.67 49.57 303.24 50.98 302.42",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "46.11 307 26.37 295.43 26.37 294.57 46.11 306.14 46.11 307",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.27,294.52l3.39-2.84.12-.09,0,0,1.42-.82,19.84,11.64v1.87l-5,2.88L26.27,295.48ZM46.1,306l3.31-2.77L29.84,291.79l-3.31,2.76ZM31.24,291l-1.22.71,2,1.16,17.55,10.3,1.22-.71Zm19.65,13.17v-1.54l-1.26.73-1.09.91-2.33,2v.65Zm-24.43-8.76L46,306.84v-.64L26.46,294.74Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "47.34 321.43 42.94 318.89 42.94 313.81 47.34 316.35 47.34 321.43",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "51.74 313.81 47.34 316.35 42.94 313.81 47.34 311.27 51.74 313.81",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.34,311.12l-4.4,2.54-.12.08V319l4.4,2.54h0l.12.08.13-.07h0l4.4-2.55v-5.23Zm0,.3,4.15,2.39L49.41,315l-2.07,1.19-.64-.38-3.5-2Zm-4.27,7.39V314l4.15,2.39v4.79Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.28,319.91l-.67-.39a.45.45,0,0,1-.19-.37v-.71c0-.14.08-.21.19-.14l.67.38a.48.48,0,0,1,.2.38v.7C46.48,319.9,46.39,320,46.28,319.91Z",
    style: {
      fill: "#090d15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.48,229.15l-48,27.7,48,27.71,48-27.71Zm48,27.7-48,27.71V340l48-27.7Zm-48,27.71L.5,256.85v55.41l48,27.7Z",
    style: {
      fill: "none",
      stroke: "#111",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "246.4 114.05 294.38 141.75 294.38 197.16 246.4 224.86 198.42 197.15 198.42 141.75 246.4 114.05",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.42,197.61l48-27.82m0,0-.11-55.41m.14,55.41L294,197.39",
    style: {
      fill: "none",
      stroke: "#111",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.08,207.24a.16.16,0,0,1,0,.31.57.57,0,0,1-.54,0c-.16-.08-.16-.23,0-.31A.57.57,0,0,1,224.08,207.24Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.51,206.41a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,225.51,206.41Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.94,205.59c.15.09.15.23,0,.31a.59.59,0,0,1-.55,0c-.15-.08-.15-.22,0-.31A.59.59,0,0,1,226.94,205.59Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.37,204.76a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,228.37,204.76Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.79,203.94a.17.17,0,0,1,0,.32.64.64,0,0,1-.54,0,.17.17,0,0,1,0-.32A.57.57,0,0,1,229.79,203.94Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.65,206.41a.17.17,0,0,1,0,.32.57.57,0,0,1-.54,0,.17.17,0,0,1,0-.32A.64.64,0,0,1,222.65,206.41Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.08,205.59c.15.09.15.23,0,.31a.57.57,0,0,1-.54,0c-.16-.08-.16-.22,0-.31A.57.57,0,0,1,224.08,205.59Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.51,204.76a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,225.51,204.76Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.94,203.94a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.59.59,0,0,1,226.94,203.94Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.37,203.12c.15.08.15.22,0,.31a.59.59,0,0,1-.55,0c-.15-.09-.15-.23,0-.31A.59.59,0,0,1,228.37,203.12Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.23,205.59c.15.09.15.23,0,.31a.59.59,0,0,1-.55,0c-.15-.08-.15-.22,0-.31A.59.59,0,0,1,221.23,205.59Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.65,204.76a.17.17,0,0,1,0,.32.57.57,0,0,1-.54,0,.17.17,0,0,1,0-.32A.64.64,0,0,1,222.65,204.76Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 223.81,
    cy: 204.1,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.51,203.12c.15.08.15.22,0,.31a.59.59,0,0,1-.55,0c-.15-.09-.15-.23,0-.31A.59.59,0,0,1,225.51,203.12Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 226.66,
    cy: 202.45,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.8,204.76a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,219.8,204.76Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.23,203.94a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.59.59,0,0,1,221.23,203.94Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.65,203.12c.15.08.15.22,0,.31a.57.57,0,0,1-.54,0c-.15-.09-.15-.23,0-.31A.57.57,0,0,1,222.65,203.12Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.08,202.29a.17.17,0,0,1,0,.32.64.64,0,0,1-.54,0c-.16-.09-.16-.23,0-.32A.57.57,0,0,1,224.08,202.29Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.51,201.47c.15.08.15.22,0,.31a.59.59,0,0,1-.55,0c-.15-.09-.15-.23,0-.31A.59.59,0,0,1,225.51,201.47Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 218.1,
    cy: 204.1,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 219.52,
    cy: 203.27,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.23,202.29a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.59.59,0,0,1,221.23,202.29Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.65,201.47c.15.08.15.22,0,.31a.57.57,0,0,1-.54,0c-.15-.09-.15-.23,0-.31A.57.57,0,0,1,222.65,201.47Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.08,200.64a.17.17,0,0,1,0,.32.64.64,0,0,1-.54,0c-.16-.09-.16-.23,0-.32A.64.64,0,0,1,224.08,200.64Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 216.66,
    cy: 203.26,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 218.08,
    cy: 202.44,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.79,201.46c.15.09.15.23,0,.31a.59.59,0,0,1-.55,0c-.15-.08-.15-.22,0-.31A.59.59,0,0,1,219.79,201.46Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.21,200.63a.17.17,0,0,1,0,.32.57.57,0,0,1-.54,0,.17.17,0,0,1,0-.32A.64.64,0,0,1,221.21,200.63Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.64,199.81c.15.09.15.23,0,.31a.57.57,0,0,1-.54,0c-.16-.08-.16-.22,0-.31A.57.57,0,0,1,222.64,199.81Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.5,202.28a.17.17,0,0,1,0,.32.64.64,0,0,1-.54,0c-.16-.09-.16-.23,0-.32A.64.64,0,0,1,215.5,202.28Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.93,201.46c.15.09.15.23,0,.31a.59.59,0,0,1-.55,0c-.15-.08-.15-.22,0-.31A.59.59,0,0,1,216.93,201.46Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.36,200.63a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,218.36,200.63Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 219.51,
    cy: 199.97,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.21,199a.17.17,0,0,1,0,.32.57.57,0,0,1-.54,0,.17.17,0,0,1,0-.32A.64.64,0,0,1,221.21,199Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 213.8,
    cy: 201.62,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.5,200.63a.17.17,0,0,1,0,.32.57.57,0,0,1-.54,0c-.16-.09-.16-.23,0-.32A.64.64,0,0,1,215.5,200.63Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 216.66,
    cy: 199.97,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.36,199a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,218.36,199Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.79,198.16a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.59.59,0,0,1,219.79,198.16Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.65,200.63a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,212.65,200.63Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.07,199.81c.15.09.15.23,0,.31a.57.57,0,0,1-.54,0c-.15-.08-.15-.22,0-.31A.57.57,0,0,1,214.07,199.81Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.5,199a.17.17,0,0,1,0,.32.57.57,0,0,1-.54,0c-.16-.09-.16-.23,0-.32A.64.64,0,0,1,215.5,199Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 216.66,
    cy: 198.32,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.36,197.34c.15.08.15.22,0,.31a.59.59,0,0,1-.55,0c-.15-.09-.15-.23,0-.31A.59.59,0,0,1,218.36,197.34Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.22,199.81c.15.09.15.23,0,.31a.59.59,0,0,1-.55,0c-.15-.08-.15-.22,0-.31A.59.59,0,0,1,211.22,199.81Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.65,199a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,212.65,199Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 213.8,
    cy: 198.32,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.5,197.34c.15.08.15.22,0,.31a.57.57,0,0,1-.54,0c-.16-.09-.16-.23,0-.31A.57.57,0,0,1,215.5,197.34Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.93,196.51a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.59.59,0,0,1,216.93,196.51Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.79,199a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,209.79,199Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.22,198.16a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.59.59,0,0,1,211.22,198.16Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.65,197.34c.15.08.15.22,0,.31a.59.59,0,0,1-.55,0c-.15-.09-.15-.23,0-.31A.59.59,0,0,1,212.65,197.34Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.07,196.51a.17.17,0,0,1,0,.32.64.64,0,0,1-.54,0,.17.17,0,0,1,0-.32A.57.57,0,0,1,214.07,196.51Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.5,195.69a.16.16,0,0,1,0,.31.57.57,0,0,1-.54,0c-.16-.08-.16-.23,0-.31A.57.57,0,0,1,215.5,195.69Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 208.09,
    cy: 198.32,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.79,197.34c.15.08.15.22,0,.31a.59.59,0,0,1-.55,0c-.15-.09-.15-.23,0-.31A.59.59,0,0,1,209.79,197.34Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.22,196.51a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.59.59,0,0,1,211.22,196.51Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.65,195.69a.16.16,0,0,1,0,.31.59.59,0,0,1-.55,0,.16.16,0,0,1,0-.31A.59.59,0,0,1,212.65,195.69Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.07,194.86a.17.17,0,0,1,0,.32.57.57,0,0,1-.54,0,.17.17,0,0,1,0-.32A.64.64,0,0,1,214.07,194.86Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 206.66,
    cy: 197.49,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.36,196.51a.17.17,0,0,1,0,.32.64.64,0,0,1-.54,0,.17.17,0,0,1,0-.32A.57.57,0,0,1,208.36,196.51Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.79,195.69a.16.16,0,0,1,0,.31.59.59,0,0,1-.55,0,.16.16,0,0,1,0-.31A.59.59,0,0,1,209.79,195.69Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.22,194.86a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,211.22,194.86Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 212.37,
    cy: 194.2,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 205.22,
    cy: 196.66,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.92,195.68c.15.09.15.23,0,.31a.57.57,0,0,1-.54,0c-.15-.08-.15-.22,0-.31A.57.57,0,0,1,206.92,195.68Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.35,194.85a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,208.35,194.85Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.78,194a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.59.59,0,0,1,209.78,194Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.21,193.21c.15.08.15.22,0,.31a.59.59,0,0,1-.55,0c-.15-.09-.15-.23,0-.31A.59.59,0,0,1,211.21,193.21Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.49,194.85a.17.17,0,0,1,0,.32.57.57,0,0,1-.54,0,.17.17,0,0,1,0-.32A.64.64,0,0,1,205.49,194.85Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.92,194a.17.17,0,0,1,0,.32.64.64,0,0,1-.54,0,.17.17,0,0,1,0-.32A.57.57,0,0,1,206.92,194Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.35,193.21c.15.08.15.22,0,.31a.59.59,0,0,1-.55,0c-.15-.09-.15-.23,0-.31A.59.59,0,0,1,208.35,193.21Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.86,220.31c.16.09.16.23,0,.32a.57.57,0,0,1-.54,0,.17.17,0,0,1,0-.32A.64.64,0,0,1,249.86,220.31Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.29,219.49c.15.09.15.23,0,.31a.57.57,0,0,1-.54,0c-.15-.08-.15-.22,0-.31A.57.57,0,0,1,251.29,219.49Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.72,218.66a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,252.72,218.66Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.15,217.84a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.59.59,0,0,1,254.15,217.84Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247,220.31a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,247,220.31Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.44,219.49c.15.09.15.23,0,.31a.59.59,0,0,1-.55,0c-.15-.08-.15-.22,0-.31A.59.59,0,0,1,248.44,219.49Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 249.59,
    cy: 218.82,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 251.02,
    cy: 218,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.72,217c.15.08.15.22,0,.31a.59.59,0,0,1-.55,0c-.15-.09-.15-.23,0-.31A.59.59,0,0,1,252.72,217Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.58,219.49c.15.09.15.23,0,.31a.59.59,0,0,1-.55,0c-.15-.08-.15-.22,0-.31A.59.59,0,0,1,245.58,219.49Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247,218.66a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,247,218.66Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 248.16,
    cy: 218,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.29,216.19a.17.17,0,0,1,0,.32.64.64,0,0,1-.54,0,.17.17,0,0,1,0-.32A.57.57,0,0,1,251.29,216.19Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.15,218.66a.17.17,0,0,1,0,.32.57.57,0,0,1-.54,0,.17.17,0,0,1,0-.32A.64.64,0,0,1,244.15,218.66Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 245.31,
    cy: 218,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247,217c.15.08.15.22,0,.31a.59.59,0,0,1-.55,0c-.15-.09-.15-.23,0-.31A.59.59,0,0,1,247,217Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.86,215.37c.16.08.16.23,0,.31a.57.57,0,0,1-.54,0,.16.16,0,0,1,0-.31A.57.57,0,0,1,249.86,215.37Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.73,217.84a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.59.59,0,0,1,242.73,217.84Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.15,217c.15.08.15.22,0,.31a.57.57,0,0,1-.54,0c-.15-.09-.15-.23,0-.31A.57.57,0,0,1,244.15,217Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.58,216.19a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.59.59,0,0,1,245.58,216.19Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247,215.37a.16.16,0,0,1,0,.31.59.59,0,0,1-.55,0,.16.16,0,0,1,0-.31A.59.59,0,0,1,247,215.37Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.44,214.54a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,248.44,214.54Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 241.01,
    cy: 217.16,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.71,216.18a.17.17,0,0,1,0,.32.57.57,0,0,1-.54,0,.17.17,0,0,1,0-.32A.64.64,0,0,1,242.71,216.18Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.14,215.36c.15.09.15.23,0,.31a.59.59,0,0,1-.55,0c-.15-.08-.15-.22,0-.31A.59.59,0,0,1,244.14,215.36Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.57,214.53a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,245.57,214.53Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247,213.71c.15.09.15.23,0,.31a.59.59,0,0,1-.55,0c-.15-.08-.15-.22,0-.31A.59.59,0,0,1,247,213.71Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.86,216.18a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,239.86,216.18Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.28,215.36c.16.09.16.23,0,.31a.57.57,0,0,1-.54,0c-.15-.08-.15-.22,0-.31A.57.57,0,0,1,241.28,215.36Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.71,214.53a.17.17,0,0,1,0,.32.57.57,0,0,1-.54,0,.17.17,0,0,1,0-.32A.64.64,0,0,1,242.71,214.53Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 243.87,
    cy: 213.87,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.57,212.89c.15.08.15.22,0,.31a.59.59,0,0,1-.55,0c-.15-.09-.15-.23,0-.31A.59.59,0,0,1,245.57,212.89Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.43,215.36c.15.09.15.23,0,.31a.59.59,0,0,1-.55,0c-.15-.08-.15-.22,0-.31A.59.59,0,0,1,238.43,215.36Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.86,214.53a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,239.86,214.53Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.28,213.71c.16.09.16.23,0,.31a.57.57,0,0,1-.54,0c-.15-.08-.15-.22,0-.31A.57.57,0,0,1,241.28,213.71Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.71,212.89c.15.08.15.22,0,.31a.57.57,0,0,1-.54,0c-.15-.09-.15-.23,0-.31A.57.57,0,0,1,242.71,212.89Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 243.87,
    cy: 212.22,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,214.53a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,237,214.53Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.43,213.71c.15.09.15.23,0,.31a.59.59,0,0,1-.55,0c-.15-.08-.15-.22,0-.31A.59.59,0,0,1,238.43,213.71Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.86,212.89c.15.08.15.22,0,.31a.59.59,0,0,1-.55,0c-.15-.09-.15-.23,0-.31A.59.59,0,0,1,239.86,212.89Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.28,212.06c.16.09.16.23,0,.32a.64.64,0,0,1-.54,0,.17.17,0,0,1,0-.32A.57.57,0,0,1,241.28,212.06Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.71,211.24c.15.08.15.22,0,.31a.57.57,0,0,1-.54,0c-.15-.09-.15-.23,0-.31A.57.57,0,0,1,242.71,211.24Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 235.3,
    cy: 213.87,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,212.89c.15.08.15.22,0,.31a.59.59,0,0,1-.55,0c-.15-.09-.15-.23,0-.31A.59.59,0,0,1,237,212.89Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.43,212.06a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.59.59,0,0,1,238.43,212.06Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.86,211.24c.15.08.15.22,0,.31a.59.59,0,0,1-.55,0c-.15-.09-.15-.23,0-.31A.59.59,0,0,1,239.86,211.24Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.28,210.41c.16.09.16.23,0,.32a.64.64,0,0,1-.54,0,.17.17,0,0,1,0-.32A.57.57,0,0,1,241.28,210.41Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.15,212.89c.15.08.15.22,0,.31a.59.59,0,0,1-.55,0c-.15-.09-.15-.23,0-.31A.59.59,0,0,1,234.15,212.89Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.57,212.06a.17.17,0,0,1,0,.32.64.64,0,0,1-.54,0,.17.17,0,0,1,0-.32A.57.57,0,0,1,235.57,212.06Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 236.73,
    cy: 211.39,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.43,210.41a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.59.59,0,0,1,238.43,210.41Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.86,209.59a.16.16,0,0,1,0,.31.59.59,0,0,1-.55,0,.16.16,0,0,1,0-.31A.59.59,0,0,1,239.86,209.59Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.72,212.06a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.59.59,0,0,1,232.72,212.06Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.15,211.24c.15.08.15.22,0,.31a.59.59,0,0,1-.55,0c-.15-.09-.15-.23,0-.31A.59.59,0,0,1,234.15,211.24Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.57,210.41a.17.17,0,0,1,0,.32.64.64,0,0,1-.54,0,.17.17,0,0,1,0-.32A.57.57,0,0,1,235.57,210.41Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,209.59a.16.16,0,0,1,0,.31.57.57,0,0,1-.54,0c-.16-.08-.16-.23,0-.31A.57.57,0,0,1,237,209.59Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.43,208.76a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,238.43,208.76Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.29,211.24c.15.08.15.22,0,.31a.59.59,0,0,1-.55,0c-.15-.09-.15-.23,0-.31A.59.59,0,0,1,231.29,211.24Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.72,210.41a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.59.59,0,0,1,232.72,210.41Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.15,209.59a.16.16,0,0,1,0,.31.59.59,0,0,1-.55,0,.16.16,0,0,1,0-.31A.59.59,0,0,1,234.15,209.59Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.57,208.76a.17.17,0,0,1,0,.32.57.57,0,0,1-.54,0,.17.17,0,0,1,0-.32A.64.64,0,0,1,235.57,208.76Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 236.73,
    cy: 208.1,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 229.58,
    cy: 210.56,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.28,209.58c.15.09.15.23,0,.31a.59.59,0,0,1-.55,0c-.15-.08-.15-.22,0-.31A.59.59,0,0,1,231.28,209.58Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.71,208.75a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,232.71,208.75Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.13,207.93a.17.17,0,0,1,0,.32.64.64,0,0,1-.54,0,.17.17,0,0,1,0-.32A.57.57,0,0,1,234.13,207.93Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 235.29,
    cy: 207.26,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.42,209.58c.15.09.15.23,0,.31a.57.57,0,0,1-.54,0c-.16-.08-.16-.22,0-.31A.57.57,0,0,1,228.42,209.58Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.85,208.75a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,229.85,208.75Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.28,207.93a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.59.59,0,0,1,231.28,207.93Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.71,207.11c.15.08.15.22,0,.31a.59.59,0,0,1-.55,0c-.15-.09-.15-.23,0-.31A.59.59,0,0,1,232.71,207.11Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.13,206.28a.17.17,0,0,1,0,.32.64.64,0,0,1-.54,0,.17.17,0,0,1,0-.32A.57.57,0,0,1,234.13,206.28Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227,208.75a.17.17,0,0,1,0,.32.57.57,0,0,1-.54,0,.17.17,0,0,1,0-.32A.64.64,0,0,1,227,208.75Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.42,207.93a.17.17,0,0,1,0,.32.64.64,0,0,1-.54,0c-.16-.09-.16-.23,0-.32A.57.57,0,0,1,228.42,207.93Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.85,207.11c.15.08.15.22,0,.31a.59.59,0,0,1-.55,0c-.15-.09-.15-.23,0-.31A.59.59,0,0,1,229.85,207.11Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.28,206.28a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.59.59,0,0,1,231.28,206.28Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.71,205.46a.16.16,0,0,1,0,.31.59.59,0,0,1-.55,0,.16.16,0,0,1,0-.31A.59.59,0,0,1,232.71,205.46Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.57,207.93a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.59.59,0,0,1,225.57,207.93Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227,207.11c.15.08.15.22,0,.31a.57.57,0,0,1-.54,0c-.15-.09-.15-.23,0-.31A.57.57,0,0,1,227,207.11Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.42,206.28a.17.17,0,0,1,0,.32.64.64,0,0,1-.54,0c-.16-.09-.16-.23,0-.32A.57.57,0,0,1,228.42,206.28Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.85,205.46a.16.16,0,0,1,0,.31.59.59,0,0,1-.55,0,.16.16,0,0,1,0-.31A.59.59,0,0,1,229.85,205.46Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.28,204.63a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,231.28,204.63Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.23,203.13c.15.08.15.22,0,.31a.59.59,0,0,1-.55,0c-.15-.09-.15-.23,0-.31A.59.59,0,0,1,231.23,203.13Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.65,202.3a.17.17,0,0,1,0,.32.64.64,0,0,1-.54,0,.17.17,0,0,1,0-.32A.57.57,0,0,1,232.65,202.3Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.08,201.48a.16.16,0,0,1,0,.31.57.57,0,0,1-.54,0c-.16-.08-.16-.23,0-.31A.57.57,0,0,1,234.08,201.48Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.51,200.65a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,235.51,200.65Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.94,199.83c.15.09.15.23,0,.31a.59.59,0,0,1-.55,0c-.15-.08-.15-.22,0-.31A.59.59,0,0,1,236.94,199.83Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.37,199a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,238.37,199Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.79,198.18a.17.17,0,0,1,0,.32.64.64,0,0,1-.54,0,.17.17,0,0,1,0-.32A.57.57,0,0,1,239.79,198.18Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.22,197.36c.15.08.15.22,0,.31a.59.59,0,0,1-.55,0c-.15-.09-.15-.23,0-.31A.59.59,0,0,1,241.22,197.36Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.65,196.53a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.59.59,0,0,1,242.65,196.53Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.08,195.71c.15.08.15.22,0,.31a.59.59,0,0,1-.55,0c-.15-.09-.15-.23,0-.31A.59.59,0,0,1,244.08,195.71Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.5,194.88c.16.09.16.23,0,.32a.64.64,0,0,1-.54,0,.17.17,0,0,1,0-.32A.64.64,0,0,1,245.5,194.88Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.93,194.06a.16.16,0,0,1,0,.31.57.57,0,0,1-.54,0,.16.16,0,0,1,0-.31A.57.57,0,0,1,246.93,194.06Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.36,193.23a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,248.36,193.23Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.79,192.41c.15.09.15.23,0,.31a.59.59,0,0,1-.55,0c-.15-.08-.15-.22,0-.31A.59.59,0,0,1,249.79,192.41Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.67,191.58a.66.66,0,0,1,.55,0,.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.25,202.3a.66.66,0,0,1,.55,0,.17.17,0,0,1,0,.32.63.63,0,0,1-.55,0A.17.17,0,0,1,229.25,202.3Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.23,201.48a.16.16,0,0,1,0,.31.59.59,0,0,1-.55,0,.16.16,0,0,1,0-.31A.59.59,0,0,1,231.23,201.48Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.65,200.65a.17.17,0,0,1,0,.32.57.57,0,0,1-.54,0,.17.17,0,0,1,0-.32A.64.64,0,0,1,232.65,200.65Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 233.81,
    cy: 199.99,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.51,199a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,235.51,199Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.94,198.18a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.59.59,0,0,1,236.94,198.18Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.37,197.36c.15.08.15.22,0,.31a.59.59,0,0,1-.55,0c-.15-.09-.15-.23,0-.31A.59.59,0,0,1,238.37,197.36Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 239.52,
    cy: 196.69,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.22,195.71c.15.08.15.22,0,.31a.59.59,0,0,1-.55,0c-.15-.09-.15-.23,0-.31A.59.59,0,0,1,241.22,195.71Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.65,194.88a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,242.65,194.88Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.08,194.06a.16.16,0,0,1,0,.31.59.59,0,0,1-.55,0,.16.16,0,0,1,0-.31A.59.59,0,0,1,244.08,194.06Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.5,193.23c.16.09.16.23,0,.32a.57.57,0,0,1-.54,0C244.81,193.46,245.35,193.15,245.5,193.23Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.82,201.48a.59.59,0,0,1,.55,0,.16.16,0,0,1,0,.31.59.59,0,0,1-.55,0C227.67,201.71,227.67,201.57,227.82,201.48Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.8,200.65a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,229.8,200.65Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.23,199.83c.15.09.15.23,0,.31a.59.59,0,0,1-.55,0c-.15-.08-.15-.22,0-.31A.59.59,0,0,1,231.23,199.83Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.65,199a.17.17,0,0,1,0,.32.57.57,0,0,1-.54,0,.17.17,0,0,1,0-.32A.64.64,0,0,1,232.65,199Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.08,198.18a.17.17,0,0,1,0,.32.64.64,0,0,1-.54,0c-.16-.09-.16-.23,0-.32A.57.57,0,0,1,234.08,198.18Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.51,197.36c.15.08.15.22,0,.31a.59.59,0,0,1-.55,0c-.15-.09-.15-.23,0-.31A.59.59,0,0,1,235.51,197.36Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.94,196.53a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.59.59,0,0,1,236.94,196.53Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.37,195.71c.15.08.15.22,0,.31a.59.59,0,0,1-.55,0c-.15-.09-.15-.23,0-.31A.59.59,0,0,1,238.37,195.71Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.79,194.88a.17.17,0,0,1,0,.32.64.64,0,0,1-.54,0C239.1,195.11,239.64,194.8,239.79,194.88Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.39,200.65a.66.66,0,0,1,.55,0,.17.17,0,0,1,0,.32.57.57,0,0,1-.54,0C226.24,200.88,226.24,200.74,226.39,200.65Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.37,199.83c.15.09.15.23,0,.31a.59.59,0,0,1-.55,0c-.15-.08-.15-.22,0-.31A.59.59,0,0,1,228.37,199.83Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.8,199a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,229.8,199Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.23,198.18a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.59.59,0,0,1,231.23,198.18Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.65,197.36c.15.08.15.22,0,.31a.57.57,0,0,1-.54,0c-.15-.09-.15-.23,0-.31A.57.57,0,0,1,232.65,197.36Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.08,196.53a.17.17,0,0,1,0,.32.64.64,0,0,1-.54,0c-.16-.09-.16-.23,0-.32A.57.57,0,0,1,234.08,196.53Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.51,195.71c.15.08.15.22,0,.31a.59.59,0,0,1-.55,0c-.15-.09-.15-.23,0-.31A.59.59,0,0,1,235.51,195.71Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225,199.83a.57.57,0,0,1,.54,0c.15.09.15.23,0,.31a.57.57,0,0,1-.54,0C224.82,200.06,224.82,199.92,225,199.83Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.94,199a.17.17,0,0,1,0,.32.57.57,0,0,1-.54,0,.17.17,0,0,1,0-.32A.64.64,0,0,1,226.94,199Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.37,198.18a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.59.59,0,0,1,228.37,198.18Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.8,197.36c.15.08.15.22,0,.31a.59.59,0,0,1-.55,0c-.15-.09-.15-.23,0-.31A.59.59,0,0,1,229.8,197.36Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.23,196.53a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.59.59,0,0,1,231.23,196.53Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.65,195.71c.15.08.15.22,0,.31a.57.57,0,0,1-.54,0c-.15-.09-.15-.23,0-.31A.57.57,0,0,1,232.65,195.71Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.53,199a.57.57,0,0,1,.54,0c.15.08.15.22,0,.31a.57.57,0,0,1-.54,0C223.38,199.22,223.38,199.08,223.53,199Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.5,198.17a.17.17,0,0,1,0,.32.64.64,0,0,1-.54,0c-.16-.09-.16-.23,0-.32A.57.57,0,0,1,225.5,198.17Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.93,197.35c.15.08.15.22,0,.31a.59.59,0,0,1-.55,0c-.15-.09-.15-.23,0-.31A.59.59,0,0,1,226.93,197.35Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 228.08,
    cy: 196.68,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.79,195.7a.16.16,0,0,1,0,.31.59.59,0,0,1-.55,0,.16.16,0,0,1,0-.31A.59.59,0,0,1,229.79,195.7Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.1,198.17a.57.57,0,0,1,.54,0c.16.09.16.23,0,.32a.66.66,0,0,1-.55,0A.17.17,0,0,1,222.1,198.17Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.07,197.35c.15.08.15.22,0,.31a.57.57,0,0,1-.54,0c-.15-.09-.15-.23,0-.31A.57.57,0,0,1,224.07,197.35Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.5,196.52a.17.17,0,0,1,0,.32.64.64,0,0,1-.54,0c-.16-.09-.16-.23,0-.32A.64.64,0,0,1,225.5,196.52Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.93,195.7a.16.16,0,0,1,0,.31.59.59,0,0,1-.55,0,.16.16,0,0,1,0-.31A.59.59,0,0,1,226.93,195.7Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.67,197.35a.59.59,0,0,1,.55,0,.16.16,0,0,1,0,.31.59.59,0,0,1-.55,0A.16.16,0,0,1,220.67,197.35Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.65,196.52a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,222.65,196.52Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.07,195.7a.16.16,0,0,1,0,.31.57.57,0,0,1-.54,0,.16.16,0,0,1,0-.31A.57.57,0,0,1,224.07,195.7Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.24,196.52a.66.66,0,0,1,.55,0,.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0A.17.17,0,0,1,219.24,196.52Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.22,195.7a.16.16,0,0,1,0,.31.59.59,0,0,1-.55,0,.16.16,0,0,1,0-.31A.59.59,0,0,1,221.22,195.7Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.65,194.87a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,222.65,194.87Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.81,195.7a.59.59,0,0,1,.55,0c.15.09.15.23,0,.31a.57.57,0,0,1-.54,0C217.66,195.93,217.66,195.79,217.81,195.7Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 219.52,
    cy: 195.03,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.39,194.87a.64.64,0,0,1,.54,0,.17.17,0,0,1,0,.32.57.57,0,0,1-.54,0A.17.17,0,0,1,216.39,194.87Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.36,194.05c.15.09.15.23,0,.31a.57.57,0,0,1-.54,0c-.15-.08-.15-.22,0-.31A.57.57,0,0,1,218.36,194.05Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,194.05a.57.57,0,0,1,.54,0c.16.09.16.23,0,.31a.63.63,0,0,1-.55,0A.17.17,0,0,1,215,194.05Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.53,193.23a.59.59,0,0,1,.55,0c.15.08.15.22,0,.31a.59.59,0,0,1-.55,0C213.38,193.45,213.38,193.31,213.53,193.23Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.58,217c.15.08.15.22,0,.31a.59.59,0,0,1-.55,0c-.15-.09-.15-.23,0-.31A.59.59,0,0,1,255.58,217Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 256.74,
    cy: 216.36,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 258.16,
    cy: 215.54,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.86,214.55c.16.09.16.23,0,.32a.57.57,0,0,1-.54,0,.17.17,0,0,1,0-.32A.64.64,0,0,1,259.86,214.55Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.29,213.73c.15.09.15.23,0,.31a.57.57,0,0,1-.54,0c-.15-.08-.15-.22,0-.31A.57.57,0,0,1,261.29,213.73Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.72,212.9a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,262.72,212.9Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.15,212.08a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.59.59,0,0,1,264.15,212.08Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.58,211.26c.15.08.15.22,0,.31a.59.59,0,0,1-.55,0c-.15-.09-.15-.23,0-.31A.59.59,0,0,1,265.58,211.26Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267,210.43a.17.17,0,0,1,0,.32.64.64,0,0,1-.54,0,.17.17,0,0,1,0-.32A.57.57,0,0,1,267,210.43Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.29,208c.15.09.15.23,0,.31a.59.59,0,0,1-.55,0c-.15-.08-.15-.22,0-.31A.59.59,0,0,1,271.29,208Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.43,209.61a.16.16,0,0,1,0,.31.57.57,0,0,1-.54,0,.16.16,0,0,1,0-.31A.57.57,0,0,1,268.43,209.61Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.86,208.78a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,269.86,208.78Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.6,216.2a.66.66,0,0,1,.55,0,.17.17,0,0,1,0,.32.57.57,0,0,1-.54,0C253.45,216.43,253.45,216.29,253.6,216.2Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 255.31,
    cy: 215.54,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257,214.55a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,257,214.55Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.44,213.73c.15.09.15.23,0,.31a.59.59,0,0,1-.55,0c-.15-.08-.15-.22,0-.31A.59.59,0,0,1,258.44,213.73Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 259.59,
    cy: 213.06,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.29,212.08a.17.17,0,0,1,0,.32.64.64,0,0,1-.54,0,.17.17,0,0,1,0-.32A.57.57,0,0,1,261.29,212.08Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.72,211.26c.15.08.15.22,0,.31a.59.59,0,0,1-.55,0c-.15-.09-.15-.23,0-.31A.59.59,0,0,1,262.72,211.26Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 263.88,
    cy: 210.59,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.58,209.61a.16.16,0,0,1,0,.31.59.59,0,0,1-.55,0,.16.16,0,0,1,0-.31A.59.59,0,0,1,265.58,209.61Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.86,207.13a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,269.86,207.13Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.29,206.31c.15.09.15.23,0,.31a.59.59,0,0,1-.55,0c-.15-.08-.15-.22,0-.31A.59.59,0,0,1,271.29,206.31Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 272.44,
    cy: 205.64,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.14,204.66a.17.17,0,0,1,0,.32.64.64,0,0,1-.54,0,.17.17,0,0,1,0-.32A.57.57,0,0,1,274.14,204.66Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.57,203.84c.15.08.15.22,0,.31a.57.57,0,0,1-.54,0c-.16-.09-.16-.23,0-.31A.57.57,0,0,1,275.57,203.84Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277,203a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.59.59,0,0,1,277,203Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267,208.78a.17.17,0,0,1,0,.32.64.64,0,0,1-.54,0,.17.17,0,0,1,0-.32A.64.64,0,0,1,267,208.78Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.43,208c.15.09.15.23,0,.31a.57.57,0,0,1-.54,0c-.15-.08-.15-.22,0-.31A.57.57,0,0,1,268.43,208Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.18,215.38a.57.57,0,0,1,.54,0c.15.09.15.23,0,.31a.57.57,0,0,1-.54,0C252,215.61,252,215.47,252.18,215.38Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 253.88,
    cy: 214.71,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.58,213.73c.15.09.15.23,0,.31a.59.59,0,0,1-.55,0c-.15-.08-.15-.22,0-.31A.59.59,0,0,1,255.58,213.73Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257,212.9a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,257,212.9Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.44,212.08a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.59.59,0,0,1,258.44,212.08Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.86,211.26c.16.08.16.22,0,.31a.57.57,0,0,1-.54,0c-.15-.09-.15-.23,0-.31A.57.57,0,0,1,259.86,211.26Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.29,210.43a.17.17,0,0,1,0,.32.64.64,0,0,1-.54,0,.17.17,0,0,1,0-.32A.57.57,0,0,1,261.29,210.43Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.72,209.61a.16.16,0,0,1,0,.31.59.59,0,0,1-.55,0,.16.16,0,0,1,0-.31A.59.59,0,0,1,262.72,209.61Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.15,208.78a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,264.15,208.78Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.58,208c.15.09.15.23,0,.31a.59.59,0,0,1-.55,0c-.15-.08-.15-.22,0-.31A.59.59,0,0,1,265.58,208Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.86,205.48a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,269.86,205.48Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.29,204.66a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.59.59,0,0,1,271.29,204.66Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.72,203.84c.15.08.15.22,0,.31a.59.59,0,0,1-.55,0c-.15-.09-.15-.23,0-.31A.59.59,0,0,1,272.72,203.84Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.14,203a.17.17,0,0,1,0,.32.64.64,0,0,1-.54,0,.17.17,0,0,1,0-.32A.57.57,0,0,1,274.14,203Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.57,202.19a.16.16,0,0,1,0,.31.57.57,0,0,1-.54,0c-.16-.08-.16-.23,0-.31A.57.57,0,0,1,275.57,202.19Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267,207.13c.16.09.16.23,0,.32a.57.57,0,0,1-.54,0,.17.17,0,0,1,0-.32A.64.64,0,0,1,267,207.13Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.43,206.31c.15.09.15.23,0,.31a.57.57,0,0,1-.54,0c-.15-.08-.15-.22,0-.31A.57.57,0,0,1,268.43,206.31Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.75,214.55a.66.66,0,0,1,.55,0,.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0A.17.17,0,0,1,250.75,214.55Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.73,213.73c.15.09.15.23,0,.31a.59.59,0,0,1-.55,0c-.15-.08-.15-.22,0-.31A.59.59,0,0,1,252.73,213.73Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 253.88,
    cy: 213.06,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.58,212.08a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.59.59,0,0,1,255.58,212.08Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257,211.26c.15.08.15.22,0,.31a.59.59,0,0,1-.55,0c-.15-.09-.15-.23,0-.31A.59.59,0,0,1,257,211.26Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.44,210.43a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.59.59,0,0,1,258.44,210.43Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.86,209.61c.16.08.16.23,0,.31a.57.57,0,0,1-.54,0,.16.16,0,0,1,0-.31A.57.57,0,0,1,259.86,209.61Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.29,208.78a.17.17,0,0,1,0,.32.64.64,0,0,1-.54,0,.17.17,0,0,1,0-.32A.64.64,0,0,1,261.29,208.78Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.72,208c.15.09.15.23,0,.31a.59.59,0,0,1-.55,0c-.15-.08-.15-.22,0-.31A.59.59,0,0,1,262.72,208Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267,205.48c.16.09.16.23,0,.32a.57.57,0,0,1-.54,0,.17.17,0,0,1,0-.32A.64.64,0,0,1,267,205.48Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.43,204.66a.17.17,0,0,1,0,.32.64.64,0,0,1-.54,0,.17.17,0,0,1,0-.32A.57.57,0,0,1,268.43,204.66Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.86,203.84c.15.08.15.22,0,.31a.59.59,0,0,1-.55,0c-.15-.09-.15-.23,0-.31A.59.59,0,0,1,269.86,203.84Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 271.01,
    cy: 203.17,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.72,202.19a.16.16,0,0,1,0,.31.59.59,0,0,1-.55,0,.16.16,0,0,1,0-.31A.59.59,0,0,1,272.72,202.19Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.14,201.36a.17.17,0,0,1,0,.32.57.57,0,0,1-.54,0,.17.17,0,0,1,0-.32A.64.64,0,0,1,274.14,201.36Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.15,207.13a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,264.15,207.13Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.58,206.31c.15.09.15.23,0,.31a.59.59,0,0,1-.55,0c-.15-.08-.15-.22,0-.31A.59.59,0,0,1,265.58,206.31Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.32,213.73a.59.59,0,0,1,.55,0c.15.09.15.23,0,.31a.63.63,0,0,1-.55,0A.17.17,0,0,1,249.32,213.73Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 251.02,
    cy: 213.06,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.73,212.08a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.59.59,0,0,1,252.73,212.08Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 253.88,
    cy: 211.41,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.58,210.43a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.59.59,0,0,1,255.58,210.43Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257,209.61a.16.16,0,0,1,0,.31.59.59,0,0,1-.55,0,.16.16,0,0,1,0-.31A.59.59,0,0,1,257,209.61Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.44,208.78a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,258.44,208.78Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.86,208c.16.09.16.23,0,.31a.57.57,0,0,1-.54,0c-.15-.08-.15-.22,0-.31A.57.57,0,0,1,259.86,208Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.29,207.13a.17.17,0,0,1,0,.32.57.57,0,0,1-.54,0,.17.17,0,0,1,0-.32A.64.64,0,0,1,261.29,207.13Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.58,204.66a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.59.59,0,0,1,265.58,204.66Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267,203.84c.16.08.16.22,0,.31a.57.57,0,0,1-.54,0c-.15-.09-.15-.23,0-.31A.57.57,0,0,1,267,203.84Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.43,203a.17.17,0,0,1,0,.32.64.64,0,0,1-.54,0,.17.17,0,0,1,0-.32A.57.57,0,0,1,268.43,203Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.86,202.19a.16.16,0,0,1,0,.31.59.59,0,0,1-.55,0,.16.16,0,0,1,0-.31A.59.59,0,0,1,269.86,202.19Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.29,201.36a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,271.29,201.36Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 272.44,
    cy: 200.7,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 262.45,
    cy: 206.47,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.15,205.48a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,264.15,205.48Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.88,212.9a.59.59,0,0,1,.55,0c.15.08.15.22,0,.31a.59.59,0,0,1-.55,0A.16.16,0,0,1,247.88,212.9Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.86,212.07a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.59.59,0,0,1,249.86,212.07Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.28,211.25c.16.08.16.23,0,.31a.57.57,0,0,1-.54,0,.16.16,0,0,1,0-.31A.57.57,0,0,1,251.28,211.25Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.71,210.42a.17.17,0,0,1,0,.32.64.64,0,0,1-.54,0,.17.17,0,0,1,0-.32A.64.64,0,0,1,252.71,210.42Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.14,209.6c.15.09.15.23,0,.31a.59.59,0,0,1-.55,0c-.15-.08-.15-.22,0-.31A.59.59,0,0,1,254.14,209.6Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 255.3,
    cy: 208.93,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257,208c.15.09.15.23,0,.31a.59.59,0,0,1-.55,0c-.15-.08-.15-.22,0-.31A.59.59,0,0,1,257,208Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.42,207.12c.16.09.16.23,0,.32a.57.57,0,0,1-.54,0,.17.17,0,0,1,0-.32A.64.64,0,0,1,258.42,207.12Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 259.58,
    cy: 206.46,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 263.86,
    cy: 203.98,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.56,203a.17.17,0,0,1,0,.32.57.57,0,0,1-.54,0,.17.17,0,0,1,0-.32A.64.64,0,0,1,265.56,203Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267,202.18c.15.09.15.23,0,.31a.57.57,0,0,1-.54,0c-.16-.08-.16-.22,0-.31A.57.57,0,0,1,267,202.18Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.42,201.35a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,268.42,201.35Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.85,200.53c.15.09.15.23,0,.31a.59.59,0,0,1-.55,0c-.15-.08-.15-.22,0-.31A.59.59,0,0,1,269.85,200.53Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.28,199.71c.15.08.15.22,0,.31a.59.59,0,0,1-.55,0c-.15-.09-.15-.23,0-.31A.59.59,0,0,1,271.28,199.71Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.28,205.48c.15.08.15.22,0,.31a.59.59,0,0,1-.55,0c-.15-.09-.15-.23,0-.31A.59.59,0,0,1,261.28,205.48Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 262.43,
    cy: 204.81,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.45,212.07a.63.63,0,0,1,.55,0,.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0A.17.17,0,0,1,246.45,212.07Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.43,211.25a.16.16,0,0,1,0,.31.59.59,0,0,1-.55,0,.16.16,0,0,1,0-.31A.59.59,0,0,1,248.43,211.25Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.86,210.42a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,249.86,210.42Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.28,209.6c.16.09.16.23,0,.31a.57.57,0,0,1-.54,0c-.15-.08-.15-.22,0-.31A.57.57,0,0,1,251.28,209.6Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.71,208.77a.17.17,0,0,1,0,.32.57.57,0,0,1-.54,0,.17.17,0,0,1,0-.32A.64.64,0,0,1,252.71,208.77Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 253.87,
    cy: 208.11,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.57,207.12a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,255.57,207.12Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257,206.3a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.59.59,0,0,1,257,206.3Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.28,203.83a.16.16,0,0,1,0,.31.59.59,0,0,1-.55,0,.16.16,0,0,1,0-.31A.59.59,0,0,1,261.28,203.83Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 262.44,
    cy: 203.16,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.14,202.18c.15.09.15.23,0,.31a.59.59,0,0,1-.55,0c-.15-.08-.15-.22,0-.31A.59.59,0,0,1,264.14,202.18Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.56,201.35a.17.17,0,0,1,0,.32.57.57,0,0,1-.54,0,.17.17,0,0,1,0-.32A.64.64,0,0,1,265.56,201.35Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267,200.53c.15.09.15.23,0,.31a.57.57,0,0,1-.54,0c-.16-.08-.16-.22,0-.31A.57.57,0,0,1,267,200.53Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.42,199.71c.15.08.15.22,0,.31a.59.59,0,0,1-.55,0c-.15-.09-.15-.23,0-.31A.59.59,0,0,1,268.42,199.71Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 269.57,
    cy: 199.04,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.42,205.48c.16.08.16.22,0,.31a.57.57,0,0,1-.54,0c-.15-.09-.15-.23,0-.31A.57.57,0,0,1,258.42,205.48Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.85,204.65a.17.17,0,0,1,0,.32.64.64,0,0,1-.54,0,.17.17,0,0,1,0-.32A.57.57,0,0,1,259.85,204.65Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245,211.25a.57.57,0,0,1,.54,0,.16.16,0,0,1,0,.31.57.57,0,0,1-.54,0C244.88,211.48,244.87,211.34,245,211.25Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247,210.42a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,247,210.42Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.43,209.6c.15.09.15.23,0,.31a.59.59,0,0,1-.55,0c-.15-.08-.15-.22,0-.31A.59.59,0,0,1,248.43,209.6Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.86,208.77a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,249.86,208.77Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.28,208c.16.09.16.23,0,.31a.57.57,0,0,1-.54,0c-.15-.08-.15-.22,0-.31A.57.57,0,0,1,251.28,208Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.71,207.12a.17.17,0,0,1,0,.32.57.57,0,0,1-.54,0,.17.17,0,0,1,0-.32A.64.64,0,0,1,252.71,207.12Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 253.87,
    cy: 206.46,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.57,205.48c.15.08.15.22,0,.31a.59.59,0,0,1-.55,0c-.15-.09-.15-.23,0-.31A.59.59,0,0,1,255.57,205.48Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 259.58,
    cy: 203.16,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.28,202.18c.15.09.15.23,0,.31a.59.59,0,0,1-.55,0c-.15-.08-.15-.22,0-.31A.59.59,0,0,1,261.28,202.18Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.71,201.35a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,262.71,201.35Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.14,200.53c.15.09.15.23,0,.31a.59.59,0,0,1-.55,0c-.15-.08-.15-.22,0-.31A.59.59,0,0,1,264.14,200.53Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.56,199.71c.15.08.15.22,0,.31a.57.57,0,0,1-.54,0c-.15-.09-.15-.23,0-.31A.57.57,0,0,1,265.56,199.71Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267,198.88a.17.17,0,0,1,0,.32.64.64,0,0,1-.54,0c-.16-.09-.16-.23,0-.32A.57.57,0,0,1,267,198.88Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.42,198.06c.15.08.15.22,0,.31a.59.59,0,0,1-.55,0c-.15-.09-.15-.23,0-.31A.59.59,0,0,1,268.42,198.06Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257,204.65a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.59.59,0,0,1,257,204.65Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 258.15,
    cy: 203.98,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.6,210.42a.64.64,0,0,1,.54,0,.17.17,0,0,1,0,.32.57.57,0,0,1-.54,0A.17.17,0,0,1,243.6,210.42Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.57,209.6c.15.09.15.23,0,.31a.57.57,0,0,1-.54,0c-.15-.08-.15-.22,0-.31A.57.57,0,0,1,245.57,209.6Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247,208.77a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,247,208.77Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.43,208c.15.09.15.23,0,.31a.59.59,0,0,1-.55,0c-.15-.08-.15-.22,0-.31A.59.59,0,0,1,248.43,208Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.86,207.12a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,249.86,207.12Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.28,206.3c.16.09.16.23,0,.32a.64.64,0,0,1-.54,0,.17.17,0,0,1,0-.32A.57.57,0,0,1,251.28,206.3Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.71,205.48c.15.08.15.22,0,.31a.57.57,0,0,1-.54,0c-.15-.09-.15-.23,0-.31A.57.57,0,0,1,252.71,205.48Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.14,204.65a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.59.59,0,0,1,254.14,204.65Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.42,202.18c.16.09.16.23,0,.31a.57.57,0,0,1-.54,0c-.15-.08-.15-.22,0-.31A.57.57,0,0,1,258.42,202.18Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 259.58,
    cy: 201.51,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.28,200.53c.15.09.15.23,0,.31a.59.59,0,0,1-.55,0c-.15-.08-.15-.22,0-.31A.59.59,0,0,1,261.28,200.53Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.71,199.71c.15.08.15.22,0,.31a.59.59,0,0,1-.55,0c-.15-.09-.15-.23,0-.31A.59.59,0,0,1,262.71,199.71Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 263.86,
    cy: 199.04,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.56,198.06c.15.08.15.22,0,.31a.57.57,0,0,1-.54,0c-.15-.09-.15-.23,0-.31A.57.57,0,0,1,265.56,198.06Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 266.72,
    cy: 197.39,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.57,203.83a.16.16,0,0,1,0,.31.59.59,0,0,1-.55,0,.16.16,0,0,1,0-.31A.59.59,0,0,1,255.57,203.83Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257,203a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,257,203Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.17,209.6a.59.59,0,0,1,.55,0c.15.09.15.23,0,.31a.59.59,0,0,1-.55,0C242,209.83,242,209.69,242.17,209.6Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 243.87,
    cy: 208.93,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.57,208c.15.09.15.23,0,.31a.57.57,0,0,1-.54,0c-.15-.08-.15-.22,0-.31A.57.57,0,0,1,245.57,208Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247,207.12a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,247,207.12Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.43,206.3a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.59.59,0,0,1,248.43,206.3Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.86,205.48c.15.08.15.22,0,.31a.59.59,0,0,1-.55,0c-.15-.09-.15-.23,0-.31A.59.59,0,0,1,249.86,205.48Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.28,204.65c.16.09.16.23,0,.32a.64.64,0,0,1-.54,0,.17.17,0,0,1,0-.32A.57.57,0,0,1,251.28,204.65Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 252.44,
    cy: 203.98,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 253.87,
    cy: 203.16,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.42,200.53c.16.09.16.23,0,.31a.57.57,0,0,1-.54,0c-.15-.08-.15-.22,0-.31A.57.57,0,0,1,258.42,200.53Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.85,199.71c.15.08.15.22,0,.31a.57.57,0,0,1-.54,0c-.15-.09-.15-.23,0-.31A.57.57,0,0,1,259.85,199.71Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.28,198.88a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.59.59,0,0,1,261.28,198.88Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.71,198.06c.15.08.15.22,0,.31a.59.59,0,0,1-.55,0c-.15-.09-.15-.23,0-.31A.59.59,0,0,1,262.71,198.06Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.14,197.23a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.59.59,0,0,1,264.14,197.23Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.56,196.41a.16.16,0,0,1,0,.31.57.57,0,0,1-.54,0,.16.16,0,0,1,0-.31A.57.57,0,0,1,265.56,196.41Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.57,202.18c.15.09.15.23,0,.31a.59.59,0,0,1-.55,0c-.15-.08-.15-.22,0-.31A.59.59,0,0,1,255.57,202.18Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257,201.35a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,257,201.35Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.74,208.77a.66.66,0,0,1,.55,0,.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0A.17.17,0,0,1,240.74,208.77Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.72,208c.15.09.15.23,0,.31a.59.59,0,0,1-.55,0c-.15-.08-.15-.22,0-.31A.59.59,0,0,1,242.72,208Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.15,207.12a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,244.15,207.12Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.57,206.3a.17.17,0,0,1,0,.32.64.64,0,0,1-.54,0,.17.17,0,0,1,0-.32A.57.57,0,0,1,245.57,206.3Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247,205.48c.15.08.15.22,0,.31a.59.59,0,0,1-.55,0c-.15-.09-.15-.23,0-.31A.59.59,0,0,1,247,205.48Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.43,204.65a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.59.59,0,0,1,248.43,204.65Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.86,203.83a.16.16,0,0,1,0,.31.59.59,0,0,1-.55,0,.16.16,0,0,1,0-.31A.59.59,0,0,1,249.86,203.83Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.28,203c.16.09.16.23,0,.32a.57.57,0,0,1-.54,0,.17.17,0,0,1,0-.32A.64.64,0,0,1,251.28,203Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.71,202.18c.15.09.15.23,0,.31a.57.57,0,0,1-.54,0c-.15-.08-.15-.22,0-.31A.57.57,0,0,1,252.71,202.18Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.14,201.35a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,254.14,201.35Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 258.15,
    cy: 199.04,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.85,198.06c.15.08.15.22,0,.31a.57.57,0,0,1-.54,0c-.15-.09-.15-.23,0-.31A.57.57,0,0,1,259.85,198.06Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.28,197.23a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.59.59,0,0,1,261.28,197.23Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.71,196.41a.16.16,0,0,1,0,.31.59.59,0,0,1-.55,0,.16.16,0,0,1,0-.31A.59.59,0,0,1,262.71,196.41Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.14,195.58a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,264.14,195.58Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.57,200.53c.15.09.15.23,0,.31a.59.59,0,0,1-.55,0c-.15-.08-.15-.22,0-.31A.59.59,0,0,1,255.57,200.53Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257,199.71c.15.08.15.22,0,.31a.59.59,0,0,1-.55,0c-.15-.09-.15-.23,0-.31A.59.59,0,0,1,257,199.71Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.31,208a.59.59,0,0,1,.55,0,.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0A.17.17,0,0,1,239.31,208Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.29,207.12a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,241.29,207.12Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.72,206.3a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.59.59,0,0,1,242.72,206.3Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.15,205.48c.15.08.15.22,0,.31a.59.59,0,0,1-.55,0c-.15-.09-.15-.23,0-.31A.59.59,0,0,1,244.15,205.48Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.57,204.65a.17.17,0,0,1,0,.32.64.64,0,0,1-.54,0,.17.17,0,0,1,0-.32A.57.57,0,0,1,245.57,204.65Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247,203.83a.16.16,0,0,1,0,.31.59.59,0,0,1-.55,0,.16.16,0,0,1,0-.31A.59.59,0,0,1,247,203.83Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.43,203a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,248.43,203Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.86,202.18c.15.09.15.23,0,.31a.59.59,0,0,1-.55,0c-.15-.08-.15-.22,0-.31A.59.59,0,0,1,249.86,202.18Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.28,201.35c.16.09.16.23,0,.32a.57.57,0,0,1-.54,0,.17.17,0,0,1,0-.32A.64.64,0,0,1,251.28,201.35Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.71,200.53c.15.09.15.23,0,.31a.57.57,0,0,1-.54,0c-.15-.08-.15-.22,0-.31A.57.57,0,0,1,252.71,200.53Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 253.87,
    cy: 199.86,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.42,197.23c.16.09.16.23,0,.32a.64.64,0,0,1-.54,0,.17.17,0,0,1,0-.32A.64.64,0,0,1,258.42,197.23Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.85,196.41a.16.16,0,0,1,0,.31.57.57,0,0,1-.54,0,.16.16,0,0,1,0-.31A.57.57,0,0,1,259.85,196.41Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.28,195.58a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,261.28,195.58Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.71,194.76c.15.09.15.23,0,.31a.59.59,0,0,1-.55,0c-.15-.08-.15-.22,0-.31A.59.59,0,0,1,262.71,194.76Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.57,198.88a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.59.59,0,0,1,255.57,198.88Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257,198.06c.15.08.15.22,0,.31a.59.59,0,0,1-.55,0c-.15-.09-.15-.23,0-.31A.59.59,0,0,1,257,198.06Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.89,207.13a.57.57,0,0,1,.54,0c.15.08.15.22,0,.31a.57.57,0,0,1-.54,0C237.74,207.35,237.74,207.21,237.89,207.13Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.86,206.3a.17.17,0,0,1,0,.32.64.64,0,0,1-.54,0c-.16-.09-.16-.23,0-.32A.57.57,0,0,1,239.86,206.3Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.29,205.48c.15.08.15.22,0,.31a.59.59,0,0,1-.55,0c-.15-.09-.15-.23,0-.31A.59.59,0,0,1,241.29,205.48Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 242.44,
    cy: 204.81,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.15,203.83a.16.16,0,0,1,0,.31.59.59,0,0,1-.55,0,.16.16,0,0,1,0-.31A.59.59,0,0,1,244.15,203.83Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.57,203a.17.17,0,0,1,0,.32.57.57,0,0,1-.54,0,.17.17,0,0,1,0-.32A.64.64,0,0,1,245.57,203Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247,202.18c.15.09.15.23,0,.31a.59.59,0,0,1-.55,0c-.15-.08-.15-.22,0-.31A.59.59,0,0,1,247,202.18Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.43,201.35a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,248.43,201.35Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 249.58,
    cy: 200.69,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.28,199.71c.16.08.16.22,0,.31a.57.57,0,0,1-.54,0c-.15-.09-.15-.23,0-.31A.57.57,0,0,1,251.28,199.71Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 252.44,
    cy: 199.04,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.14,198.06c.15.08.15.22,0,.31a.59.59,0,0,1-.55,0c-.15-.09-.15-.23,0-.31A.59.59,0,0,1,254.14,198.06Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.42,195.58c.16.09.16.23,0,.32a.57.57,0,0,1-.54,0,.17.17,0,0,1,0-.32A.64.64,0,0,1,258.42,195.58Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.85,194.76c.15.09.15.23,0,.31a.57.57,0,0,1-.54,0c-.15-.08-.15-.22,0-.31A.57.57,0,0,1,259.85,194.76Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.28,193.93a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,261.28,193.93Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.57,197.23a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,255.57,197.23Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257,196.41a.16.16,0,0,1,0,.31.59.59,0,0,1-.55,0,.16.16,0,0,1,0-.31A.59.59,0,0,1,257,196.41Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.45,206.29a.64.64,0,0,1,.54,0,.17.17,0,0,1,0,.32.6.6,0,0,1-.54,0C236.3,206.52,236.29,206.38,236.45,206.29Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 238.15,
    cy: 205.63,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.85,204.64a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,239.85,204.64Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.28,203.82c.15.09.15.23,0,.31a.59.59,0,0,1-.55,0c-.15-.08-.15-.22,0-.31A.59.59,0,0,1,241.28,203.82Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.7,203c.16.09.16.23,0,.32a.57.57,0,0,1-.54,0,.17.17,0,0,1,0-.32A.64.64,0,0,1,242.7,203Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 243.86,
    cy: 202.33,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.56,201.35c.15.08.15.22,0,.31a.59.59,0,0,1-.55,0c-.15-.09-.15-.23,0-.31A.59.59,0,0,1,245.56,201.35Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247,200.52a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.59.59,0,0,1,247,200.52Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.42,199.7c.15.08.15.22,0,.31a.59.59,0,0,1-.55,0c-.15-.09-.15-.23,0-.31A.59.59,0,0,1,248.42,199.7Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 249.57,
    cy: 199.03,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 251,
    cy: 198.21,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.7,197.22a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,252.7,197.22Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.13,196.4c.15.09.15.23,0,.31a.59.59,0,0,1-.55,0c-.15-.08-.15-.22,0-.31A.59.59,0,0,1,254.13,196.4Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.41,193.93c.15.08.15.22,0,.31a.57.57,0,0,1-.54,0c-.15-.09-.15-.23,0-.31A.57.57,0,0,1,258.41,193.93Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.84,193.1a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.59.59,0,0,1,259.84,193.1Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.56,195.57a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,255.56,195.57Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 256.71,
    cy: 194.91,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235,205.47a.57.57,0,0,1,.54,0c.15.08.16.23,0,.31a.57.57,0,0,1-.54,0C234.87,205.7,234.87,205.56,235,205.47Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,204.64a.17.17,0,0,1,0,.32.57.57,0,0,1-.54,0,.17.17,0,0,1,0-.32A.64.64,0,0,1,237,204.64Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.42,203.82c.15.09.15.23,0,.31a.57.57,0,0,1-.54,0c-.16-.08-.16-.22,0-.31A.57.57,0,0,1,238.42,203.82Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.85,203a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,239.85,203Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.28,202.17a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.59.59,0,0,1,241.28,202.17Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.7,201.35c.16.08.16.22,0,.31a.57.57,0,0,1-.54,0c-.15-.09-.15-.23,0-.31A.57.57,0,0,1,242.7,201.35Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.13,200.52a.17.17,0,0,1,0,.32.64.64,0,0,1-.54,0,.17.17,0,0,1,0-.32A.57.57,0,0,1,244.13,200.52Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.56,199.7c.15.08.15.22,0,.31a.59.59,0,0,1-.55,0c-.15-.09-.15-.23,0-.31A.59.59,0,0,1,245.56,199.7Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247,198.87a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,247,198.87Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.42,198.05a.16.16,0,0,1,0,.31.59.59,0,0,1-.55,0,.16.16,0,0,1,0-.31A.59.59,0,0,1,248.42,198.05Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.84,197.22c.16.09.16.23,0,.32a.57.57,0,0,1-.54,0,.17.17,0,0,1,0-.32A.64.64,0,0,1,249.84,197.22Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.27,196.4c.15.09.15.23,0,.31a.57.57,0,0,1-.54,0c-.15-.08-.15-.22,0-.31A.57.57,0,0,1,251.27,196.4Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.7,195.57a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,252.7,195.57Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.13,194.75a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.59.59,0,0,1,254.13,194.75Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.56,193.93c.15.08.15.22,0,.31a.59.59,0,0,1-.55,0c-.15-.09-.15-.23,0-.31A.59.59,0,0,1,255.56,193.93Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257,193.1a.17.17,0,0,1,0,.32.64.64,0,0,1-.54,0,.17.17,0,0,1,0-.32A.57.57,0,0,1,257,193.1Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 258.14,
    cy: 192.43,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.59,204.64a.66.66,0,0,1,.55,0,.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0A.17.17,0,0,1,233.59,204.64Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.57,203.82c.15.09.15.23,0,.31a.59.59,0,0,1-.55,0c-.15-.08-.15-.22,0-.31A.59.59,0,0,1,235.57,203.82Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,203a.17.17,0,0,1,0,.32.57.57,0,0,1-.54,0,.17.17,0,0,1,0-.32A.64.64,0,0,1,237,203Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.42,202.17a.17.17,0,0,1,0,.32.64.64,0,0,1-.54,0c-.16-.09-.16-.23,0-.32A.57.57,0,0,1,238.42,202.17Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.85,201.35c.15.08.15.22,0,.31a.59.59,0,0,1-.55,0c-.15-.09-.15-.23,0-.31A.59.59,0,0,1,239.85,201.35Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.28,200.52a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.59.59,0,0,1,241.28,200.52Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.7,199.7c.16.08.16.22,0,.31a.57.57,0,0,1-.54,0c-.15-.09-.15-.23,0-.31A.57.57,0,0,1,242.7,199.7Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.13,198.87a.17.17,0,0,1,0,.32.64.64,0,0,1-.54,0,.17.17,0,0,1,0-.32A.64.64,0,0,1,244.13,198.87Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 245.29,
    cy: 198.21,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247,197.22a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,247,197.22Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.42,196.4c.15.09.15.23,0,.31a.59.59,0,0,1-.55,0c-.15-.08-.15-.22,0-.31A.59.59,0,0,1,248.42,196.4Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.84,195.57c.16.09.16.23,0,.32a.57.57,0,0,1-.54,0,.17.17,0,0,1,0-.32A.64.64,0,0,1,249.84,195.57Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 251,
    cy: 194.91,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.7,193.93c.15.08.15.22,0,.31a.59.59,0,0,1-.55,0c-.15-.09-.15-.23,0-.31A.59.59,0,0,1,252.7,193.93Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.13,193.1a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.59.59,0,0,1,254.13,193.1Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.56,192.28a.16.16,0,0,1,0,.31.59.59,0,0,1-.55,0,.16.16,0,0,1,0-.31A.59.59,0,0,1,255.56,192.28Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257,191.45a.17.17,0,0,1,0,.32.64.64,0,0,1-.54,0,.17.17,0,0,1,0-.32A.64.64,0,0,1,257,191.45Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.16,203.82a.59.59,0,0,1,.55,0c.15.09.15.23,0,.31a.63.63,0,0,1-.55,0A.17.17,0,0,1,232.16,203.82Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.14,203a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,234.14,203Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.57,202.17a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.59.59,0,0,1,235.57,202.17Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,201.35c.15.08.15.22,0,.31a.57.57,0,0,1-.54,0c-.15-.09-.15-.23,0-.31A.57.57,0,0,1,237,201.35Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.42,200.52a.17.17,0,0,1,0,.32.64.64,0,0,1-.54,0c-.16-.09-.16-.23,0-.32A.57.57,0,0,1,238.42,200.52Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 239.58,
    cy: 199.85,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.28,198.87a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,241.28,198.87Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.7,198.05c.16.08.16.23,0,.31a.57.57,0,0,1-.54,0,.16.16,0,0,1,0-.31A.57.57,0,0,1,242.7,198.05Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.13,197.22a.17.17,0,0,1,0,.32.57.57,0,0,1-.54,0,.17.17,0,0,1,0-.32A.64.64,0,0,1,244.13,197.22Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.56,196.4c.15.09.15.23,0,.31a.59.59,0,0,1-.55,0c-.15-.08-.15-.22,0-.31A.59.59,0,0,1,245.56,196.4Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247,195.57a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,247,195.57Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.42,194.75a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.59.59,0,0,1,248.42,194.75Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.84,193.93c.16.08.16.22,0,.31a.57.57,0,0,1-.54,0c-.15-.09-.15-.23,0-.31A.57.57,0,0,1,249.84,193.93Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 251,
    cy: 193.26,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 252.43,
    cy: 192.43,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.13,191.45a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,254.13,191.45Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.56,190.63c.15.09.15.23,0,.31a.59.59,0,0,1-.55,0c-.15-.08-.15-.22,0-.31A.59.59,0,0,1,255.56,190.63Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.89,202.2a.63.63,0,0,1,.55,0,.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0C277.74,202.42,277.74,202.28,277.89,202.2Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.87,201.37a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.59.59,0,0,1,279.87,201.37Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.29,200.55c.16.08.16.22,0,.31a.57.57,0,0,1-.54,0c-.15-.09-.15-.23,0-.31A.57.57,0,0,1,281.29,200.55Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 282.45,
    cy: 199.88,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.15,198.9c.15.08.15.22,0,.31a.59.59,0,0,1-.55,0c-.15-.09-.15-.23,0-.31A.59.59,0,0,1,284.15,198.9Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.58,198.07a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.59.59,0,0,1,285.58,198.07Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287,197.25a.16.16,0,0,1,0,.31.59.59,0,0,1-.55,0,.16.16,0,0,1,0-.31A.59.59,0,0,1,287,197.25Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.43,196.74a.57.57,0,0,1-.54,0,.17.17,0,0,1,0-.32.64.64,0,0,1,.54,0c.16.09.16.23,0,.32Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.46,201.37a.59.59,0,0,1,.55,0,.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0A.17.17,0,0,1,276.46,201.37Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.44,200.55c.15.08.15.22,0,.31a.59.59,0,0,1-.55,0c-.15-.09-.15-.23,0-.31A.59.59,0,0,1,278.44,200.55Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.87,199.72a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.59.59,0,0,1,279.87,199.72Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.29,198.9c.16.08.16.22,0,.31a.57.57,0,0,1-.54,0c-.15-.09-.15-.23,0-.31A.57.57,0,0,1,281.29,198.9Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.72,198.07a.17.17,0,0,1,0,.32.64.64,0,0,1-.54,0,.17.17,0,0,1,0-.32A.57.57,0,0,1,282.72,198.07Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.15,197.25a.16.16,0,0,1,0,.31.59.59,0,0,1-.55,0,.16.16,0,0,1,0-.31A.59.59,0,0,1,284.15,197.25Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.58,196.42a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,285.58,196.42Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287,195.6c.15.09.15.23,0,.31a.59.59,0,0,1-.55,0c-.15-.08-.15-.22,0-.31A.59.59,0,0,1,287,195.6Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275,200.55a.57.57,0,0,1,.54,0c.15.08.15.22,0,.31a.57.57,0,0,1-.54,0C274.89,200.77,274.88,200.63,275,200.55Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277,199.72a.17.17,0,0,1,0,.32.64.64,0,0,1-.54,0c-.16-.09-.16-.23,0-.32A.57.57,0,0,1,277,199.72Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 278.17,
    cy: 199.05,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 279.59,
    cy: 198.23,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.29,197.25c.16.08.16.23,0,.31a.57.57,0,0,1-.54,0,.16.16,0,0,1,0-.31A.57.57,0,0,1,281.29,197.25Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.72,196.42a.17.17,0,0,1,0,.32.57.57,0,0,1-.54,0,.17.17,0,0,1,0-.32A.64.64,0,0,1,282.72,196.42Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.15,195.6c.15.09.15.23,0,.31a.59.59,0,0,1-.55,0c-.15-.08-.15-.22,0-.31A.59.59,0,0,1,284.15,195.6Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.58,194.77a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,285.58,194.77Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.61,199.72a.57.57,0,0,1,.54,0c.15.09.16.23,0,.32a.64.64,0,0,1-.54,0A.17.17,0,0,1,273.61,199.72Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.58,198.9c.15.08.15.22,0,.31a.57.57,0,0,1-.54,0c-.15-.09-.15-.23,0-.31A.57.57,0,0,1,275.58,198.9Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277,198.07a.17.17,0,0,1,0,.32.64.64,0,0,1-.54,0c-.16-.09-.16-.23,0-.32A.57.57,0,0,1,277,198.07Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.44,197.25a.16.16,0,0,1,0,.31.59.59,0,0,1-.55,0,.16.16,0,0,1,0-.31A.59.59,0,0,1,278.44,197.25Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.87,196.42a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,279.87,196.42Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.29,195.6c.16.09.16.23,0,.31a.57.57,0,0,1-.54,0c-.15-.08-.15-.22,0-.31A.57.57,0,0,1,281.29,195.6Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.72,194.77a.17.17,0,0,1,0,.32.57.57,0,0,1-.54,0,.17.17,0,0,1,0-.32A.64.64,0,0,1,282.72,194.77Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 283.88,
    cy: 194.11,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.17,198.89a.57.57,0,0,1,.54,0c.15.09.15.23,0,.31a.57.57,0,0,1-.54,0C272,199.12,272,199,272.17,198.89Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.14,198.06a.17.17,0,0,1,0,.32.57.57,0,0,1-.54,0,.17.17,0,0,1,0-.32A.64.64,0,0,1,274.14,198.06Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.57,197.24c.15.09.15.23,0,.31a.59.59,0,0,1-.55,0c-.15-.08-.15-.22,0-.31A.59.59,0,0,1,275.57,197.24Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277,196.41a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,277,196.41Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.43,195.59a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.59.59,0,0,1,278.43,195.59Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.85,194.77c.16.08.16.22,0,.31a.57.57,0,0,1-.54,0c-.15-.09-.15-.23,0-.31A.57.57,0,0,1,279.85,194.77Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.28,193.94a.17.17,0,0,1,0,.32.64.64,0,0,1-.54,0,.17.17,0,0,1,0-.32A.57.57,0,0,1,281.28,193.94Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.74,198.06a.66.66,0,0,1,.55,0,.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0A.17.17,0,0,1,270.74,198.06Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.72,197.24c.15.09.15.23,0,.31a.59.59,0,0,1-.55,0c-.15-.08-.15-.22,0-.31A.59.59,0,0,1,272.72,197.24Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.14,196.41a.17.17,0,0,1,0,.32.57.57,0,0,1-.54,0,.17.17,0,0,1,0-.32A.64.64,0,0,1,274.14,196.41Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.57,195.59a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.59.59,0,0,1,275.57,195.59Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277,194.77c.15.08.15.22,0,.31a.59.59,0,0,1-.55,0c-.15-.09-.15-.23,0-.31A.59.59,0,0,1,277,194.77Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.43,193.94a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.59.59,0,0,1,278.43,193.94Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.31,197.24a.59.59,0,0,1,.55,0c.15.09.15.23,0,.31a.63.63,0,0,1-.55,0A.17.17,0,0,1,269.31,197.24Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.29,196.41a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,271.29,196.41Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.72,195.59a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.59.59,0,0,1,272.72,195.59Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.14,194.77c.15.08.15.22,0,.31a.57.57,0,0,1-.54,0c-.15-.09-.15-.23,0-.31A.57.57,0,0,1,274.14,194.77Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.57,193.94a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.59.59,0,0,1,275.57,193.94Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277,193.12a.16.16,0,0,1,0,.31.59.59,0,0,1-.55,0,.16.16,0,0,1,0-.31A.59.59,0,0,1,277,193.12Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.43,192.29a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,278.43,192.29Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.88,196.42a.59.59,0,0,1,.55,0c.15.08.15.22,0,.31a.59.59,0,0,1-.55,0C267.73,196.64,267.73,196.5,267.88,196.42Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.86,195.59a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.59.59,0,0,1,269.86,195.59Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.29,194.77c.15.08.15.22,0,.31a.59.59,0,0,1-.55,0c-.15-.09-.15-.23,0-.31A.59.59,0,0,1,271.29,194.77Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.72,193.94a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.59.59,0,0,1,272.72,193.94Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.14,193.12a.16.16,0,0,1,0,.31.57.57,0,0,1-.54,0,.16.16,0,0,1,0-.31A.57.57,0,0,1,274.14,193.12Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.57,192.29a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,275.57,192.29Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277,191.47c.15.09.15.23,0,.31a.59.59,0,0,1-.55,0c-.15-.08-.15-.22,0-.31A.59.59,0,0,1,277,191.47Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.43,190.64a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,278.43,190.64Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.46,195.59a.57.57,0,0,1,.54,0,.17.17,0,0,1,0,.32.64.64,0,0,1-.54,0C266.31,195.82,266.3,195.68,266.46,195.59Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.43,194.77c.15.08.15.22,0,.31a.57.57,0,0,1-.54,0c-.16-.09-.16-.23,0-.31A.57.57,0,0,1,268.43,194.77Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.86,193.94a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.59.59,0,0,1,269.86,193.94Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.29,193.12a.16.16,0,0,1,0,.31.59.59,0,0,1-.55,0,.16.16,0,0,1,0-.31A.59.59,0,0,1,271.29,193.12Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.72,192.29a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,272.72,192.29Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 273.87,
    cy: 191.63,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.57,190.64a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,275.57,190.64Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277,189.82c.15.09.15.23,0,.31a.59.59,0,0,1-.55,0c-.15-.08-.15-.22,0-.31A.59.59,0,0,1,277,189.82Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.43,189a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,278.43,189Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265,194.77a.57.57,0,0,1,.54,0c.15.08.16.22,0,.31a.57.57,0,0,1-.54,0A.16.16,0,0,1,265,194.77Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 266.73,
    cy: 194.1,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.43,193.12a.16.16,0,0,1,0,.31.57.57,0,0,1-.54,0c-.16-.08-.16-.23,0-.31A.57.57,0,0,1,268.43,193.12Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.86,192.29a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,269.86,192.29Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.29,191.47c.15.09.15.23,0,.31a.59.59,0,0,1-.55,0c-.15-.08-.15-.22,0-.31A.59.59,0,0,1,271.29,191.47Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.72,190.64a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,272.72,190.64Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.14,189.82c.15.09.15.23,0,.31a.57.57,0,0,1-.54,0c-.15-.08-.15-.22,0-.31A.57.57,0,0,1,274.14,189.82Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.57,189a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,275.57,189Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277,188.17a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.59.59,0,0,1,277,188.17Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.43,187.35c.15.08.15.22,0,.31a.59.59,0,0,1-.55,0c-.15-.09-.15-.23,0-.31A.59.59,0,0,1,278.43,187.35Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.6,193.94a.62.62,0,0,1,.55,0,.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0A.17.17,0,0,1,263.6,193.94Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.58,193.12a.16.16,0,0,1,0,.31.59.59,0,0,1-.55,0,.16.16,0,0,1,0-.31A.59.59,0,0,1,265.58,193.12Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267,192.29a.17.17,0,0,1,0,.32.64.64,0,0,1-.54,0,.17.17,0,0,1,0-.32A.64.64,0,0,1,267,192.29Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.43,191.47c.15.09.15.23,0,.31a.57.57,0,0,1-.54,0c-.16-.08-.16-.22,0-.31A.57.57,0,0,1,268.43,191.47Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.86,190.64a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,269.86,190.64Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.29,189.82c.15.09.15.23,0,.31a.59.59,0,0,1-.55,0c-.15-.08-.15-.22,0-.31A.59.59,0,0,1,271.29,189.82Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.72,189a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,272.72,189Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.14,188.17a.17.17,0,0,1,0,.32.64.64,0,0,1-.54,0,.17.17,0,0,1,0-.32A.57.57,0,0,1,274.14,188.17Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275,187.35a.59.59,0,0,1,.55,0c.15.08.15.22,0,.31a.59.59,0,0,1-.55,0c-.15-.09-.15-.23,0-.31Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.17,193.12a.59.59,0,0,1,.55,0,.16.16,0,0,1,0,.31.59.59,0,0,1-.55,0C262,193.35,262,193.21,262.17,193.12Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.15,192.29a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,264.15,192.29Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 265.3,
    cy: 191.63,
    rx: 0.39,
    ry: 0.22,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267,190.64a.17.17,0,0,1,0,.32.57.57,0,0,1-.54,0,.17.17,0,0,1,0-.32A.64.64,0,0,1,267,190.64Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.43,189.82c.15.09.15.23,0,.31a.57.57,0,0,1-.54,0c-.16-.08-.16-.22,0-.31A.57.57,0,0,1,268.43,189.82Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.86,189a.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0,.17.17,0,0,1,0-.32A.66.66,0,0,1,269.86,189Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.29,188.17a.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32A.59.59,0,0,1,271.29,188.17Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.73,192.28a.66.66,0,0,1,.55,0,.17.17,0,0,1,0,.32.59.59,0,0,1-.55,0A.17.17,0,0,1,260.73,192.28Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.71,191.46c.15.09.15.23,0,.31a.59.59,0,0,1-.55,0c-.15-.08-.15-.22,0-.31A.59.59,0,0,1,262.71,191.46Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.14,190.64c.15.08.15.22,0,.31a.59.59,0,0,1-.55,0c-.15-.09-.15-.23,0-.31A.59.59,0,0,1,264.14,190.64Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.56,189.81a.17.17,0,0,1,0,.32.64.64,0,0,1-.54,0,.17.17,0,0,1,0-.32A.57.57,0,0,1,265.56,189.81Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.44,189a.59.59,0,0,1,.55,0c.15.08.15.22,0,.31a.59.59,0,0,1-.55,0c-.15-.09-.15-.23,0-.31Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.3,191.46a.59.59,0,0,1,.55,0,.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0A.17.17,0,0,1,259.3,191.46Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.28,190.64c.15.08.15.22,0,.31a.59.59,0,0,1-.55,0c-.15-.09-.15-.23,0-.31A.59.59,0,0,1,261.28,190.64Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.16,189.81a.59.59,0,0,1,.55,0,.17.17,0,0,1,0,.32.66.66,0,0,1-.55,0,.17.17,0,0,1,0-.32Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.88,190.64a.57.57,0,0,1,.54,0c.15.08.15.22,0,.31a.57.57,0,0,1-.54,0C257.73,190.86,257.73,190.72,257.88,190.64Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "246.55 211.75 284.27 190.11 246.62 167.46 207.85 189.2 246.55 211.75",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "248.73 166.78 207.85 190.38 246.55 212.93 283.3 191.85",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "207.75 190.48 207.84 193.33 246.26 215.8 246.26 212.96 207.75 190.48",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.24,216l-38.53-22.53-.11-3.2.23.13,38.59,22.53Zm-38.18-22.71,38.2,22.3v-2.49L208,190.74Z",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.24,216l-.11-3.07.13,0L285,190.71l-.11,3.22h0Z",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "285.06 189.64 246.26 211.75 246.26 212.96 284.99 190.71 285.06 189.64",
    style: {
      fill: "#140f0c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.57,211.83v.88l38.42-22,.07-1.07Z",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "246.28 212.96 246.55 211.75 207.85 189.2 207.76 190.48 246.28 212.96",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.64,191.17l-36.09,20.4L232,203.11,208.14,189.2l39.35-20.48,36.78,21.39.79-.47-37.5-22-39.85,21.48-.11,1.45,38.6,22.53.18.1.3-1.35m-.5.89L207.91,190.4l.07-1,38.4,22.37Z",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "252.32 209.48 252.18 209.22 284.99 190.71 284.89 191.03 252.32 209.48",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.39,175.33a.27.27,0,0,0,0-.12.64.64,0,0,0-.06-.18c-.09-.16-.24-.23-.36-.16l-8.89,5a.23.23,0,0,0-.09.12.35.35,0,0,0,0,.24v3.06c0,.13.13.23.31.23s.32-.1.32-.23v-1.9l8.07-4.58v1.56c0,.13.14.23.32.23s.31-.1.31-.23Zm-8.7,5,8.07-4.58v.4l-8.07,4.58Z",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.47,181a.33.33,0,0,0,0-.27.28.28,0,0,0-.36-.16l-8.89,5c-.11.06-.13.21-.06.36v3.05c0,.14.14.24.32.24s.31-.1.31-.24v-1.89l8.08-4.58v1.55c0,.14.13.23.31.23s.32-.09.32-.23,0-2,0-2,0-1.09,0-1.09S218.47,181,218.47,181Zm-8.72,5,8.08-4.58v.4l-8.08,4.59Z",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.06 192.59 219.06 191.93 221.23 190.55 221.47 191.35 219.06 192.59",
    style: {
      fill: "#140f0c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.06 192.59 219.06 191.93 214.42 189.2 214.42 189.93 219.06 192.59",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.53 189.2 219.02 186.6 221.72 188.19 221.71 190.43 219.16 191.93 214.53 189.2",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "215.07 189.51 219.02 187.19 221.72 188.78 221.71 190.43 219.16 191.93 215.07 189.51",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.87,188.11,219,186.43l-4.53,2.63V190l4.57,2.75,2.52-1.39v-.69l.28-.16ZM219,186.78l2.55,1.5v2l-2.45,1.43L217,190.46l-2.09-1.29Zm-4.24,3.06v-.33l2,1.2,2.12,1.3v.32Zm6.5,1.35-2.07,1.15v-.27l2.07-1.21Z",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.37,185a1.1,1.1,0,0,1,.41-.86h0l3.09-1.9.08,0c.17,0,.35.27.38.48a.36.36,0,0,1-.18.41h0l-2.53,1.46c-.3.18-.37.27-.37.52v.05h0l.05,4.17v0a.4.4,0,0,1-.44.34c-.25,0-.45-.13-.45-.32a.43.43,0,0,1,0-.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.86,189.8a.54.54,0,0,1-.6-.48.66.66,0,0,1,0-.13l-.06-4.24a1.26,1.26,0,0,1,.49-1l3.09-1.9a.27.27,0,0,1,.14,0,.34.34,0,0,1,.25.07.87.87,0,0,1,.3.54.5.5,0,0,1-.27.57l-2.51,1.46c-.26.15-.29.2-.3.34v.09l0,4.17s0,0,0,0A.56.56,0,0,1,219.86,189.8Zm-.34-4.85.06,4.28v.09c0,.09.13.17.29.17s.29-.09.29-.19l-.06-4.26c0-.32.12-.45.45-.65l2.53-1.47a.21.21,0,0,0,.1-.25.51.51,0,0,0-.2-.35h0l-3.08,1.89A1,1,0,0,0,219.52,185Z",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "221.43 177.34 231.23 171.93 240.44 177.14 230.95 182.6 221.43 177.34",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "221.43 178.52 231.23 173.11 240.44 178.32 230.95 183.79 221.43 178.52",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.31 191.56 260.26 177.2 255.57 168.38 230.95 182.6 235.31 191.56",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.25,191.76l-4.49-9.21.11-.07,24.76-14.3,4.83,9.08Zm-4.11-9.1,4.24,8.69,24.68-14.21-4.55-8.55Z",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.16 191.56 235.16 201.48 259.87 187.29 259.76 177.34 235.16 191.56",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "230.77 182.6 235.16 191.56 235.16 201.48 221.57 193.57 221.23 177.34 230.77 182.6",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.1,187.38l-.08-10.3-24.64,14.27-4.24-8.69,9.6-5.52-9.51-5.38-9.95,5.49v16.37l14,8Zm-.29-.17-24.35,14v-9.58l24.27-14ZM231.23,172.1l8.91,5-9.19,5.3-9.22-5.1Zm-9.65,21.35V177.59l9.26,5.12,4.33,8.88v9.63Z",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.67,186.65h0L238,179.76l-4.64,2.66,2.93,5.84h0l.6,1.18Zm-1.48.52L237,189l-.33-.66,3.75-2.22.41.25.33.19Zm-1.95-3,.66-.37.39.72-.75.42-.34-.67Zm-.65-3.78.3-.17,3.2,6-.27-.16-.27-.16Zm-3.83,2.2,3.57-2.06,1.57,2.93-.8.45-.5-.92-.91.52-.5-.93-.91.53-.5-.93-.95.55Zm4.05,1.56-.68.39-.34-.67,0-.1.66-.37.36.66Zm-1.41-.4-.68.39-.34-.67,0-.1.66-.38.36.67Zm-1.41-.4-.67.37L234,183l.71-.41.36.67Zm-.53.64.66-.38.47.93.94-.53.47.94.94-.53.47.93,1.16-.65.67,1.27-3.68,2.19Z",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.25,177.25h0l-3.66-6.89L250,173l2.93,5.84h0l.6,1.19Zm-1.47.52-3.18,1.86-.33-.66,3.75-2.22.42.25.33.2Zm-1.95-3,.65-.38.39.72-.75.42-.34-.67Zm-.66-3.79.3-.17,3.2,6-.27-.16-.27-.16Zm-3.83,2.2,3.58-2,1.56,2.92-.79.46-.5-.93-.91.52-.5-.92-.92.52-.49-.93-1,.55Zm4,1.56-.68.39-.34-.67,0-.1.65-.37.36.66Zm-1.41-.4-.68.39L252,174l0-.1.65-.38.36.67Zm-1.41-.4-.66.37-.37-.72.71-.41.36.67Zm-.53.64.66-.38.47.94,1-.53.46.93.95-.53.47.93,1.15-.65.68,1.27-3.69,2.19Z",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.72,180.39h0l-3.66-6.9-4.64,2.67,2.94,5.83h0l.59,1.19Zm-1.47.52-3.18,1.85-.33-.65,3.76-2.23.41.25.33.2Zm-1.95-3,.65-.38.39.72-.75.43-.33-.67Zm-.65-3.79.29-.17,3.2,6-.27-.17-.26-.16Zm-3.84,2.2,3.58-2.05,1.56,2.92-.79.46-.5-.93-.91.52-.5-.92-.91.52-.5-.92-1,.54Zm4.06,1.57-.69.38-.33-.67,0-.09.65-.38.36.66Zm-1.42-.41-.68.39-.34-.67,0-.1.65-.37.36.66ZM246,177l-.66.38-.37-.73.71-.41.36.67Zm-.53.64.67-.37.47.93.94-.53.47.93.94-.53.47.93,1.15-.64.68,1.26-3.69,2.19Z",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.2,183.52h0l-3.67-6.9-4.64,2.67,2.94,5.84h0l.59,1.18Zm-1.48.52-3.17,1.86-.33-.66L246,183l.41.25.33.2Zm-1.95-3,.66-.38.38.73-.75.42-.33-.67Zm-.65-3.79.3-.17,3.2,6-.27-.16-.27-.17Zm-3.84,2.21,3.58-2.06,1.57,2.92-.8.46-.5-.93-.91.53-.5-.93-.91.52-.5-.92-1,.55Zm4.06,1.56-.69.38-.33-.66,0-.1.66-.38.35.67Zm-1.41-.4-.69.38-.33-.67,0-.1.65-.37.36.66Zm-1.41-.41-.67.38-.36-.73.7-.4.36.66Zm-.54.64.67-.37.47.93.94-.53.47.93.94-.53.47.94,1.15-.65.68,1.26-3.69,2.2Z",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "221.85 181.03 233.08 187.43 234.66 190.55 221.85 183.22 221.85 181.03",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.71,190.13l-13.48-7.71v-2.53L233,186.63Zm-13.17-7.88L234,189.39l-1.25-2.55-11.24-6.44Z",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.36 163.34 246.34 157.01 255.55 162.21 244.68 168.6 235.36 163.34",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.36 164.22 246.34 157.89 255.55 163.1 244.68 169.49 235.36 164.22",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.36 163.34 231.23 171.93 240.44 177.14 244.68 168.6 235.36 163.34",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.48 177.1 244.68 168.6 255.55 162.21 255.57 168.38 240.48 177.1",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.7,162.13l-9.36-5.29-11.1,6.39L231,172l9.39,5.31,15.29-8.83Zm-9.36-4.95,8.92,5-10.59,6.22-9-5.1Zm-10.92,6.36,9.06,5.12-4.1,8.27-9-5.06Zm9.37,5.17,10.61-6.24,0,5.83-14.59,8.43Z",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "242.3 167.26 237.95 169.7 237.94 176.11 238.26 175.91 242.3 167.26",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "237.95 169.7 233.88 167.32 238.1 164.89 242.3 167.26 237.95 169.7",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "237.94 170.58 233.87 168.2 238.1 165.77 241.63 167.77 237.94 169.7 237.94 170.58",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.61 167.32 233.61 173.99 237.94 176.25 237.94 169.7 233.61 167.32",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.49,167.2l-4.39-2.48-4.41,2.53v6.83l4.1,2.24v.05l0,0,.29-.18.26-.16Zm-8.32.12,3.93-2.26,3.9,2.2-1.48.83L238,169.52l-1.43-.82ZM234,173.9v-6.33l2.4,1.39,1.41.82V176Zm8-6.29-3.82,8.19,0,0v-6l2.06-1.15Z",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.63,176.15l-3.09-1.62v-5.61l3.09,1.54Zm-2.78-1.8,2.47,1.3v-5l-2.47-1.24Z",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.77 170.85 235.77 172.88 237.32 173.62 237.32 171.59 235.77 170.85",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,173.26l-1.85-.88V170l1.85.88Zm-1.55-1.06,1.24.59v-1.7l-1.24-.59Z",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.06,199.71l-7.74-4.54v-9.55l7.74,4.56ZM224.63,195l7.12,4.19v-8.84l-7.12-4.21Z",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.94 186.37 224.94 194.65 224.32 195.08 224.32 185.88 224.94 186.37",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.32,195.17v-9.6l.93.73v8.43Zm.31-9v8.59l.31-.21v-8.14Z",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.06,199.83l-8-4.75,1.15-.59,6.86,4Zm-7.41-4.74,7.1,4.22v-.67l-6.57-3.82Z",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.42 185.83 224.42 187.41 231.77 191.81 231.77 190.27 224.42 185.83",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.83 186.65 224.83 187.76 231.77 191.84 231.77 190.86 224.83 186.65",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.92,192.07l-7.65-4.58v-1.92l7.65,4.61Zm-7.36-4.75,7.06,4.23v-1.2l-7.05-4.26Z",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "251.39 192.31 250.16 190.34 267.21 180.52 268.52 182.31 251.39 192.31",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "251.34 200.96 243.74 196.68 243.83 186.74 250.16 190.34 251.39 192.31 251.34 200.96",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.91 161.23 238.89 158.91 244.44 162.01 244.44 164.45 238.91 161.23",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "244.44 162.01 249.39 158.91 249.39 161.42 244.44 164.45 244.44 162.01",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.86 158.91 244.29 155.72 249.73 158.91 244.4 162.01 238.86 158.91",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.88 159.5 244.3 156.31 249.14 159.14 244.44 162.01 244.44 162.6 238.88 159.5",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.64,159.13l.38-.22-.38-.22v0l0,0-5.32-3.12-5.53,3.25,0,2.51,5.7,3.31,5.16-3.12Zm-5.35-3.24,5,3-3.74,2.3-1.14.67-5.26-2.93Zm-5.22,5.25V159.2l5.27,2.93v2.06Zm5.55,3.05v-2.1l1.12-.69,3.61-2.1v2Z",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.63,158.51c.44.05.61.24.61.5,0,0,0,0,0,0l1.3.63a1,1,0,0,0,.21-.61c0-.8-1-1.46-2.27-1.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.59,159.57l-1.55-.75,0-.1h0c0-.08,0-.3-.46-.35h-.1l-.2-1.26h.18c1.38.07,2.41.79,2.41,1.68a1.14,1.14,0,0,1-.23.69Zm-1.21-.92,1.11.54a.94.94,0,0,0,.11-.42c0-.68-.84-1.26-1.95-1.37l.11.68C245.25,158.17,245.37,158.45,245.38,158.65Z",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.86,159.44a1,1,0,0,1-.57.1,1.06,1.06,0,0,1-.56-.1l-1.35.58a3.14,3.14,0,0,0,1.91.58,3,3,0,0,0,2-.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.29,160.45a3.31,3.31,0,0,1-2-.61l-.19-.16,1.65-.7.06,0a.86.86,0,0,0,.49.09c.27,0,.36,0,.49-.09l.06,0,1.75.61-.19.17A3.26,3.26,0,0,1,244.29,160.45Zm-1.61-.7a3.15,3.15,0,0,0,1.61.4,3.2,3.2,0,0,0,1.7-.45l-1.12-.4a1.08,1.08,0,0,1-.58.1,1.2,1.2,0,0,1-.56-.1Z",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.35,159s0,0,0,0a.63.63,0,0,1,.61-.62l.15-.85c-1.27.06-2.27.72-2.27,1.52a1.12,1.12,0,0,0,.27.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.08,159.66l-.09-.1a1.32,1.32,0,0,1-.3-.79c0-.89,1-1.61,2.41-1.68h.19l-.2,1.14H244a.49.49,0,0,0-.48.45l0,.08,0,0v0l-.13,0Zm1.85-2.26c-1.1.11-1.94.69-1.94,1.37a.87.87,0,0,0,.16.5l1-.63,0,0a.76.76,0,0,1,.62-.63Z",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.25,158.71c0,.3-.43.54-.95.54s-1-.24-1-.54.25-.77.58-.86c.12,0,.23.33.37.33s.24-.36.37-.33A1.16,1.16,0,0,1,245.25,158.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.3,159.4c-.61,0-1.09-.3-1.09-.69s.26-.89.68-1c.16,0,.26.1.34.21l.07.09.07-.09c.07-.11.17-.26.33-.21a1.25,1.25,0,0,1,.69,1C245.39,159.1,244.91,159.4,244.3,159.4Zm-.37-1.39a1,1,0,0,0-.43.7c0,.19.33.39.8.39s.8-.2.8-.39a1.11,1.11,0,0,0-.43-.7l-.06.07c-.07.11-.16.25-.31.25s-.24-.14-.31-.24Z",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245,158.16c0,.21-.3.37-.66.37s-.66-.16-.66-.37.3-.37.66-.37S245,158,245,158.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.3,158.68c-.46,0-.8-.22-.8-.52s.34-.52.8-.52.81.23.81.52S244.75,158.68,244.3,158.68Zm0-.74c-.31,0-.51.13-.51.22s.2.22.51.22.51-.13.51-.22S244.61,157.94,244.3,157.94Z",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "244.3 158.53 244.3 159.25 245.1 159.07 245.3 158.68 244.96 158.16 244.63 158.51 244.3 158.53",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.13,173.91a.37.37,0,0,0,0-.17c-.09-.16-.24-.23-.36-.17L231,178.5l-7-4,6.9-3.91v1.66c0,.14.13.24.32.24s.31-.1.31-.24,0-3.19,0-3.29l0-.05a.27.27,0,0,0-.35-.15s-8.79,5-8.85,5l0,0a.21.21,0,0,0-.09.13.14.14,0,0,0,0,.09s0,0,0,0v3.24c0,.13.13.23.31.23s.32-.1.32-.23v-1.71l7.92,4.57V182c0,.13.14.23.32.23s.31-.1.31-.23v-1.9l8.08-4.58v1.55c0,.14.13.24.31.24s.32-.1.32-.24S240.13,174,240.13,173.91Zm-16.91.09,7.75-4.4v.24l-7.53,4.28Zm.21.84,7.34,4.23v.32L223.15,175Zm8,4.21,0,0,8.06-4.58v.41l-8.08,4.58Z",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.09 174.5 238.09 175.2 238.57 174.95 238.96 174 238.09 174.5",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.09 175.65 238.09 176.07 238.31 175.95 238.47 175.44 238.09 175.65",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "267.14 188.83 267.21 187.03 271.37 189.35 271.36 191.17 267.14 188.83",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "271.37 189.35 275.37 187.03 275.34 188.87 271.37 191.17 271.37 189.35",
    style: {
      fill: "#130e0c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "267.21 187.03 271.29 184.63 275.37 187.03 271.37 189.35 267.21 187.03",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "267.21 187.62 271.29 185.22 274.82 187.3 271.37 189.35 271.37 189.94 267.21 187.62",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.52,186.94l-4.23-2.48-4.08,2.4-.14-.08v.16l-.16.09.15.08-.07,1.8,4.37,2.43,4.12-2.39Zm-4.23-2.14,3.79,2.23-3.71,2.15L267.51,187Zm-4,3.94.06-1.47,3.86,2.16v1.49Zm4.22,2.18v-1.48l3.69-2.15,0,1.49Z",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.55,186.8c.32,0,.45.18.45.37,0,0,0,0,0,0l1,.47a.77.77,0,0,0,.15-.46c0-.6-.75-1.1-1.7-1.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273,187.57l-1.2-.54h-.15v0l.05,0,.08-.1s0-.19-.3-.23h-.1l-.16-1h.19c1.05.05,1.84.6,1.84,1.29a.92.92,0,0,1-.18.54Zm-.88-.76.77.38a.54.54,0,0,0,.07-.27c0-.48-.6-.9-1.38-1l.07.43C272,186.45,272.13,186.65,272.15,186.81Z",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.72,187.49a.69.69,0,0,1-.43.09.77.77,0,0,1-.42-.09l-1,.44a2.41,2.41,0,0,0,1.44.43,2.28,2.28,0,0,0,1.51-.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.29,188.22a2.51,2.51,0,0,1-1.53-.47l-.19-.15,1.31-.57.06,0a.69.69,0,0,0,.35.06c.2,0,.26,0,.35-.06l.06,0,1.39.48-.19.17A2.47,2.47,0,0,1,271.29,188.22Zm-1.13-.56a2.39,2.39,0,0,0,1.13.26,2.5,2.5,0,0,0,1.2-.29l-.76-.27a1.36,1.36,0,0,1-.86,0Z",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.58,187.17s0,0,0,0a.48.48,0,0,1,.46-.46l.11-.64c-.95,0-1.7.54-1.7,1.14a.89.89,0,0,0,.2.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.62,187.63l-.08-.1a.92.92,0,0,1-.24-.61c0-.69.8-1.24,1.85-1.29h.18l-.16.93h-.11a.33.33,0,0,0-.33.29l0,.09,0,0v0l-.13,0Zm1.36-1.69c-.79.09-1.38.5-1.38,1a.62.62,0,0,0,.09.32l.72-.43,0-.05a.61.61,0,0,1,.46-.47Z",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272,186.88c0,.22-.32.4-.71.4s-.71-.18-.71-.4a.86.86,0,0,1,.43-.65c.09,0,.17.25.28.25s.18-.27.27-.25A.87.87,0,0,1,272,186.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.3,187.43c-.48,0-.86-.24-.86-.55a1,1,0,0,1,.54-.79c.15,0,.24.09.29.17l0,0,0,0c.05-.08.14-.21.29-.17a1,1,0,0,1,.55.79C272.16,187.19,271.78,187.43,271.3,187.43Zm-.29-1a.77.77,0,0,0-.27.48c0,.1.21.25.56.25s.56-.15.56-.25a.81.81,0,0,0-.28-.48l0,0a.33.33,0,0,1-.26.19c-.13,0-.21-.11-.27-.19Z",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.79,186.46c0,.16-.22.28-.49.28s-.5-.12-.5-.28.23-.28.5-.28S271.79,186.31,271.79,186.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.3,186.89c-.37,0-.64-.18-.64-.43s.27-.42.64-.42.64.18.64.42S271.66,186.89,271.3,186.89Zm0-.56c-.23,0-.35.1-.35.13s.12.13.35.13.34-.09.34-.13S271.52,186.33,271.3,186.33Z",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "271.22 186.74 271.22 187.36 271.69 187.28 271.98 186.99 271.82 186.56 271.51 186.76 271.22 186.74",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.84,188.49l-2.76.08,0,3.28h0c.07.62.64.74,1.32.74s1.26-.12,1.33-.74h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.45,192.48c-.32,0-1.26.15-1.44-.74l0-.14,0-3.37,3.06,0-.09,3.53C278.71,192.63,277.77,192.48,277.45,192.48Zm-1.18-.95v.05c0,.28.2.61,1.17.61s1.15-.33,1.18-.61v-.07l.05-3h-2.46Z",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.84,188.21c0,.48-.62.87-1.39.87s-1.39-.39-1.39-.87.63-.86,1.39-.86S278.84,187.73,278.84,188.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.45,187.94a1.52,1.52,0,0,0-1.3.57,1.52,1.52,0,0,0,1.3.57,1.54,1.54,0,0,0,1.31-.57A1.54,1.54,0,0,0,277.45,187.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.45,189.23c-.86,0-1.53-.45-1.53-1s.67-1,1.53-1,1.54.44,1.54,1S278.32,189.23,277.45,189.23Zm0-1.74c-.67,0-1.24.33-1.24.72s.57.72,1.24.72,1.25-.33,1.25-.72S278.13,187.49,277.45,187.49Z",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.63,189.08v3.23l.7-.12.44-.38v-3.24a2.61,2.61,0,0,1-.37.25Z",
    style: {
      fill: "#120d0c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,185.07h-2.77l0,3.21h0a1.56,1.56,0,0,0,2.65,0h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.65,189.17a1.88,1.88,0,0,1-1.43-.74l-.05-.18,0-3.38h3.07l-.12,3.55A1.86,1.86,0,0,1,213.65,189.17Zm-1.19-1v0a1.31,1.31,0,0,0,1.18.64,1.33,1.33,0,0,0,1.18-.63v0l.06-3h-2.47Z",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,185c0,.48-.63.87-1.39.87s-1.39-.39-1.39-.87.62-.86,1.39-.86S215,184.48,215,185Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.65,184.68a1.52,1.52,0,0,0-1.3.57,1.78,1.78,0,0,0,2.61,0A1.53,1.53,0,0,0,213.65,184.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.65,186c-.87,0-1.54-.45-1.54-1s.67-1,1.54-1,1.53.45,1.53,1S214.51,186,213.65,186Zm0-1.74c-.68,0-1.25.33-1.25.72s.57.73,1.25.73,1.24-.33,1.24-.73S214.32,184.23,213.65,184.23Z",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "213.9 185.84 213.9 189.07 214.51 188.77 214.97 188.43 215.03 185.25 214.24 185.78 213.9 185.84",
    style: {
      fill: "#140f0c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "251.31 192.31 251.22 201.11 267.96 191.19 267.96 182.31 251.31 192.31",
    style: {
      fill: "#140f0c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.2,201.2l0-9,.08,0,16.95-10.14v9.22l-.08,0-16.86,10Zm.33-8.8-.05,8.45L268,191.1v-8.52Z",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "267.21 180.52 260.9 176.83 243.83 186.74 250.16 190.34 267.21 180.52",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "267.21 181.7 260.9 178.01 243.83 187.92 250.16 191.53 267.21 181.7",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.55,182.05l-1.24-1.65-6.41-3.74-17.21,10-.1,10.11,7.61,4.44.28-.35.06-8.45,17-9.94Zm-17.11,10.06-1.07-1.72,16.8-9.68,1.14,1.56Zm-7.31-5.37L260.9,177l6,3.51-16.75,9.66-4.6-2.62Zm-.24,9.85L244,187l1.57.9,4.51,2.56,1.18,1.9-.05,8.5Z",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.82,192.71l0-8.93,2.79-1.73v9Z",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.62,190.8l-1.14-.61-2.4,1.39v2.28l1.11.67,2.43-1.37Zm-1.14-.35.73.39-2,1.16-.71-.39Zm-2.11,3.24v-1.81l.67.37v1.85Zm3-.7-2,1.12v-1.86l2-1.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.52,194.58a1.2,1.2,0,0,0-.44-.92h0l-3.33-2-.08,0c-.18,0-.41.28-.45.51s0,.36.15.42h0l2.76,1.56c.33.19.42.28.42.55,0,0,0,0,0,.06h0l0,4.43v0a.44.44,0,0,0,.48.37c.27,0,.48-.14.48-.35a.41.41,0,0,0,0-.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264,199.71a.58.58,0,0,1-.62-.52v-.05l.05-4.34v-.13c0-.18,0-.23-.35-.42l-2.76-1.56c-.12,0-.28-.19-.22-.57s.32-.68.61-.64a.27.27,0,0,1,.13,0l3.44,2a1.39,1.39,0,0,1,.61,1h0l-.17,4.5s0,.1,0,.13C264.67,199.49,264.35,199.71,264,199.71Zm-.29-5.09h0v.11l0,4.43v0c0,.12.15.22.33.22s.33-.09.33-.2v-.11l.06-4.52a1,1,0,0,0-.36-.79l-3.33-2h0c-.06,0-.25.2-.28.39s0,.24.05.27l2.79,1.56C263.52,194.18,263.68,194.31,263.7,194.62Z",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.29,193.4a1.15,1.15,0,0,0-.44-.92h0l-3.32-2-.09,0c-.18,0-.41.29-.44.51s0,.37.14.43h0l2.77,1.56c.32.19.42.28.42.55,0,0,0,0,0,.06h0l0,4.42v0a.44.44,0,0,0,.48.37c.26,0,.47-.15.47-.35a.41.41,0,0,0,0-.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.77,198.53a.59.59,0,0,1-.63-.52v0l.05-4.34v-.07s0,0,0-.06c0-.18,0-.23-.35-.42l-2.76-1.56c-.12,0-.27-.19-.22-.58s.32-.67.61-.63a.35.35,0,0,1,.13,0l3.33,2a1.29,1.29,0,0,1,.49,1.05h0l-.05,4.5a.39.39,0,0,1,0,.13A.56.56,0,0,1,265.77,198.53Zm-.3-5.1h0v.11l-.05,4.43v0c0,.12.16.22.34.22s.33-.09.33-.2a.56.56,0,0,0,0-.07v-.05l.06-4.51a1,1,0,0,0-.36-.79l-3.33-2h0c-.05,0-.25.2-.28.38s0,.25.06.27l2.78,1.57C265.3,193,265.46,193.13,265.47,193.43Z",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.31,191.29l0,0a.39.39,0,0,0-.05-.27.36.36,0,0,0-.2-.17.22.22,0,0,0-.16,0l-8.89,5a.19.19,0,0,0-.09.12.35.35,0,0,0,0,.24v3.06c0,.13.13.23.31.23s.31-.1.31-.23v-1.9l8.08-4.58v1.55c0,.14.13.23.32.23s.31-.09.31-.23Zm-8.71,5,8.08-4.58v.41l-8.08,4.58Z",
    style: {
      fill: "#140f0c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.53,196.89a.37.37,0,0,0,0-.26.35.35,0,0,0-.2-.18.19.19,0,0,0-.15,0l-8.9,5a.25.25,0,0,0-.09.13.36.36,0,0,0,0,.24v3.05c0,.14.13.23.31.23s.32-.09.32-.23V203l8.07-4.59V200c0,.13.14.23.32.23s.31-.1.31-.23v-3.08Zm-8.72,5,8.07-4.58v.4l-8.07,4.58Z",
    style: {
      fill: "#140f0c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.58,202.65a.34.34,0,0,0,0-.29c-.09-.16-.24-.23-.36-.16l-8.89,5a.19.19,0,0,0-.09.12.34.34,0,0,0,0,.24v3.06c0,.13.14.23.32.23s.31-.1.31-.23v-1.9l8.08-4.58v1.56c0,.13.13.23.31.23s.32-.1.32-.23Zm-8.71,5,8.08-4.58v.4L247.87,208Z",
    style: {
      fill: "#140f0c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.67,171.66a.33.33,0,0,0-.29.36v8.18a.3.3,0,1,0,.58,0V172A.33.33,0,0,0,265.67,171.66Z",
    style: {
      fill: "#140f0c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.64,177.88v-5.35s1.55.4,1.55,1.73v4.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.34,178.9l-1.85-.92v-5.62l.22,0s1.63.44,1.63,1.87Zm-1.55-1.1,1.24.61v-4.13a1.49,1.49,0,0,0-1.24-1.52Z",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.25,149.72l-4.19,0-1.39,31.07V181h0c0,1.24,1.63,2.15,3.6,2.15s3.61-1,3.61-2.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.27,183.32c-2,0-3.72-1.06-3.75-2.3h0v-.2l1.4-31.22,4.47,0v.14L264,180.88C264,182.22,262.34,183.32,260.27,183.32Zm-3.46-2.42v0c0,1.11,1.61,2,3.45,2s3.46-1,3.46-2.12l-1.62-31-3.9,0-1.39,30.93A.25.25,0,0,1,256.81,180.9Z",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.58,156.57l-.33-6.62-4.19-.08-.31,6.34c0,.83,1.08,1.47,2.42,1.47s2.41-.43,2.41-1.26a.92.92,0,0,1,0,.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.17,157.81c-1.44,0-2.57-.71-2.57-1.62l.32-6.5,4.47.05.34,6.61v.22h0C262.54,157.5,261.56,157.81,260.17,157.81Zm-2-7.82-.31,6.21c0,.73,1,1.33,2.27,1.33s2.21-.46,2.26-1.12h0v0l-.32-6.35Z",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.25,149.69c0,.72-.93,1.3-2.08,1.3s-2.09-.58-2.09-1.3.93-1.3,2.09-1.3S262.25,149,262.25,149.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.17,151.14c-1.26,0-2.24-.64-2.24-1.45s1-1.45,2.24-1.45,2.23.64,2.23,1.45S261.42,151.14,260.17,151.14Zm0-2.6c-1.07,0-1.94.52-1.94,1.15s.87,1.16,1.94,1.16,1.93-.52,1.93-1.16S261.23,148.54,260.17,148.54Z",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 260.17,
    cy: 149.64,
    rx: 1.45,
    ry: 0.86,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.62,149.93c0,.48-.65.86-1.45.86s-1.46-.38-1.46-.86.65-.85,1.46-.85S261.62,149.46,261.62,149.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.17,150.64c-.9,0-1.6-.44-1.6-1s.7-1,1.6-1,1.6.44,1.6,1S261.06,150.64,260.17,150.64Zm0-1.71c-.71,0-1.31.32-1.31.71s.6.71,1.31.71,1.3-.33,1.3-.71S260.87,148.93,260.17,148.93Z",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.79 148.81 259.79 150.46 259 150.16 258.71 149.64 258.86 149.26 259.25 148.97 259.79 148.81",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.79 150.99 259.79 157.68 260.95 157.62 261.91 157.3 262.58 156.58 262.25 149.96 261.77 150.53 260.87 150.94 259.79 150.99",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.79 157.68 259.75 183.19 260.77 183.19 262.2 182.85 263.1 182.32 263.71 181.55 263.88 180.91 262.62 156.85 262.4 156.96 261.69 157.46 260.95 157.62 260.04 157.66 259.79 157.68",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.43,156.41h0c-.06.66-1,1.12-2.27,1.12H260v.29h.15a2.86,2.86,0,0,0,2.32-.74l-.06-.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.39,154.74l-4.19,0-1.39,31.07s0,.24,0,.25v.2h0c0,.93,1.62,2,3.6,2S255,187.21,255,186Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.41,188.46c-2,0-3.72-1.25-3.75-2.18h0v-.38l1.4-31.25,4.47,0v.13L255.16,186C255.16,187.31,253.48,188.46,251.41,188.46ZM248,185.92V186c0,1.1,1.61,2,3.46,2s3.46-1,3.46-2.13l-1.62-31-3.91,0L248,185.84Z",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.72,161.52l-.33-6.58-4.19-.06-.31,6.34c0,.83,1.08,1.48,2.41,1.48s2.42-.46,2.42-1.3c0,0,0,.12,0,.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.3,162.8c-1.43,0-2.56-.69-2.56-1.61l.32-6.49,4.47.06.34,6.61s0,0,0,0v.14h0C253.67,162.45,252.7,162.8,251.3,162.8Zm-2-7.79-.31,6.21c0,.73,1,1.33,2.27,1.33s2.21-.46,2.27-1.12h0v0l-.32-6.35Z",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.39,154.71c0,.72-.94,1.31-2.09,1.31s-2.08-.59-2.08-1.31.93-1.3,2.08-1.3S253.39,154,253.39,154.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.3,156.16c-1.25,0-2.23-.63-2.23-1.45s1-1.45,2.23-1.45,2.24.64,2.24,1.45S252.55,156.16,251.3,156.16Zm0-2.6c-1.07,0-1.93.52-1.93,1.15s.86,1.16,1.93,1.16,1.94-.52,1.94-1.16S252.37,153.56,251.3,153.56Z",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.76,154.66c0,.47-.65.86-1.46.86s-1.45-.39-1.45-.86.65-.86,1.45-.86S252.76,154.19,252.76,154.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.76,155c0,.47-.65.85-1.46.85s-1.45-.38-1.45-.85.65-.86,1.45-.86S252.76,154.48,252.76,155Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.3,155.67c-.9,0-1.6-.45-1.6-1s.7-1,1.6-1,1.6.44,1.6,1S252.2,155.67,251.3,155.67Zm0-1.72c-.7,0-1.3.33-1.3.71s.6.71,1.3.71,1.31-.32,1.31-.71S252,154,251.3,154Z",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.92 153.83 250.92 155.49 250.14 155.18 249.85 154.66 250 154.29 250.39 154 250.92 153.83",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.92 156.02 250.92 162.71 252.08 162.64 253.04 162.32 253.72 161.6 253.39 154.98 252.9 155.55 252.01 155.97 250.92 156.02",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.92 162.71 250.89 188.21 251.91 188.21 253.34 187.87 254.24 187.34 254.84 186.58 255.01 185.93 253.76 161.87 253.53 161.99 252.82 162.49 252.08 162.64 251.18 162.69 250.92 162.71",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.57,161.43h0c0,.66-1,1.12-2.26,1.12h-.15v.3h.15a2.86,2.86,0,0,0,2.32-.74l-.06-.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "253.98 169.13 253.69 163.48 253.98 163.33 254.29 168.95 253.98 169.13",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.71 201.11 238.85 197.22 243.79 200.02 243.82 203.86 238.71 201.11",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "243.79 200.02 248.46 197.22 248.46 201.1 243.81 203.86 243.79 200.02",
    style: {
      fill: "#130e0c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.85 197.22 243.76 194.34 248.67 197.22 243.86 200.02 238.85 197.22",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.85 197.82 243.76 194.93 248.18 197.53 243.89 199.96 243.86 200.61 238.85 197.82",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.76,197.11l-5-2.94-5,3v4.06l5.22,2.84,4.83-2.84Zm-5-2.6,4.59,2.7-4.13,2.42-.36.22-4.71-2.63ZM239,201v-3.54l4.71,2.63.05,3.49Zm5.07,2.58-.07-3.5.38-.22,4.07-2.37V201Z",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.06,196.89c.4,0,.55.22.55.45,0,0,0,0,0,0l1.18.57a.93.93,0,0,0,.18-.55c0-.73-.9-1.32-2.05-1.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.84,197.83l-1.33-.64h-.07l0,0,0-.11c0-.07,0-.25-.42-.3h-.11l-.18-1.17h.18c1.25.06,2.19.71,2.19,1.52a1.09,1.09,0,0,1-.21.64Zm-1.08-.85,1,.47a.74.74,0,0,0,.09-.36c0-.6-.74-1.11-1.72-1.21l.09.58C244.63,196.55,244.74,196.8,244.76,197Z",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.27,197.73a.88.88,0,0,1-.51.09,1,1,0,0,1-.51-.09l-1.22.52a2.83,2.83,0,0,0,1.73.52,2.75,2.75,0,0,0,1.81-.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.76,198.63a3,3,0,0,1-1.83-.56l-.19-.15,1.52-.65.06,0a.79.79,0,0,0,.44.08c.24,0,.31,0,.43-.08l.06,0,1.61.56-.19.17A3,3,0,0,1,243.76,198.63Zm-1.43-.65a3.09,3.09,0,0,0,2.93,0l-1-.35a1,1,0,0,1-.52.09,1.11,1.11,0,0,1-.51-.09Z",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.9,197.34s0,0,0,0a.58.58,0,0,1,.56-.56l.13-.77c-1.14.06-2.05.65-2.05,1.38a1,1,0,0,0,.25.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.75,197.91l-.08-.1a1.13,1.13,0,0,1-.27-.72c0-.81.94-1.46,2.18-1.52h.19l-.19,1.06h-.11a.44.44,0,0,0-.42.39l.11.08,0,0v.05l-.19,0Zm1.66-2c-1,.1-1.72.61-1.72,1.21a.83.83,0,0,0,.13.43l.91-.55,0,0a.7.7,0,0,1,.56-.57Z",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.62,197c0,.27-.38.49-.86.49s-.85-.22-.85-.49.23-.7.52-.77c.11,0,.21.29.33.29s.22-.32.33-.29C244.38,196.34,244.62,196.85,244.62,197Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.76,197.68c-.56,0-1-.28-1-.64a1.14,1.14,0,0,1,.63-.91c.16,0,.25.09.32.19l0,.07.05-.07c.07-.09.16-.24.32-.2a1.18,1.18,0,0,1,.64.92C244.77,197.4,244.33,197.68,243.76,197.68Zm-.34-1.25a.94.94,0,0,0-.36.61c0,.16.3.34.7.34s.71-.18.71-.34a1,1,0,0,0-.37-.61l0,0c-.07.1-.15.23-.3.23s-.22-.12-.29-.22Z",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.36,196.55c0,.18-.27.33-.6.33s-.59-.15-.59-.33.27-.34.59-.34S244.36,196.36,244.36,196.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.76,197c-.42,0-.74-.21-.74-.48s.32-.49.74-.49.74.21.74.49S244.19,197,243.76,197Zm0-.67c-.27,0-.44.12-.44.19s.18.18.44.18.45-.11.45-.18S244,196.36,243.76,196.36Z",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "243.66 196.85 243.66 197.53 244.27 197.43 244.61 197.07 244.42 196.54 244.14 196.81 243.66 196.85",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.16,201a1.07,1.07,0,0,0-.41-.86h0l-3.14-1.9-.08,0c-.17,0-.39.27-.42.48s0,.34.14.4h0l2.61,1.47c.3.18.39.26.39.52,0,0,0,0,0,.05h0l0,2.15v0a.41.41,0,0,0,.45.35c.25,0,.45-.14.45-.33,0,0,0-.08,0-.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.67,203.8a.56.56,0,0,1-.6-.5v-.05l.05-2.07v-.11c0-.17,0-.22-.33-.39l-2.6-1.47c-.12-.05-.26-.19-.21-.56s.3-.64.58-.6l.13,0,3.16,1.91a1.24,1.24,0,0,1,.51,1h0l-.08,2.21a.53.53,0,0,1,0,.12A.55.55,0,0,1,240.67,203.8ZM240.4,201h0v.13l0,2.15v0c0,.11.14.2.31.2s.3-.08.3-.18,0,0,0-.06v0L241,201a.82.82,0,0,0-.34-.68s-3.15-2-3.17-2h0a.48.48,0,0,0-.25.35c0,.1,0,.22.05.24l2.62,1.48C240.23,200.6,240.38,200.72,240.4,201Z",
    style: {
      fill: "#15100c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.5,175.32l-.06-.13h0a1.52,1.52,0,0,0-.33-.26,2.73,2.73,0,0,0-2.43,0,1.31,1.31,0,0,0-.33.26h0l-.05.14c-.19.33,0,.71.42,1a2.73,2.73,0,0,0,2.43,0C231.54,176,231.68,175.66,231.5,175.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.1,176.31a1.78,1.78,0,0,1-.4-.17,1,1,0,0,1-.34-.28l-.1.24a1.12,1.12,0,0,0,.34.3,2.47,2.47,0,0,0,.5.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.86,176.63a2.6,2.6,0,0,1-1.23-.29c-.47-.27-.64-.66-.44-1l.06-.16h.05a1.46,1.46,0,0,1,.33-.26,2.82,2.82,0,0,1,2.47,0,1.21,1.21,0,0,1,.32.26h.05l.07.16c.2.36,0,.76-.44,1A2.61,2.61,0,0,1,229.86,176.63Zm-1.55-1.4,0,.11c-.19.33,0,.69.4.93a2.71,2.71,0,0,0,2.39,0c.43-.25.58-.6.4-.93h0l0-.11h0a1.34,1.34,0,0,0-.31-.26,2.71,2.71,0,0,0-2.39,0,1.21,1.21,0,0,0-.32.26h0Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "229.29 176.29 229.29 176.53 230.12 176.59 230.67 176.48 231.11 176.29 231.51 175.94 231.58 175.6 231.51 175.46 231.37 175.71 231.09 175.99 230.46 176.27 229.86 176.3 229.29 176.29",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.29,176.21a2.23,2.23,0,0,1-.55-.2.8.8,0,0,1-.44-.54h-.09a.87.87,0,0,0,.49.61,2.06,2.06,0,0,0,.59.22h0v-.08Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.47,175.39v-3.84h-3.21v3.85a.76.76,0,0,0,.47.64,2.52,2.52,0,0,0,2.27,0A.77.77,0,0,0,231.47,175.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.86,176.35a2.35,2.35,0,0,1-1.15-.27.83.83,0,0,1-.5-.68v-3.83a.07.07,0,0,1,.07-.07h3.17a.06.06,0,0,1,.06.06v3.82a.79.79,0,0,1-.49.7A2.42,2.42,0,0,1,229.86,176.35Zm-1.56-4.76v3.81a.75.75,0,0,0,.45.61,2.57,2.57,0,0,0,2.23,0,.73.73,0,0,0,.44-.62v-3.8Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "229.29 172.43 229.29 176.27 230.08 176.31 230.7 176.18 231.15 175.95 231.47 175.57 231.51 171.65 231.21 172.09 230.81 172.35 230.23 172.45 229.7 172.47 229.29 172.43",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.51,175.46h-.09a.79.79,0,0,1-.44.55,2.59,2.59,0,0,1-1.68.2h0v.08a2.78,2.78,0,0,0,.58.06,2.41,2.41,0,0,0,1.15-.27A.85.85,0,0,0,231.51,175.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.54,174.2a0,0,0,0,0-.07,0,1.15,1.15,0,0,1-.46.55,2.56,2.56,0,0,1-2.29,0c-.29-.17-.49-.36-.51-.58a.27.27,0,0,1,0-.14c-.19.34,0,.72.42,1a2.73,2.73,0,0,0,2.43,0C231.55,174.76,231.61,174.42,231.54,174.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.1,175a1.78,1.78,0,0,1-.4-.17,1.08,1.08,0,0,1-.34-.28l-.1.24a1,1,0,0,0,.34.29,2,2,0,0,0,.5.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.54,174l-.07-.15s0,.15,0,.23c.15.32,0,.65-.42.89a2.71,2.71,0,0,1-2.39,0c-.41-.24-.57-.57-.43-.89,0-.08,0-.23,0-.23l-.06.15c-.2.37,0,.77.44,1a2.77,2.77,0,0,0,2.47,0C231.57,174.79,231.74,174.39,231.54,174Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "229.29 175.01 229.29 175.25 230.12 175.31 230.67 175.19 231.11 175.01 231.51 174.65 231.58 174.32 231.51 174.17 231.37 174.43 231.09 174.71 230.5 174.96 229.86 175.01 229.29 175.01",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.51,174.17h-.09a.77.77,0,0,1-.44.55,2.46,2.46,0,0,1-1.68.2h0V175a2.62,2.62,0,0,0,.57.06,2.38,2.38,0,0,0,1.15-.27A.85.85,0,0,0,231.51,174.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.29,174.92a1.89,1.89,0,0,1-.55-.2.76.76,0,0,1-.44-.54h-.09a.88.88,0,0,0,.49.62,1.8,1.8,0,0,0,.59.21h0v-.09Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.06,175a2.71,2.71,0,0,1-1.77.22h0v.08a2.78,2.78,0,0,0,.58.06,2.6,2.6,0,0,0,1.23-.29,1.16,1.16,0,0,0,.41-.37h-.1A1.17,1.17,0,0,1,231.06,175Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.54,172.79a0,0,0,0,0-.07,0,1.15,1.15,0,0,1-.46.55,2.56,2.56,0,0,1-2.29,0c-.29-.17-.49-.36-.51-.58a.27.27,0,0,1,0-.14c-.19.34,0,.72.42,1a2.73,2.73,0,0,0,2.43,0C231.55,173.35,231.61,173,231.54,172.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.1,173.62a1.78,1.78,0,0,1-.4-.17,1.08,1.08,0,0,1-.34-.28l-.1.24a1,1,0,0,0,.34.29,2,2,0,0,0,.5.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.54,172.61l-.07-.15s0,.15,0,.23c.15.32,0,.65-.42.89a2.71,2.71,0,0,1-2.39,0c-.41-.24-.57-.57-.43-.89,0-.08,0-.23,0-.23l-.06.15c-.2.37,0,.77.44,1a2.77,2.77,0,0,0,2.47,0C231.57,173.38,231.74,173,231.54,172.61Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "229.29 173.6 229.29 173.84 230.12 173.9 230.67 173.79 231.11 173.6 231.51 173.24 231.58 172.91 231.51 172.76 231.37 173.02 231.09 173.3 230.5 173.55 229.86 173.61 229.29 173.6",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.51,172.76h-.09a.77.77,0,0,1-.44.55,2.46,2.46,0,0,1-1.68.2h0v.09a2.62,2.62,0,0,0,.57.06,2.38,2.38,0,0,0,1.15-.27A.85.85,0,0,0,231.51,172.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.29,173.51a1.89,1.89,0,0,1-.55-.2.76.76,0,0,1-.44-.54h-.09a.88.88,0,0,0,.49.62,1.8,1.8,0,0,0,.59.21h0v-.09Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.06,173.58a2.71,2.71,0,0,1-1.77.22h0v.08a2.78,2.78,0,0,0,.58.06,2.6,2.6,0,0,0,1.23-.29,1.16,1.16,0,0,0,.41-.37h-.1A1.17,1.17,0,0,1,231.06,173.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.53,171.46s0,0-.06,0a1.24,1.24,0,0,1-.47.55,2.56,2.56,0,0,1-2.29,0c-.29-.17-.48-.36-.5-.58a.35.35,0,0,1,0-.14c-.18.34,0,.72.42,1a2.73,2.73,0,0,0,2.43,0C231.54,172,231.61,171.68,231.53,171.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.1,172.29a1.68,1.68,0,0,1-.41-.17.94.94,0,0,1-.33-.28l-.11.24a.94.94,0,0,0,.35.29,2,2,0,0,0,.5.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.53,171.28l-.06-.15s0,.15,0,.23c.14.32,0,.65-.43.89a2.71,2.71,0,0,1-2.39,0c-.41-.24-.57-.57-.42-.89,0-.08,0-.23,0-.23l-.07.15c-.2.37,0,.77.44,1a2.86,2.86,0,0,0,2.47,0C231.56,172.05,231.73,171.65,231.53,171.28Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "229.28 172.21 229.29 172.51 230.11 172.56 230.66 172.45 231.1 172.27 231.51 171.91 231.57 171.58 231.5 171.43 231.36 171.69 231.08 171.97 230.5 172.22 229.86 172.28 229.28 172.21",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.05,172.25a2.69,2.69,0,0,1-1.76.22h0v.08a2.63,2.63,0,0,0,.57,0,2.57,2.57,0,0,0,1.23-.28,1.29,1.29,0,0,0,.42-.37h-.1A1.22,1.22,0,0,1,231.05,172.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231,170.7c.64.36.64.94,0,1.3a2.56,2.56,0,0,1-2.29,0,.68.68,0,0,1,0-1.3A2.56,2.56,0,0,1,231,170.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.85,172.31a2.46,2.46,0,0,1-1.17-.27.83.83,0,0,1-.49-.69.81.81,0,0,1,.49-.68,2.61,2.61,0,0,1,2.34,0,.83.83,0,0,1,.49.68.85.85,0,0,1-.49.69A2.49,2.49,0,0,1,229.85,172.31Zm0-1.84a2.3,2.3,0,0,0-1.13.27.74.74,0,0,0-.45.61.77.77,0,0,0,.45.62,2.54,2.54,0,0,0,2.25,0,.76.76,0,0,0,.46-.62.73.73,0,0,0-.46-.61A2.26,2.26,0,0,0,229.85,170.47Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.14,171.61a.75.75,0,0,0-.32-.28,2.25,2.25,0,0,0-1.93,0,.81.81,0,0,0-.32.28,1,1,0,0,0,.32.28,2.32,2.32,0,0,0,1.93,0A.9.9,0,0,0,231.14,171.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.85,172.12a2.17,2.17,0,0,1-1-.21.67.67,0,0,1-.42-.56.66.66,0,0,1,.42-.55,2.32,2.32,0,0,1,2,0,.67.67,0,0,1,.42.55.69.69,0,0,1-.42.56A2.17,2.17,0,0,1,229.85,172.12Zm0-1.46a2,2,0,0,0-.94.21c-.25.13-.38.3-.38.48a.6.6,0,0,0,.38.49,2.21,2.21,0,0,0,1.88,0,.6.6,0,0,0,.38-.49c0-.18-.13-.35-.38-.48A2,2,0,0,0,229.85,170.66Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.83,170.8a2.32,2.32,0,0,0-2,0,.66.66,0,0,0-.42.55.39.39,0,0,0,0,.15h.09a.7.7,0,0,1,.36-.39,2,2,0,0,1,.94-.21,2.08,2.08,0,0,1,.95.21.84.84,0,0,1,.35.35h.08a.28.28,0,0,0,0-.09A.67.67,0,0,0,230.83,170.8Zm0,.24a2.14,2.14,0,0,0-.86-.22v-.16a2,2,0,0,1,.8.21.63.63,0,0,1,.37.43A.81.81,0,0,0,230.85,171Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.55,171.52c.13.07.13.18,0,.25a.51.51,0,0,1-.45,0,.13.13,0,0,1,0-.25A.51.51,0,0,1,229.55,171.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.34,171.66a.51.51,0,0,1-.25-.06.17.17,0,0,1,0-.32.53.53,0,0,1,.49,0,.17.17,0,0,1,0,.32A.5.5,0,0,1,229.34,171.66Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.56,114.38l-48,27.71,48,27.7,48-27.7Zm48,27.71-48,27.7V225.2l48-27.71Zm-48,27.7-48-27.7v55.4l48,27.71Z",
    style: {
      fill: "none",
      stroke: "#111",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "EXPERTEN"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0.5 83.4 48.48 111.1 96.47 83.4 96.46 27.99 48.48 0.29 0.5 27.99 0.5 83.4",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.6,83.52l48-27.82m0,0L48.48.29m.15,55.41L96.17,83.29",
    style: {
      fill: "none",
      stroke: "#111",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.76,87.68c-1.25-5.33-4-13.57-9.28-16.72l-3.15-1.88L54,65.55a9.41,9.41,0,0,0,.9-.52l0,0,.11-.08a3.2,3.2,0,0,0,1.52-2.15L57,60.94l1.45-6.48a6.21,6.21,0,0,0,.14-.62l0-.17h0a10.64,10.64,0,0,0,.14-1.56c.07-5.68-3.84-12.64-8.73-15.54-2.24-1.32-4.08-1.64-5.65-1l-.22.07-.12.07a3.39,3.39,0,0,0-.53.29L39.35,38.3l-.22.46,2,1.52a9.33,9.33,0,0,0-.1,1.33,10.85,10.85,0,0,0,.05,1.5l0,.13,0,.35c0,.31.08.48.14.79l1.64,10.33h0a16.32,16.32,0,0,0,2.5,6.15L45,63.66c-.77-.46-2.15-1.36-3.15-2-2.07-1.23-3.59-1.3-5-.62l-.19.07-.48.27h0l-3.62,2,.81,1.31a19.93,19.93,0,0,0-1.1,2.49c-.62,1.74.68,4.69,2.58,5.81L49.2,81.54l.62.37,11.06,6.56c.15,1.33.38,3.12.5,4a.44.44,0,0,0,.64.32l4-2.25h0C66.77,90.19,67.1,89.13,66.76,87.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.81,93.27a.81.81,0,0,1-.37-.09.82.82,0,0,1-.44-.61c-.11-.89-.33-2.56-.48-3.87L34.68,73.38c-2-1.21-3.42-4.37-2.74-6.26a20.45,20.45,0,0,1,1-2.36l-.91-1.46,4.68-2.58c1.58-.76,3.28-.56,5.32.65.54.32,1.19.73,1.79,1.11l.88.56L45,61a16.43,16.43,0,0,1-2.47-6.19L40.88,44.22c0-.19-.07-.35-.1-.58l-.06-.44a10.1,10.1,0,0,1-.06-1.6,9.41,9.41,0,0,1,.08-1.15l-2.09-1.58.41-.84,4.24-2.34a3.71,3.71,0,0,1,.56-.31l.09-.05.29-.1c1.66-.71,3.62-.38,6,1,5,2.95,9,10.07,8.92,15.87a10.9,10.9,0,0,1-.1,1.36h0l-.08.44c0,.21-.09.43-.15.64l-1.87,8.31a3.64,3.64,0,0,1-1.68,2.38l-.1.07c-.27.18-.52.32-.76.45l.3,3.08,3,1.78c5.25,3.12,8,11,9.45,17,.37,1.53,0,2.81-.89,3.32l-4,2.25A.85.85,0,0,1,61.81,93.27ZM33.13,63.58l.71,1.15-.1.2a19.51,19.51,0,0,0-1.08,2.44c-.56,1.57.67,4.32,2.41,5.35L61.24,88.24l0,.19c.15,1.32.38,3.11.5,4l4.1-2.21c.6-.34.81-1.31.53-2.49h0c-1.13-4.81-3.81-13.34-9.1-16.48l-3.32-2-.39-4,.24-.11c.28-.14.57-.31.86-.49l.13-.1a2.84,2.84,0,0,0,1.38-1.91l1.87-8.33c.06-.21.1-.41.14-.61l0-.17a8.91,8.91,0,0,0,.14-1.5c.07-5.55-3.77-12.38-8.55-15.21-2.11-1.25-3.85-1.57-5.31-1l-.3.12a4.86,4.86,0,0,0-.51.28l-4.08,2.3,1.94,1.47,0,.22a8.54,8.54,0,0,0-.1,1.28,10,10,0,0,0,0,1.46l0,.09,0,.39c0,.2.06.35.09.52l0,.24,1.64,10.34a15.8,15.8,0,0,0,2.44,6l.08.12-.52,3.51L44.83,64l-1.38-.86c-.6-.38-1.24-.78-1.78-1.1-1.83-1.09-3.25-1.28-4.61-.61l-.21.08Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "ACTIVE",
    d: "M62.33,90.16c-1.26-5.33-4-13.58-9.29-16.72l-3.15-1.88L49.55,68a4.14,4.14,0,0,0,2.57-2.76l.42-1.85L54,56.94c0-.21.1-.41.14-.63l0-.16h0a9.52,9.52,0,0,0,.14-1.56c.07-5.68-3.84-12.64-8.73-15.54s-8.9-.64-9,5a10.94,10.94,0,0,0,0,1.51l0,.13,0,.35a7.27,7.27,0,0,0,.14.79L38.5,57.19h0A16.39,16.39,0,0,0,41,63.34l-.41,2.8c-.77-.46-2.15-1.37-3.16-2-5.32-3.15-8.2,1.76-9.56,5.54-.63,1.74.67,4.68,2.57,5.81L44.76,84l.62.37,14.27,8.46C61.55,94,62.9,92.61,62.33,90.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.92,93.63a2.87,2.87,0,0,1-1.46-.45L30.25,75.85c-2-1.2-3.42-4.36-2.74-6.26C28.39,67.13,30,64,32.6,63.07a5.8,5.8,0,0,1,5,.78L39.4,65l.89.56.32-2.08a16.75,16.75,0,0,1-2.48-6.19L36.45,46.69c0-.19-.07-.34-.1-.57l-.07-.44a11.5,11.5,0,0,1-.06-1.6c0-2.89,1.05-5,2.87-6.07s4.19-.77,6.68.7c5,3,9,10.08,8.91,15.88a10.74,10.74,0,0,1-.1,1.35h0l-.09.45c0,.21-.09.42-.14.63l-1.88,8.32A4.34,4.34,0,0,1,50,68.25l.3,3.08,3,1.78c5.26,3.12,8,11,9.46,17h0c.33,1.44.06,2.64-.72,3.22A1.74,1.74,0,0,1,60.92,93.63ZM34.21,63.55a3.84,3.84,0,0,0-1.35.24c-2.33.83-3.81,3.76-4.64,6.06-.56,1.57.68,4.32,2.41,5.35L59.85,92.52a1.51,1.51,0,0,0,1.68.16A2.38,2.38,0,0,0,62,90.25c-1.13-4.81-3.82-13.35-9.11-16.48l-3.32-2-.38-4,.23-.12a3.79,3.79,0,0,0,2.37-2.5l1.87-8.33c.06-.2.1-.4.14-.6l0-.17a10,10,0,0,0,.13-1.5C54,49,50.15,42.2,45.38,39.37,43.14,38,41,37.79,39.46,38.68S37,41.48,37,44.09A10,10,0,0,0,37,45.55l0,.08,0,.4c0,.2.06.34.09.51l.05.25,1.64,10.34a15.93,15.93,0,0,0,2.44,6l.08.12-.52,3.5-.49-.29c-.36-.21-.86-.53-1.39-.86s-1.23-.78-1.76-1.09A6,6,0,0,0,34.21,63.55Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "58.78 52.86 58.45 49.01 54 51.5 54.51 54.17 52.52 63.78 52.4 63.86 51.89 65.93 50.24 67.75 49.55 68.02 49.89 71.56 54.33 69.08 53.99 65.55 55.99 64.41 56.67 62.08 56.91 61.27 58.78 52.86",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.28 86.28 65.55 83.74 66.7 86.91 66.86 88.9 66.51 90.42 62.02 92.83 62.46 90.97 61.58 87.04 61.28 86.28",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.83,49.45c0-5.51-4.13-12.29-9-14.48-1.81-.81-3.31-.89-4.57-.21l-.15.08h0l0,0-4,2.33a.37.37,0,0,0-.11.52L65.66,40c-.06,3.94,2,8.57,5,11.7V55c0,.62.63,1.31,1,1.13l2.67-1.21,1,1.72a.4.4,0,0,0,.54.15l3.54-2.07h0C80.91,53.86,81.83,52.05,81.83,49.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.68,57.2a.64.64,0,0,1-.2,0,.74.74,0,0,1-.47-.36l-.79-1.42-2.35,1.06a.83.83,0,0,1-.81-.1A1.73,1.73,0,0,1,70.3,55V51.81a18.25,18.25,0,0,1-5-11.72l-1.58-2.16a.71.71,0,0,1-.13-.58.73.73,0,0,1,.35-.49l4.17-2.44c1.35-.73,3-.67,4.89.2,4.92,2.21,9.24,9.15,9.24,14.83,0,2.55-.85,4.48-2.4,5.46h0l-.19.12-3.55,2.06A.77.77,0,0,1,75.68,57.2Zm-1.14-2.79,1.13,2,3.57-2.07c1.42-.8,2.21-2.54,2.21-4.91,0-5.42-4.11-12-8.79-14.13-1.71-.77-3.09-.84-4.23-.22l-.16.08-4,2.34L66,39.84V40C66,43.66,68,48.26,71,51.4l.1.11V55a.91.91,0,0,0,.51.77Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.93,51.72c0-5.51-4.13-12.29-9-14.48-3.63-1.64-6.61,0-7.09,3.92-.51,4.15,1.69,9.35,5,12.77v3.32c0,.61.63,1.31,1,1.12L71,56.94C74.9,58.58,77.93,56.44,77.93,51.72Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.67,58.79a.94.94,0,0,1-.51-.17,1.73,1.73,0,0,1-.76-1.37V54.08c-3.41-3.64-5.45-8.95-5-13A5.5,5.5,0,0,1,64,36.8a5.62,5.62,0,0,1,5.11.09C74,39.1,78.31,46,78.31,51.72c0,2.49-.83,4.41-2.33,5.41a5.31,5.31,0,0,1-5,.23l-3,1.36A.82.82,0,0,1,67.67,58.79ZM66.24,37a3.78,3.78,0,0,0-1.9.48A4.7,4.7,0,0,0,62.2,41.2c-.47,3.85,1.53,9,4.85,12.47l.11.11v3.47a.92.92,0,0,0,.51.77L71,56.53l.15.06a4.65,4.65,0,0,0,4.45-.09c1.28-.85,2-2.55,2-4.78,0-5.42-4.11-12-8.79-14.14A6.27,6.27,0,0,0,66.24,37Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.22 47.51 81.15 45.22 81.83 47.25 81.83 50.68 81.45 52.5 78.57 55.33 76.25 56.43 77.93 53.05 77.93 49.45 77.22 47.51",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "ACTIVE-2",
    "data-name": "ACTIVE",
    d: "M67.1,46c0,.9-.63,1.26-1.4.81a3.08,3.08,0,0,1-1.41-2.43c0-.89.63-1.26,1.41-.81A3.12,3.12,0,0,1,67.1,46Zm2.5-.14c-.78-.45-1.41-.09-1.41.81a3.11,3.11,0,0,0,1.41,2.43c.77.45,1.4.08,1.4-.81A3.09,3.09,0,0,0,69.6,45.89Zm3.9,2.21c-.77-.45-1.4-.09-1.4.81a3.09,3.09,0,0,0,1.4,2.43c.78.45,1.41.09,1.41-.81A3.11,3.11,0,0,0,73.5,48.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.32,47.28a1.52,1.52,0,0,1-.75-.22A3.34,3.34,0,0,1,64,44.41a1.11,1.11,0,0,1,1.78-1A3.36,3.36,0,0,1,67.35,46a1.25,1.25,0,0,1-.53,1.13A1.06,1.06,0,0,1,66.32,47.28Zm-1.25-3.62a.48.48,0,0,0-.24.06.75.75,0,0,0-.28.69,2.86,2.86,0,0,0,1.27,2.21.77.77,0,0,0,.74.1.78.78,0,0,0,.29-.69,2.89,2.89,0,0,0-1.28-2.22A1.05,1.05,0,0,0,65.07,43.66Zm9.06,8.13a1.51,1.51,0,0,1-.75-.23,3.33,3.33,0,0,1-1.54-2.65,1.22,1.22,0,0,1,.54-1.13,1.24,1.24,0,0,1,1.25.1,3.34,3.34,0,0,1,1.53,2.65,1.22,1.22,0,0,1-.54,1.13A.92.92,0,0,1,74.13,51.79Zm-1.26-3.63a.41.41,0,0,0-.23.06.76.76,0,0,0-.29.69,2.88,2.88,0,0,0,1.28,2.21.74.74,0,0,0,.74.1.75.75,0,0,0,.28-.69,2.86,2.86,0,0,0-1.27-2.21A1.15,1.15,0,0,0,72.87,48.16Zm-2.64,1.38a1.55,1.55,0,0,1-.76-.23,3.32,3.32,0,0,1-1.53-2.65,1.11,1.11,0,0,1,1.79-1,3.35,3.35,0,0,1,1.53,2.65,1.22,1.22,0,0,1-.54,1.13A1.05,1.05,0,0,1,70.23,49.54ZM69,45.91a.48.48,0,0,0-.24.06.75.75,0,0,0-.28.69,2.85,2.85,0,0,0,1.28,2.21.61.61,0,0,0,1-.59,2.88,2.88,0,0,0-1.28-2.21A1,1,0,0,0,69,45.91Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.38,95.7c.28.16.28.41,0,.57a1.1,1.1,0,0,1-1,0,.3.3,0,0,1,0-.57A1.1,1.1,0,0,1,56.38,95.7Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,94.19a.31.31,0,0,1,0,.58,1.1,1.1,0,0,1-1,0,.31.31,0,0,1,0-.58A1.1,1.1,0,0,1,59,94.19Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.78,94.19a.31.31,0,0,1,0,.58,1.1,1.1,0,0,1-1,0,.31.31,0,0,1,0-.58A1.1,1.1,0,0,1,53.78,94.19Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.38,92.69c.28.16.28.41,0,.57a1.1,1.1,0,0,1-1,0,.3.3,0,0,1,0-.57A1.1,1.1,0,0,1,56.38,92.69Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.17,92.69a.3.3,0,0,1,0,.57,1.1,1.1,0,0,1-1,0,.3.3,0,0,1,0-.57A1.1,1.1,0,0,1,51.17,92.69Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.28,
    cy: 91.47,
    rx: 0.7,
    ry: 0.41,
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.06,
    cy: 91.47,
    rx: 0.7,
    ry: 0.41,
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.17,89.68a.3.3,0,0,1,0,.57,1.1,1.1,0,0,1-1,0,.3.3,0,0,1,0-.57A1.1,1.1,0,0,1,51.17,89.68Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.46,
    cy: 89.97,
    rx: 0.7,
    ry: 0.41,
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.56,88.17a.31.31,0,0,1,0,.58,1.08,1.08,0,0,1-1,0,.31.31,0,0,1,0-.58A1.08,1.08,0,0,1,48.56,88.17Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.33,88.16a.3.3,0,0,1,0,.57,1.1,1.1,0,0,1-1,0,.3.3,0,0,1,0-.57A1.1,1.1,0,0,1,43.33,88.16Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.93,86.65a.31.31,0,0,1,0,.58,1.08,1.08,0,0,1-1,0,.31.31,0,0,1,0-.58A1.08,1.08,0,0,1,45.93,86.65Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.72,86.65a.31.31,0,0,1,0,.58,1.08,1.08,0,0,1-1,0,.31.31,0,0,1,0-.58A1.08,1.08,0,0,1,40.72,86.65Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.33,85.15a.3.3,0,0,1,0,.57,1.1,1.1,0,0,1-1,0,.3.3,0,0,1,0-.57A1.1,1.1,0,0,1,43.33,85.15Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.62,
    cy: 85.44,
    rx: 0.7,
    ry: 0.41,
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.72,83.64a.31.31,0,0,1,0,.58,1.08,1.08,0,0,1-1,0,.31.31,0,0,1,0-.58A1.08,1.08,0,0,1,40.72,83.64Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.51,83.64a.31.31,0,0,1,0,.58,1.1,1.1,0,0,1-1,0,.31.31,0,0,1,0-.58A1.1,1.1,0,0,1,35.51,83.64Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.12,82.14a.3.3,0,0,1,0,.57,1.1,1.1,0,0,1-1,0c-.28-.16-.28-.41,0-.57A1.1,1.1,0,0,1,38.12,82.14Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9,82.14c.28.16.28.41,0,.57a1.08,1.08,0,0,1-1,0c-.28-.16-.28-.41,0-.57A1.08,1.08,0,0,1,32.9,82.14Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.01,
    cy: 80.92,
    rx: 0.7,
    ry: 0.41,
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3,80.63a.31.31,0,0,1,0,.58,1.1,1.1,0,0,1-1,0,.31.31,0,0,1,0-.58A1.1,1.1,0,0,1,30.3,80.63Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9,79.13c.28.16.28.42,0,.57a1.08,1.08,0,0,1-1,0c-.28-.15-.28-.41,0-.57A1.08,1.08,0,0,1,32.9,79.13Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.69,79.13c.28.16.28.42,0,.57a1.1,1.1,0,0,1-1,0c-.27-.15-.27-.41,0-.57A1.1,1.1,0,0,1,27.69,79.13Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3,77.62a.31.31,0,0,1,0,.58,1.1,1.1,0,0,1-1,0,.31.31,0,0,1,0-.58A1.17,1.17,0,0,1,30.3,77.62Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.69,76.12c.28.16.28.42,0,.57a1.1,1.1,0,0,1-1,0c-.27-.15-.27-.41,0-.57A1.1,1.1,0,0,1,27.69,76.12Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3,97a.31.31,0,0,1,0,.58,1.15,1.15,0,0,1-1,0,.31.31,0,0,1,0-.58A1.08,1.08,0,0,1,64.3,97Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.91,95.46c.27.15.27.41,0,.57a1.1,1.1,0,0,1-1,0c-.27-.16-.27-.42,0-.57A1.1,1.1,0,0,1,66.91,95.46Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.51,94a.31.31,0,0,1,0,.58,1.08,1.08,0,0,1-1,0,.31.31,0,0,1,0-.58A1.08,1.08,0,0,1,69.51,94Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.09,97a.31.31,0,0,1,0,.58,1.17,1.17,0,0,1-1,0,.31.31,0,0,1,0-.58A1.1,1.1,0,0,1,59.09,97Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7,95.46c.27.15.27.41,0,.57a1.1,1.1,0,0,1-1,0c-.28-.16-.28-.42,0-.57A1.1,1.1,0,0,1,61.7,95.46Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3,94a.31.31,0,0,1,0,.58,1.08,1.08,0,0,1-1,0,.31.31,0,0,1,0-.58A1.08,1.08,0,0,1,64.3,94Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.91,92.45a.3.3,0,0,1,0,.57,1.1,1.1,0,0,1-1,0,.3.3,0,0,1,0-.57A1.1,1.1,0,0,1,66.91,92.45Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.51,90.94a.31.31,0,0,1,0,.58,1.08,1.08,0,0,1-1,0,.31.31,0,0,1,0-.58A1.08,1.08,0,0,1,69.51,90.94Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.48.29.5,28l48,27.71L96.46,28Zm48,27.7-48,27.71v55.4l48-27.7Zm-48,27.71L.5,28V83.4l48,27.7Z",
    style: {
      fill: "none",
      stroke: "#111",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  })), /*#__PURE__*/React.createElement("line", {
    x1: 96.46,
    y1: 28.26,
    x2: 246.46,
    y2: 114.86,
    style: {
      fill: "none",
      stroke: "#090d15",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48.77,
    y1: 55.7,
    x2: 198.77,
    y2: 142.3,
    style: {
      fill: "none",
      stroke: "#090d15",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48.81,
    y1: 110.8,
    x2: 198.81,
    y2: 197.4,
    style: {
      fill: "none",
      stroke: "#090d15",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 198.84,
    y1: 142.6,
    x2: 48.84,
    y2: 229.21,
    style: {
      fill: "none",
      stroke: "#090d15",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 246.53,
    y1: 170.04,
    x2: 96.53,
    y2: 256.65,
    style: {
      fill: "none",
      stroke: "#090d15",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 246.49,
    y1: 225.14,
    x2: 96.49,
    y2: 311.75,
    style: {
      fill: "none",
      stroke: "#090d15",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.87,
    y1: 256.3,
    x2: 0.64,
    y2: 83.09,
    style: {
      fill: "none",
      stroke: "#090d15",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48.51,
    y1: 283.83,
    x2: 48.28,
    y2: 110.61,
    style: {
      fill: "none",
      stroke: "#090d15",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96.17,
    y1: 256.18,
    x2: 95.95,
    y2: 82.96,
    style: {
      fill: "none",
      stroke: "#090d15",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormgroupTiangel);
export default __webpack_public_path__ + "static/media/formgroupTiangel.677ed799004e12fb4cc2f9fb8d0d4459.svg";
export { ForwardRef as ReactComponent };